import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import { CommonSecurity, Config, secureFetch } from '@dav/security-component-spa';
import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import 'whatwg-fetch';
import { Amplify } from '@aws-amplify/core';
import { API } from '@aws-amplify/api';
export { API } from '@aws-amplify/api';
import { required, minLength, sameAs, requiredIf } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import moment$1 from 'moment';
import moment$2 from 'moment-timezone';
import { CommonState as CommonState$1 } from '@primeit/components-vue';
import masker from 'vue-the-mask/src/masker';
import tokens from 'vue-the-mask/src/tokens';

//

var script$p = {
  name: 'AvatarUploader',
  tag: 'primeit-image-uploader',
  components: { VueCropper },
  props: {
    value: String,
    width: String,
    height: String,
    setCanvas: Object, // height/width/maxHeight/maxWidth
    banners: {
      required: false,
      default: false
    },
    mobile: {
      required: false,
      default: false
    }
  },
  data: () => ({
    cropImg: null,
    data: null,
    imgSource: null,
    fileType: null,
    crop_dialog: false,
    errorDialog: null,
    errorText: '',
    uploadFieldName: 'file',
    maxSize: 2048,
  }),
  computed: {},
  watch: {},
  mounted: function () {
    const that = this;
    const reader = new FileReader();
    reader.onloadend = function () {
      that.$emit('input', reader.result);
    };
  },
  methods: {
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas(this.setCanvas).toDataURL(this.fileType);
      this.$emit('input', this.cropImg);
      this.cancelCrop();
    },
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY);
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    cancelCrop() {
      this.$refs.cropper.reset();
      this.crop_dialog = false;
      this.cropImg = null;
    },
    getImage() {
      const that = this;
      if ((!that.value && !this.cropImg) || that.value === '') {
        return 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
      } else if (this.cropImg) {
        return this.cropImg;
      } else if (that.value && !this.cropImg) {
        return that.value;
      }
    },

    clearPicker() {
      const input = this.$refs.inputFileComponetRef;
      input.type = 'text';
      input.type = 'file';
      this.cropImg = null;

      if (this.banners) {
        this.$emit('input', '');
      }
      else {
        this.$emit('input', ' ');
      }
    },
    launchFilePicker() {
      this.$refs.inputFileComponetRef.click();
    },
    onFileChange(fieldName, file) {
      this.crop_dialog = true;
      const { maxSize } = this;
      const imageFile = file[0];

      if (file.length > 0) {
        const img = new Image();
        const p = new Promise((resolve, reject) => {
          img.src = window.URL.createObjectURL(imageFile);
          img.onload = () => {
            window.URL.revokeObjectURL(img.src);
            resolve();
          };
        });
        p.then((result) => {
          const size = imageFile.size / maxSize / maxSize;
          if (!imageFile.type.match('image.*')) {
            // check whether the upload is an image
            this.errorDialog = true;
            this.errorText = 'Por favor escolha um arquivo de imagem';
          } else if (size > 2) {
            // check whether the size is greater than the size limit
            this.errorDialog = true;
            this.errorText = 'Seu arquivo é muito grande! Por favor, escolha uma imagem de até 2MB.';
          } else if (img.naturalWidth > Number(this.maxWidth) || img.naturalHeight > Number(this.maxHeight)) {
            this.errorDialog = true;
            this.errorText = `A imagem ${img.naturalWidth}x${img.naturalHeight} tem é dimensão diferente da esperada: ${this.maxWidth}x${this.maxHeight}`;
          } else {
            const reader = new FileReader();
            reader.onloadend = (event) => {
              this.imgSource = reader.result;
              this.fileType = imageFile.type;
              this.$refs.cropper.replace(reader.result);
            };
            reader.readAsDataURL(imageFile);
          }
        });
      }
    },
  },
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$p = script$p;

/* template */
var __vue_render__$n = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _c("meta", {
        attrs: {
          "http-equiv": "Content-Type",
          content: "text/html; charset=UTF-8",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("v-input", [
            _c(
              "div",
              {
                staticClass: "cropped-image",
                on: {
                  click: function ($event) {
                    return _vm.launchFilePicker()
                  },
                },
              },
              [
                _c("v-img", {
                  attrs: {
                    width: _vm.width,
                    "aspect-ratio": _vm.width / _vm.height,
                    height: _vm.height,
                    "max-width":
                      _vm.$vuetify.breakpoint.smAndDown &&
                      Number(_vm.width) === 700
                        ? _vm.width / 3
                        : _vm.width,
                    "max-height":
                      _vm.$vuetify.breakpoint.smAndDown &&
                      Number(_vm.height) === 128 &&
                      Number(_vm.width) === 700
                        ? _vm.height / 3
                        : _vm.height,
                    src: _vm.getImage(),
                    alt: "",
                    eager: true,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _vm.value
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "ml-3",
                        attrs: {
                          outlined: "",
                          icon: "",
                          fab: "",
                          small: "",
                          color: "red",
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation();
                            return _vm.clearPicker()
                          },
                        },
                      },
                      [_c("v-icon", [_vm._v("delete")])],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("input", {
        ref: "inputFileComponetRef",
        staticStyle: { display: "none" },
        attrs: {
          id: this.$route.path.split("/")[1] + "__image",
          type: "file",
          accept: "image/*",
          name: _vm.uploadFieldName,
        },
        on: {
          change: function ($event) {
            return _vm.onFileChange($event.target.name, $event.target.files)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "300" },
          model: {
            value: _vm.errorDialog,
            callback: function ($$v) {
              _vm.errorDialog = $$v;
            },
            expression: "errorDialog",
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "v-card",
                [
                  _c("v-card-text", { staticClass: "subheading" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.errorText) + "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          on: {
                            click: function ($event) {
                              _vm.errorDialog = false;
                            },
                          },
                        },
                        [_vm._v(" Voltar ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          staticClass: "pa-3",
          attrs: { width: "75%", heigth: "75%" },
          model: {
            value: _vm.crop_dialog,
            callback: function ($$v) {
              _vm.crop_dialog = $$v;
            },
            expression: "crop_dialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "pb-2" },
            [
              _c(
                "v-card-title",
                {
                  staticClass: "headline grey lighten-2",
                  attrs: { "primary-title": "" },
                },
                [_c("span", [_vm._v(" Envie sua imagem ")])]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "content text-center" }, [
                _c("section", { staticClass: "cropper-area" }, [
                  _c(
                    "div",
                    { staticClass: "img-cropper" },
                    [
                      _c("vue-cropper", {
                        ref: "cropper",
                        staticStyle: { "max-height": "450px" },
                        attrs: {
                          src: _vm.imgSource,
                          "aspect-ratio": _vm.width / _vm.height,
                          preview: ".preview",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.mobile
                    ? _c(
                        "div",
                        { staticClass: "actions" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-1",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault();
                                  return _vm.rotate(-90)
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { large: "" } }, [
                                _vm._v(" rotate_left "),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-1",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault();
                                  return _vm.rotate(90)
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { large: "" } }, [
                                _vm._v(" rotate_right "),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "error mr-1",
                              on: {
                                click: function ($event) {
                                  return _vm.cancelCrop()
                                },
                              },
                            },
                            [_vm._v(" Cancelar ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "blue",
                              attrs: { dark: "" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault();
                                  return _vm.cropImage()
                                },
                              },
                            },
                            [_vm._v(" Aplicar ")]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "actions" },
                        [
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "mr-1",
                                      staticStyle: { width: "100%" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault();
                                          return _vm.rotate(-90)
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", { attrs: { large: "" } }, [
                                        _vm._v(" rotate_left "),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "mr-1",
                                      staticStyle: { width: "100%" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault();
                                          return _vm.rotate(90)
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", { attrs: { large: "" } }, [
                                        _vm._v(" rotate_right "),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "blue",
                                      staticStyle: { width: "100%" },
                                      attrs: { dark: "" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault();
                                          return _vm.cropImage()
                                        },
                                      },
                                    },
                                    [_vm._v(" Aplicar ")]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "error mr-1",
                                      staticStyle: { width: "100%" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.cancelCrop()
                                        },
                                      },
                                    },
                                    [_vm._v(" Cancelar ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
};
var __vue_staticRenderFns__$n = [];
__vue_render__$n._withStripped = true;

  /* style */
  const __vue_inject_styles__$p = function (inject) {
    if (!inject) return
    inject("data-v-27505295_0", { source: "\n.content[data-v-27505295] {\n  display: flex;\n  justify-content: space-between;\n}\n.cropper-area[data-v-27505295] {\n  max-width: 75%;\n  max-height: 75%;\n  margin: auto;\n}\n.actions[data-v-27505295] {\n  margin-top: 1rem;\n}\n", map: {"version":3,"sources":["/home/daniel/Projects/dav/frontend/dav-frontend-components-vue/src/components/AvatarUploader/AvatarUploader.vue"],"names":[],"mappings":";AA2OA;EACA,aAAA;EACA,8BAAA;AACA;AACA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AACA;AACA;EACA,gBAAA;AACA","file":"AvatarUploader.vue","sourcesContent":["<template>\n  <div>\n    <!-- slot for parent component to activate the file changer -->\n    <meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\" />\n    <div>\n      <!-- Null -->\n      <v-input>\n        <div class=\"cropped-image\" @click=\"launchFilePicker()\">\n          <v-img\n            :width=\"width\"\n            :aspect-ratio=\"width / height\"\n            :height=\"height\"\n            :max-width=\"$vuetify.breakpoint.smAndDown && Number(width) === 700 ? width / 3 : width\"\n            :max-height=\"\n              $vuetify.breakpoint.smAndDown && Number(height) === 128 && Number(width) === 700 ? height / 3 : height\n            \"\n            :src=\"getImage()\"\n            alt=\"\"\n            :eager=\"true\"\n          />\n        </div>\n        <div>\n          <v-btn v-if=\"value\" outlined class=\"ml-3\" icon fab small color=\"red\" @click.stop=\"clearPicker()\">\n            <v-icon>delete</v-icon>\n          </v-btn>\n        </div>\n      </v-input>\n    </div>\n    <input\n      :id=\"`${this.$route.path.split('/')[1]}__image`\"\n      ref=\"inputFileComponetRef\"\n      type=\"file\"\n      accept=\"image/*\"\n      :name=\"uploadFieldName\"\n      style=\"display: none\"\n      @change=\"onFileChange($event.target.name, $event.target.files)\"\n    />\n    <v-dialog v-model=\"errorDialog\" max-width=\"300\">\n      <div>\n        <v-card>\n          <v-card-text class=\"subheading\">\n            {{ errorText }}\n          </v-card-text>\n          <v-card-actions>\n            <v-spacer />\n            <v-btn @click=\"errorDialog = false\"> Voltar </v-btn>\n          </v-card-actions>\n        </v-card>\n      </div>\n    </v-dialog>\n    <v-dialog v-model=\"crop_dialog\" class=\"pa-3\" width=\"75%\" heigth=\"75%\">\n      <v-card class=\"pb-2\">\n        <v-card-title class=\"headline grey lighten-2\" primary-title>\n          <span> Envie sua imagem </span>\n        </v-card-title>\n\n        <div class=\"content text-center\">\n          <section class=\"cropper-area\">\n            <div class=\"img-cropper\">\n              <vue-cropper\n                ref=\"cropper\"\n                :src=\"imgSource\"\n                :aspect-ratio=\"width / height\"\n                style=\"max-height: 450px\"\n                preview=\".preview\"\n              />\n            </div>\n            <div class=\"actions\" v-if=\"!mobile\">\n              <v-btn class=\"mr-1\" @click.prevent=\"rotate(-90)\">\n                <v-icon large> rotate_left </v-icon>\n              </v-btn>\n              <v-btn class=\"mr-1\" @click.prevent=\"rotate(90)\">\n                <v-icon large> rotate_right </v-icon>\n              </v-btn>\n              <v-btn class=\"error mr-1\" @click=\"cancelCrop()\"> Cancelar </v-btn>\n              <v-btn class=\"blue\" dark @click.prevent=\"cropImage()\"> Aplicar </v-btn>\n            </div>\n            <div class=\"actions\" v-else>\n              <v-row dense>\n                <v-col cols=\"12\">\n                  <v-btn class=\"mr-1\" style=\"width: 100%;\" @click.prevent=\"rotate(-90)\">\n                    <v-icon large> rotate_left </v-icon>\n                  </v-btn>\n                </v-col>\n                <v-col cols=\"12\">\n                  <v-btn class=\"mr-1\" style=\"width: 100%;\" @click.prevent=\"rotate(90)\">\n                  <v-icon large> rotate_right </v-icon>\n                </v-btn>\n                </v-col>\n                <v-col cols=\"12\">\n                  <v-btn class=\"blue\" style=\"width: 100%;\" dark @click.prevent=\"cropImage()\"> Aplicar </v-btn>\n                </v-col>\n                <v-col cols=\"12\">\n                  <v-btn class=\"error mr-1\" style=\"width: 100%;\" @click=\"cancelCrop()\"> Cancelar </v-btn>\n                </v-col>\n              </v-row>\n            </div>\n          </section>\n        </div>\n      </v-card>\n    </v-dialog>\n  </div>\n</template>\n\n<script>\nimport VueCropper from 'vue-cropperjs';\nimport 'cropperjs/dist/cropper.css';\n\nexport default {\n  name: 'AvatarUploader',\n  tag: 'primeit-image-uploader',\n  components: { VueCropper },\n  props: {\n    value: String,\n    width: String,\n    height: String,\n    setCanvas: Object, // height/width/maxHeight/maxWidth\n    banners: {\n      required: false,\n      default: false\n    },\n    mobile: {\n      required: false,\n      default: false\n    }\n  },\n  data: () => ({\n    cropImg: null,\n    data: null,\n    imgSource: null,\n    fileType: null,\n    crop_dialog: false,\n    errorDialog: null,\n    errorText: '',\n    uploadFieldName: 'file',\n    maxSize: 2048,\n  }),\n  computed: {},\n  watch: {},\n  mounted: function () {\n    const that = this;\n    const reader = new FileReader();\n    reader.onloadend = function () {\n      that.$emit('input', reader.result);\n    };\n  },\n  methods: {\n    cropImage() {\n      // get image data for post processing, e.g. upload or setting image src\n      this.cropImg = this.$refs.cropper.getCroppedCanvas(this.setCanvas).toDataURL(this.fileType);\n      this.$emit('input', this.cropImg);\n      this.cancelCrop();\n    },\n    move(offsetX, offsetY) {\n      this.$refs.cropper.move(offsetX, offsetY);\n    },\n    rotate(deg) {\n      this.$refs.cropper.rotate(deg);\n    },\n    cancelCrop() {\n      this.$refs.cropper.reset();\n      this.crop_dialog = false;\n      this.cropImg = null;\n    },\n    getImage() {\n      const that = this;\n      if ((!that.value && !this.cropImg) || that.value === '') {\n        return 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';\n      } else if (this.cropImg) {\n        return this.cropImg;\n      } else if (that.value && !this.cropImg) {\n        return that.value;\n      }\n    },\n\n    clearPicker() {\n      const input = this.$refs.inputFileComponetRef;\n      input.type = 'text';\n      input.type = 'file';\n      this.cropImg = null;\n\n      if (this.banners) {\n        this.$emit('input', '');\n      }\n      else {\n        this.$emit('input', ' ');\n      }\n    },\n    launchFilePicker() {\n      this.$refs.inputFileComponetRef.click();\n    },\n    onFileChange(fieldName, file) {\n      this.crop_dialog = true;\n      const { maxSize } = this;\n      const imageFile = file[0];\n\n      if (file.length > 0) {\n        const img = new Image();\n        const p = new Promise((resolve, reject) => {\n          img.src = window.URL.createObjectURL(imageFile);\n          img.onload = () => {\n            window.URL.revokeObjectURL(img.src);\n            resolve();\n          };\n        });\n        p.then((result) => {\n          const size = imageFile.size / maxSize / maxSize;\n          if (!imageFile.type.match('image.*')) {\n            // check whether the upload is an image\n            this.errorDialog = true;\n            this.errorText = 'Por favor escolha um arquivo de imagem';\n          } else if (size > 2) {\n            // check whether the size is greater than the size limit\n            this.errorDialog = true;\n            this.errorText = 'Seu arquivo é muito grande! Por favor, escolha uma imagem de até 2MB.';\n          } else if (img.naturalWidth > Number(this.maxWidth) || img.naturalHeight > Number(this.maxHeight)) {\n            this.errorDialog = true;\n            this.errorText = `A imagem ${img.naturalWidth}x${img.naturalHeight} tem é dimensão diferente da esperada: ${this.maxWidth}x${this.maxHeight}`;\n          } else {\n            const reader = new FileReader();\n            reader.onloadend = (event) => {\n              this.imgSource = reader.result;\n              this.fileType = imageFile.type;\n              this.$refs.cropper.replace(reader.result);\n            };\n            reader.readAsDataURL(imageFile);\n          }\n        });\n      }\n    },\n  },\n};\n</script>\n\n<style scoped>\n.content {\n  display: flex;\n  justify-content: space-between;\n}\n.cropper-area {\n  max-width: 75%;\n  max-height: 75%;\n  margin: auto;\n}\n.actions {\n  margin-top: 1rem;\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$p = "data-v-27505295";
  /* module identifier */
  const __vue_module_identifier__$p = undefined;
  /* functional template */
  const __vue_is_functional_template__$p = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$p = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$n, staticRenderFns: __vue_staticRenderFns__$n },
    __vue_inject_styles__$p,
    __vue_script__$p,
    __vue_scope_id__$p,
    __vue_is_functional_template__$p,
    __vue_module_identifier__$p,
    false,
    createInjector,
    undefined,
    undefined
  );

const AvatarUploader = __vue_component__$p;

// const DEFAULT_WARNING = 'Sr. desenvolvedor, por favor instancie diretamente CommonSecurity de @dav/security-component-spa. Obrigado';

const OldCommonSecurity = CommonSecurity;

Vue.use(Vuex);

const CommonState = new Vuex.Store({
strict: process.env.NODE_ENV !== 'production',
});

Object.getPrototypeOf(CommonState).getItem = (key, defaultValue = null) => {
    return JSON.parse(CommonSecurity.getWindowStorage().getItem(key) || defaultValue);
};

Object.getPrototypeOf(CommonState).setItem = (key, value) => {
  CommonSecurity.getWindowStorage().setItem(key, JSON.stringify(value));
  return value;
};

const CommonRouter = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  routes: [],
});

/**
 * This avoid to do redudant navigation
 * @param to
 * @param from
 * @param next
 */
const cleanRoute = (to, from, next) => {
  if (to.path === '/' || (to.path && from.path !== to.path) || (to.name && from.name !== to.name)) next();
};

const testRoute = (to, from, next, user) => {
  if (from.path.startsWith('/profile/person/edit')) {
    return cleanRoute(to, from, next);
  }

  if (to.path === '/login' || user) {
    if (testDirty(from)) cleanRoute(to, from, next);
  } else if (to.meta.front === 'consultorio') {
    cleanRoute(to, from, next);
  } else {
    next({ path: '/login', replace: true });
  }
};

const testDirty = (from) => {
  let ok = true;
  const anyDirty = from.meta.$v ? from.meta.$v.$anyDirty : false;

  if (anyDirty || from.meta.dirt) {
    ok = confirm('Há informações sem salvar nesta página. Ter certeza que quer sair?');
  }

  return ok;
};

CommonRouter.beforeEach((to, from, next) => {
  if (!CommonState.getters['credential/SETUP']) {
    CommonState.dispatch('credential/SETUP');
  }

  let goNext = () => {
    /// TODO CONTORNO COLOCADO POR CONTA DA TAWK.TO. ENTRAR EM CONTATO COM O SUPORTE DELES.
    console.info('REVISAR :: Navegacao Origem Não-DaV');
  };

  // if (VueRouter.isHacked) {
  //   if (to?.origin === 'dav' || [CommonRouter.history._startLocation, '/login', '/'].includes(to.path)) {
  //     goNext = next;
  //   }
  // } else {
  goNext = next;
  // }

  OldCommonSecurity.getUser().then((user) => {
    if (to.meta.secure) {
      if (user) CommonState.dispatch('credential/GET_PERMISSIONS', { id: user.getAttribute('cognito:username') });
      testRoute(to, from, goNext, user);
    } else {
      if (testDirty(from)) cleanRoute(to, from, goNext);
    }
  });
});

const ordemNumerica = (a, b) => {
  if (a.order > b.order) {
    return 1;
  }
  if (a.order < b.order) {
    return -1;
  }
  // a must be equal to b
  return 0;
};

const registeredRoutes = [];

Object.defineProperty(CommonRouter, 'registeredRoutes', {
  get: () => {
    registeredRoutes.sort(ordemNumerica);
    return registeredRoutes;
  },
});

Object.getPrototypeOf(CommonRouter).registerRoutes = (routes) => {
  routes.forEach((route) => {
    CommonRouter.addRoute(route);
    const finalRoute = route.meta;
    finalRoute.path = route.path;
    registeredRoutes.push(finalRoute);
  });
};

Object.defineProperty(CommonRouter, 'dirt', {
  value: {
    attach: (vm) => {
      if (vm.$v) {
        vm.$route.meta.$v = vm.$v;
      }
      vm.$route.meta.dirt = false;
    },
    clear: (vm) => {
      vm.$route.meta.dirt = false;
    },
    release: (vm) => {
      if (vm.$route.meta.$v) {
        vm.$route.meta.$v.$reset();
        delete vm.$route.meta.$v;
      }
      delete vm.$route.meta.dirt;
    },
    set: (vm) => {
      vm.$route.meta.dirt = true;
    },
  },
  writable: false,
});

Vue.use(CommonRouter);

const getCurrentLanguage = () => {
  const lang = navigator.language || navigator.userLanguage;

  let current;

  switch (lang) {
    case 'en':
    case 'en-US':
      current = 'en-US';
      break;

    case 'pt':
    case 'pt-BR':
    default:
      current = 'pt-BR';
      break;
  }

  return current;
};

const Fetcher = async (input, init) => {
  const user = await OldCommonSecurity.getUser();

  if (user) {
    if (!init) init = { method: 'GET' };

    let headers = new Headers();

    if ('headers' in init) {
      if (init.headers instanceof Headers) {
        headers = init.headers;
      } else {
        Object.entries(init.headers).forEach(([key, value]) => {
          headers.append(key, value);
        });
      }
    }

    headers.append('Authorization', user.getToken().id);
    headers.append('x-api-key', user.getToken().access);

    // i18n
    headers.append('Accept-Language', getCurrentLanguage());

    // Usar linha de baixo para derrubar quem esta logado
    // headers.append('Authorization', user['signInUserSession']['idToken']['payload']['exp'] = 1569856817);

    init.headers = headers;

    const request = window.fetch(encodeURI(input), init);

    return new Promise((resolve, reject) => {
      request.then(response => {
        if (response.status === 401 || response.status === 403) {
          response.json().then(data => {
            if (data.code && data.code === 422) {
              global.vueInstance.$root.$emit('show-snackbar', { btnClose: true, color: 'error', text: data.message });
              global.vueInstance.$router.push({ path: '/' });
            } else {
              global.vueInstance.$root.$emit('show-dialog');
            }
          });
        }
        resolve(response);
      }).catch(err => {
        reject(err);
      });
    });
  } else {
    CommonState.dispatch('credential/LOGOUT');
  }
};

Amplify.configure({
  Auth: {
    identityPoolId: process.env.VUE_APP_COGNITO_AUTH_IDENTITY_POOL_ID,
    region: process.env.VUE_APP_COGNITO_AUTH_REGION,
  },
  API: {
    endpoints: [
      {
        endpoint: `${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_USER}`,
        name: 'UserAPI',
        region: process.env.VUE_APP_COGNITO_AUTH_REGION,
      },
      {
        endpoint: `${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_SESSION}`,
        name: 'SessionAPI',
        region: process.env.VUE_APP_COGNITO_AUTH_REGION,
      },
      // TODO: rever se externalAppointementApi ira continuar
      {
        endpoint: `${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_EXTERNAL_APPOINTMENT}`,
        name: 'ExternalAppointmentAPI',
        region: process.env.VUE_APP_COGNITO_AUTH_REGION,
      },
      {
        endpoint: `${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_COMPANY}`,
        name: 'CompanyAPI',
        region: process.env.VUE_APP_COGNITO_AUTH_REGION,
      },
      {
        endpoint: `${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_TRANSLATION}`,
        name: 'TranslationAPI',
        region: process.env.VUE_APP_COGNITO_AUTH_REGION,
      },
      {
        endpoint: `${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_APPOINTMENT}`,
        name: 'AppointmentAPI',
        region: process.env.VUE_APP_COGNITO_AUTH_REGION,
      },
      {
        endpoint: `${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_PERSON}`,
        name: 'PersonAPI',
        region: process.env.VUE_APP_COGNITO_AUTH_REGION,
      },
      {
        endpoint: `${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_FINANCIAL}`,
        name: 'FinancialAPI',
        region: process.env.VUE_APP_COGNITO_AUTH_REGION,
      },
      {
        endpoint: `${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_ROOM}`,
        name: 'RoomAPI',
        region: process.env.VUE_APP_COGNITO_AUTH_REGION,
      },
    ],
  },
});

const getLanguage = () => {
  const lang = navigator.language || navigator.userLanguage;

  let current;

  switch (lang) {
    case 'en':
    case 'en-US':
      current = 'en-US';
      break;

    case 'pt':
    case 'pt-BR':
    default:
      current = 'pt-BR';
      break;
  }
  return current;
};

const challenges = {
  NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED',
};

const state = {
  changePassword: null,
  checkEmail: null,
  checkPassword: null,
  /// TODO Mantido apenar por compatibilidade, será removido no futuro
  currentUser: CommonState.getItem('current_user'),
  forgot: null,
  logged: CommonState.getItem('logged'),
  setup: CommonState.getItem('setup'),
  term_ready: false,
  term_user: [],
  translation: null,
  username: null,
  userPermissions: [],
};

const module$1 = {
  actions: {
    CHANGE_PASSWORD(context, params) {
      CommonSecurity.changePassword(params.newPassword)
        .then((_user) => {
          context.commit('POPULATE_CHANGE_PASSWORD', {
            result: 'OK',
            ts: Date.now(),
          });
        })
        .catch((e) => {
          context.commit('POPULATE_CHANGE_PASSWORD', {
            message: e.message,
            result: 'ERROR',
            ts: Date.now(),
          });
        });
    },
    CHECK_EMAIL(context, params) {
      CommonSecurity.check(params.email)
        .then((response) => {
          switch (response.event) {
            case 'ASK_FOR_PASSWORD':
              context.commit('POPULATE_CHECK_EMAIL', {
                result: true,
                ts: Date.now(),
              });
              break;

            case 'AUTHENTICATION_FAILURE':
              context.commit('POPULATE_CHECK_EMAIL', {
                message:
                  response.reason.i18n === 'dav.backend.credential.user.not.found'
                    ? ['Usuário inexistente.']
                    : ['Acesso negado, entre em contato com o administrador.'],
                result: false,
                ts: Date.now(),
              });
              break;
            default:
              context.commit('POPULATE_CHECK_EMAIL', {
                result: false,
                ts: Date.now(),
              });
              break;
          }
        })
        .catch((err) => {
          context.commit('POPULATE_CHECK_EMAIL', {
            message: [`Acesso negado (${err})`],
            result: false,
            ts: Date.now(),
          });
        });
    },
    CHECK_PASSWORD(context, params) {
      CommonSecurity.signIn(params.password).then((response) => {
        switch (response.event) {
          case 'ASK_FOR_NEW_PASSWORD':
            context.commit('POPULATE_CHECK_PASSWORD', {
              result: challenges.NEW_PASSWORD_REQUIRED,
              ts: Date.now(),
            });
            break;

          case 'AUTHENTICATION_FINISH':
            context.commit('POPULATE_CHECK_PASSWORD', {
              result: 'OK',
              ts: Date.now(),
            });
            break;

          case 'AUTHENTICATION_FAILURE':
          default:
            context.commit('POPULATE_CHECK_PASSWORD', {
              message: response.reason.message,
              result: 'ERROR',
              ts: Date.now(),
            });
            break;
        }
      });
    },

    /**
     * @deprecated Mantido apenar por compatibilidade, será removido no futuro
     *
     * @param context
     * @param params
     * @constructor
     */
    CURRENT_USER: (context, params) => {
      context.commit('POPULATE_CURRENT_USER', params.user);
    },

    FETCH_FORGOT: (context, params) => {
      fetch('/', { method: 'HEAD' }).then((response) => {
        const companyId = response.headers.get('x-domain-dav-company-id');

        const apiName = 'UserAPI';
        const path = '/forgot';
        const myInit = {
          queryStringParameters: {
            companyId: companyId,
            email: params,
          },
          response: true,
        };

        API.get(apiName, path, myInit)
          .then((payload) => {
            if (payload.status === 200) {
              context.commit('POPULATE_FORGOT', { send: true, ts: Date.now() });
            } else {
              context.commit('POPULATE_FORGOT', { send: false, ts: Date.now() });
            }
          })
          .catch((error) => {
            context.commit('POPULATE_FORGOT', { send: false, ts: Date.now() });
            console.log(error);
          });
      });
    },

    FETCH_TERM_USER: (context, _params) => {
      CommonSecurity.getUser().then((user) => {
        if (user) {
          const init = { method: 'GET' };
          const headers = new Headers();

          headers.append('Authorization', user.getToken().id);
          headers.append('x-api-key', user.getToken().access);

          init.headers = headers;

          const request = window.fetch(encodeURI(`${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_USER}/term`), init);

          return new Promise((resolve, reject) => {
            request
              .then((response) => {
                response.json().then((data) => {
                  context.commit('POPULATE_TERM_USER', data);
                  resolve(data);
                });
              })
              .catch((err) => {
                reject(err);
              });
          });
        } else {
          CommonState.dispatch('credential/LOGOUT');
        }
      });
    },

    FETCH_TERM_USER_ACCEPT: (context, params) => {
      CommonSecurity.getUser().then((user) => {
        if (user) {
          const init = { body: JSON.stringify(params), method: 'POST' };
          const headers = new Headers();

          headers.append('Authorization', user.getToken().id);
          headers.append('x-api-key', user.getToken().access);
          headers.append('Accept', 'application/json, text/plain, */*');
          headers.append('Content-Type', 'application/json');

          init.headers = headers;

          const request = window.fetch(encodeURI(`${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_USER}/term`), init);

          return new Promise((resolve, reject) => {
            request
              .then((response) => {
                response.json().then((data) => {
                  context.commit('POPULATE_TERM_READY', true);
                  context.commit('POPULATE_TERM_USER', []);
                  resolve(data);
                });
              })
              .catch((err) => {
                reject(err);
              });
          });
        }
      });
    },

    GET_PERMISSIONS: async (context, params) => {
      const response = await Fetcher(
        `${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_USER}/userpermissions?id=${params.id}`
      );
      try {
        if (response) {
          const res = await response.json();
          context.commit('POPULATE_PERMISSIONS', res);
        }
      } catch (e) {
        context.commit('POPULATE_PERMISSIONS', null);
      }
    },

    LOGOUT(context, _params) {
      CommonSecurity.signOut()
        .then((_) => {
          context.commit('POPULATE_CURRENT_USER', null);
        })
        .catch((err) => console.log(err));
      CommonRouter.push('/login');
    },

    NOT_ACCEPT_TERM(context, _params) {
      CommonSecurity.signOut()
        .then((_) => {
          context.commit('POPULATE_CURRENT_USER', null);
        })
        .catch((err) => console.log(err));
    },

    SETUP(context, _params) {
      new Promise((resolve, reject) => {
        fetch('/', { method: 'HEAD' })
          .then(function (response) {
            const companyId = response.headers.get('x-domain-dav-company-id');
            resolve(companyId || 'ffffffff-ffff-ffff-ffff-ffffffffffff');
            // eslint-disable-next-line prefer-promise-reject-errors
          })
          .catch(() => reject('ffffffff-ffff-ffff-ffff-ffffffffffff'));
      }).then((companyId) => {
        const apiName = 'CompanyAPI';
        const path = '/setup';
        const myInit = {
          headers: {
            'x-domain-dav-company-id': companyId,
          },
          response: true,
        };
        API.get(apiName, path, myInit)
          .then((payload) => {
            if (payload.status === 200) {
              context.commit('POPULATE_SETUP', {
                alpha_company: payload.data.alpha_company,
                background_login_clinica: payload.data.background_login_clinica
                  ? `${process.env.VUE_APP_MEDIA_SERVER_BASE}/${payload.data.background_login_clinica}`
                  : null,
                background_login_consultorio: payload.data.background_login_consultorio
                  ? `${process.env.VUE_APP_MEDIA_SERVER_BASE}/${payload.data.background_login_consultorio}`
                  : null,
                companyId: payload.data.companyId,
                contact: payload.data.contact,
                landing: payload.data.landing,
                name: payload.data.name,
                parent_id: payload.data.parent_id,
                picture: `${process.env.VUE_APP_MEDIA_SERVER_BASE}/${payload.data.picture}`,
                picture_mini: `${process.env.VUE_APP_MEDIA_SERVER_BASE}/${payload.data.picture_mini}`,
                provider: payload.data.provider,
                settings: payload.data.settings,
                theme: payload.data.theme ? payload.data.theme : null,
                timezone: payload.data.timezone,
                ts: Date.now(),
                url_domain: payload.data.url_domain,
                url_domain_atendimento: payload.data.url_domain_atendimento || undefined,
                url_domain_consultorio: payload.data.url_domain_consultorio || undefined,
              });

              CommonState.dispatch('credential/TRANSLATION', { company_id: payload.data.companyId });
            } else {
              context.commit('POPULATE_SETUP', { ts: Date.now() });
            }
          })
          .catch((error) => {
            console.log(error.response);
          });
      });
    },

    TRANSLATION: (context) => {
      Config.getInstance().then((config) => {
        secureFetch(`${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_TRANSLATION}/frontend`, {
          headers: {
            'Accept-Language': getLanguage(),
            'x-company-id': config.get('dav-company-id'),
            'x-dav-config-saas-behalf-of': config.get('dav-saas-behalf-of'),
          },
        })
          .then((response) => {
            if (response.ok) response.json().then((json) => context.commit('POPULATE_TRANSLATION', json));
          })
          .catch((error) => {
            console.log(error.response);
          });
      });
    },
  },
  getters: {
    CHANGE_PASSWORD: (state) => state.changePassword,
    CHECK_EMAIL: (state) => state.checkEmail,
    CHECK_PASSWORD: (state) => state.checkPassword,
    CURRENT_USER: (state) => state.currentUser,
    GET_FORGOT: (state) => state.forgot,
    GET_PERMISSIONS: (state) => state.userPermissions,
    GET_TRANSLATION: (state) => state.translation,
    SETUP: (state) => state.setup,
    TERM_READY: (state) => state.term_ready,
    TERM_USER: (state) => state.term_user,
  },
  mutations: {
    POPULATE_CHANGE_PASSWORD(state, payload) {
      state.changePassword = payload;
    },
    POPULATE_CHECK_EMAIL(state, payload) {
      state.checkEmail = payload;
    },
    POPULATE_CHECK_PASSWORD(state, payload) {
      state.checkPassword = payload;
    },
    /**
     * Mantido apenar por compatibilidade, será removido no futuro
     *
     * @param context
     * @param params
     * @constructor
     * @deprecated
     */
    POPULATE_CURRENT_USER(state, payload) {
      state.currentUser = CommonState.setItem('current_user', payload);
    },

    POPULATE_FORGOT(state, payload) {
      state.forgot = payload;
    },
    POPULATE_PERMISSIONS(state, payload) {
      state.userPermissions = payload;
    },
    POPULATE_SETUP(state, payload) {
      state.setup = payload;
    },
    POPULATE_TERM_READY: (state, payload) => {
      state.term_ready = payload;
    },
    POPULATE_TERM_USER: (state, payload) => {
      if (payload.length > 0) {
        state.term_user.push(...payload);
      } else {
        state.term_user = payload;
      }
    },
    POPULATE_TRANSLATION(state, payload) {
      state.translation = payload;
    },
    POPULATE_USERNAME(state, payload) {
      state.username = payload;
    },
  },
  namespaced: true,
  state,
};

CommonState.registerModule('credential', module$1);

/// TODO quando revisar toda a segurança, isso não será necessário
const legacyUpdateCurrentUser = async (event) =>
  CommonState.dispatch('credential/CURRENT_USER', { user: event.currentUser || event.user.currentUser });

CommonSecurity.eventListener.add(CommonSecurity.events.EVENT_TOKEN_REFRESH, legacyUpdateCurrentUser);
CommonSecurity.eventListener.add(CommonSecurity.events.EVENT_TOKEN_RESTORE, legacyUpdateCurrentUser);
CommonSecurity.eventListener.add(CommonSecurity.events.EVENT_SIGN_IN, legacyUpdateCurrentUser);
CommonSecurity.eventListener.add(CommonSecurity.events.EVENT_SIGN_OUT, async () =>
  CommonState.dispatch('credential/CURRENT_USER', { user: null })
);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$o = {
  tag: 'dav-accept-term',
  props: {
    termUse: {
      type: Array,
    },
    customUrlAccept: Boolean,
    actionTitle: {
      type: String,
    },
    cancelOption: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      readConfirmAcceptTerm: [],
      setTermLoading: false,
    };
  },
  computed: {
    setup() {
      return this.$store.getters['credential/SETUP'];
    },
    resultTerm() {
      return this.termUse || this.$store.getters['credential/TERM_USER'];
    },
  },
  mounted() {
    this.readConfirmAcceptTerm = this.resultTerm.map((opt) => opt === '');
  },
  beforeDestroy() {
    this.setTermLoading = false;
  },
  methods: {
    setAccept() {
      if (this.readConfirmAcceptTerm.every((opt) => opt === true)) {
        this.setTermLoading = true;
        const params = {
          term: this.resultTerm,
        };

        if (this.location) params.location = this.location;

        if (this.customUrlAccept) {
          this.$root.$emit('fetchTermAccept');
          this.setTermLoading = false;
        } else {
          this.$store.dispatch('credential/FETCH_TERM_USER_ACCEPT', params);
        }
      }
    },
    getUrlFilePath(filePath) {
      if (filePath && !filePath.includes(process.env.VUE_APP_MEDIA_SERVER_BASE)) {
        return `${process.env.VUE_APP_MEDIA_SERVER_BASE}/${filePath}`;
      }
      return filePath;
    },
    reset() {
      this.readConfirmAcceptTerm = [];
    },
  },
};

/* script */
const __vue_script__$o = script$o;

/* template */
var __vue_render__$m = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.resultTerm && _vm.resultTerm.length > 0
    ? _c(
        "v-card",
        { class: _vm.isMobile ? "card-mobile" : "" },
        [
          _c("v-card-title", [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$vuetify.lang.t("$vuetify.label.term_of_use_accept")
                ) +
                "\n  "
            ),
          ]),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c("div", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$vuetify.lang.t(
                      "$vuetify.label.text_term_use_login",
                      _vm.setup.name
                    )
                  ),
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.resultTerm, function (opt, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "mt-4" },
                  [
                    _c("v-checkbox", {
                      class: _vm.isMobile ? "" : "pl-4",
                      attrs: { color: "primary" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$vuetify.lang.t(
                                        "$vuetify.label.term_use_agree_with"
                                      )
                                    ) + "\n            "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        target: "_blank",
                                        href: _vm.getUrlFilePath(opt.path_file),
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation();
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(opt.description) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: _vm.readConfirmAcceptTerm[index],
                        callback: function ($$v) {
                          _vm.$set(_vm.readConfirmAcceptTerm, index, $$v);
                        },
                        expression: "readConfirmAcceptTerm[index]",
                      },
                    }),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { class: _vm.isMobile ? "justify-end" : "" },
            [
              _vm.cancelOption
                ? _c(
                    "v-btn",
                    {
                      class: _vm.isMobile ? "btn-mobile no-border" : "",
                      attrs: { outlined: _vm.isMobile, large: _vm.isMobile },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("cancel")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.btn.cancel")) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isMobile ? _c("v-spacer") : _vm._e(),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  class: _vm.isMobile ? "btn-mobile" : "",
                  attrs: {
                    id: "login_buttom_term_accept",
                    disabled: _vm.readConfirmAcceptTerm.some(function (opt) {
                      return opt === false
                    }),
                    loading: _vm.loading || _vm.setTermLoading,
                    color: "primary",
                    large: _vm.isMobile,
                  },
                  on: { click: _vm.setAccept },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.actionTitle ||
                          _vm.$vuetify.lang.t("$vuetify.btn.accept")
                      ) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
};
var __vue_staticRenderFns__$m = [];
__vue_render__$m._withStripped = true;

  /* style */
  const __vue_inject_styles__$o = function (inject) {
    if (!inject) return
    inject("data-v-24af8ede_0", { source: "\n.card-mobile[data-v-24af8ede] {\n  box-shadow: none !important;\n}\n.btn-mobile[data-v-24af8ede] {\n  text-transform: unset;\n  border-radius: 8px;\n}\n.no-border[data-v-24af8ede] {\n  border: none !important;\n}\n", map: {"version":3,"sources":["/home/daniel/Projects/dav/frontend/dav-frontend-components-vue/src/components/AcceptTerm/AcceptTerm.vue"],"names":[],"mappings":";AAuHA;EACA,2BAAA;AACA;AAEA;EACA,qBAAA;EACA,kBAAA;AACA;AAEA;EACA,uBAAA;AACA","file":"AcceptTerm.vue","sourcesContent":["<template>\n  <v-card v-if=\"resultTerm && resultTerm.length > 0\" :class=\"isMobile ? 'card-mobile' : ''\">\n    <v-card-title>\n      {{ $vuetify.lang.t('$vuetify.label.term_of_use_accept') }}\n    </v-card-title>\n    <v-card-text>\n      <div v-html=\"$vuetify.lang.t('$vuetify.label.text_term_use_login', setup.name)\" />\n      <div v-for=\"(opt, index) in resultTerm\" :key=\"index\" class=\"mt-4\">\n        <v-checkbox v-model=\"readConfirmAcceptTerm[index]\" :class=\"isMobile ? '' : 'pl-4'\" color=\"primary\">\n          <template #label>\n            <span\n              >{{ $vuetify.lang.t('$vuetify.label.term_use_agree_with') }}\n              <a target=\"_blank\" :href=\"getUrlFilePath(opt.path_file)\" @click.stop>\n                {{ opt.description }}\n              </a>\n            </span>\n          </template>\n        </v-checkbox>\n      </div>\n    </v-card-text>\n\n    <v-card-actions :class=\"isMobile ? 'justify-end' : ''\">\n      <v-btn\n        v-if=\"cancelOption\"\n        :outlined=\"isMobile\"\n        :large=\"isMobile\"\n        :class=\"isMobile ? 'btn-mobile no-border' : ''\"\n        @click=\"$emit('cancel')\"\n      >\n        {{ $vuetify.lang.t('$vuetify.btn.cancel') }}\n      </v-btn>\n      <v-spacer v-if=\"!isMobile\" />\n      <v-btn\n        id=\"login_buttom_term_accept\"\n        :disabled=\"readConfirmAcceptTerm.some((opt) => opt === false)\"\n        :loading=\"loading || setTermLoading\"\n        color=\"primary\"\n        :large=\"isMobile\"\n        :class=\"isMobile ? 'btn-mobile' : ''\"\n        @click=\"setAccept\"\n      >\n        {{ actionTitle || $vuetify.lang.t('$vuetify.btn.accept') }}\n      </v-btn>\n    </v-card-actions>\n  </v-card>\n</template>\n<script>\nexport default {\n  tag: 'dav-accept-term',\n  props: {\n    termUse: {\n      type: Array,\n    },\n    customUrlAccept: Boolean,\n    actionTitle: {\n      type: String,\n    },\n    cancelOption: {\n      type: Boolean,\n    },\n    loading: {\n      type: Boolean,\n    },\n    isMobile: {\n      type: Boolean,\n      default: false,\n    },\n  },\n  data: () => {\n    return {\n      readConfirmAcceptTerm: [],\n      setTermLoading: false,\n    };\n  },\n  computed: {\n    setup() {\n      return this.$store.getters['credential/SETUP'];\n    },\n    resultTerm() {\n      return this.termUse || this.$store.getters['credential/TERM_USER'];\n    },\n  },\n  mounted() {\n    this.readConfirmAcceptTerm = this.resultTerm.map((opt) => opt === '');\n  },\n  beforeDestroy() {\n    this.setTermLoading = false;\n  },\n  methods: {\n    setAccept() {\n      if (this.readConfirmAcceptTerm.every((opt) => opt === true)) {\n        this.setTermLoading = true;\n        const params = {\n          term: this.resultTerm,\n        };\n\n        if (this.location) params.location = this.location;\n\n        if (this.customUrlAccept) {\n          this.$root.$emit('fetchTermAccept');\n          this.setTermLoading = false;\n        } else {\n          this.$store.dispatch('credential/FETCH_TERM_USER_ACCEPT', params);\n        }\n      }\n    },\n    getUrlFilePath(filePath) {\n      if (filePath && !filePath.includes(process.env.VUE_APP_MEDIA_SERVER_BASE)) {\n        return `${process.env.VUE_APP_MEDIA_SERVER_BASE}/${filePath}`;\n      }\n      return filePath;\n    },\n    reset() {\n      this.readConfirmAcceptTerm = [];\n    },\n  },\n};\n</script>\n<style scoped>\n.card-mobile {\n  box-shadow: none !important;\n}\n\n.btn-mobile {\n  text-transform: unset;\n  border-radius: 8px;\n}\n\n.no-border {\n  border: none !important;\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$o = "data-v-24af8ede";
  /* module identifier */
  const __vue_module_identifier__$o = undefined;
  /* functional template */
  const __vue_is_functional_template__$o = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$o = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$m, staticRenderFns: __vue_staticRenderFns__$m },
    __vue_inject_styles__$o,
    __vue_script__$o,
    __vue_scope_id__$o,
    __vue_is_functional_template__$o,
    __vue_module_identifier__$o,
    false,
    createInjector,
    undefined,
    undefined
  );

const AcceptTerm = __vue_component__$o;

//

var script$n = {
  name: 'LoginForm',
  components: { 'dav-accept-term': AcceptTerm },
  mixins: [validationMixin],
  tag: 'primeit-login-form',
  validations: {
    credential: {
      newPassword: {
        value: {
          required,
          minLength: minLength(8),
          valid: function (value) {
            return /^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z]).{6,}$/.test(value);
          },
        },
      },
      confirmPassword: {
        value: {
          same: sameAs(function () {
            return this.credential.newPassword.value;
          }),
        },
      },
    },
  },
  props: {},
  data: () => ({
    termShow: 0,
    dialog: false,
    dialogMensage: false,
    mail: '',
    dialogChangePassword: false,
    msgForgotMail: '',
    isActiveChangePassword: false,
    readConfirmAcceptTerm: false,
    loadingAccept: false,
    termUse: null,
    location: null,
    steps: {
      currentStep: null,
      config: {
        email: { step: 1, complete: false },
        password: { step: 2, complete: false },
        newPassword: { step: 3, complete: false },
        acceptTerm: { step: 4, complete: false },
        notAcceptTerm: { step: 5, complete: false },
      },
    },
    loading: {
      checkingEmail: false,
      checkingPassword: false,
      changingPassword: false,
      checkinTermPending: false,
    },
    credential: {
      email: {
        value: '',
        errors: [],
      },
      password: {
        value: '',
        errors: [],
        type: 'password',
        appendIcon: 'visibility',
      },
      newPassword: {
        value: '',
        errors: [],
        type: 'password',
        appendIcon: 'visibility',
      },
      confirmPassword: {
        value: '',
        errors: [],
        type: 'password',
        appendIcon: 'visibility',
      },
    },
  }),
  computed: {
    newPasswordErrors() {
      const errors = [];
      if (!this.$v.credential.newPassword.value.$dirty) return errors;
      !this.$v.credential.newPassword.value.required && errors.push('A senha é obrigatória');
      !this.$v.credential.newPassword.value.minLength && errors.push('A senha deve possuir pelo menos 8 caracteres');
      !this.$v.credential.newPassword.value.valid &&
        errors.push(
          'A senha deve possuir pelo menos 8 caracteres e ser composta por letras maiúsculas, minúsculas e números'
        );
      return errors;
    },
    confirmPasswordErrors() {
      const errors = [];
      if (!this.$v.credential.confirmPassword.value.$dirty) return errors;
      !this.$v.credential.confirmPassword.value.same && errors.push('Confirmação deve ser igual a senha escolhida');
      return errors;
    },
    setup() {
      return this.$store.getters['credential/SETUP'];
    },
    checkEmail() {
      return this.$store.getters['credential/CHECK_EMAIL'];
    },
    checkPassword() {
      return this.$store.getters['credential/CHECK_PASSWORD'];
    },
    changePassword() {
      return this.$store.getters['credential/CHANGE_PASSWORD'];
    },
    resultForgot() {
      return this.$store.getters['credential/GET_FORGOT'];
    },
    resultTerm() {
      return this.$store.getters['credential/TERM_USER'];
    },
    termReady() {
      return this.$store.getters['credential/TERM_READY'];
    },
  },
  watch: {
    'credential.newPassword.value'(val) {
      this.isActiveChangePassword = false;
      if (val) {
        if (
          val.length > 5 &&
          this.credential &&
          this.credential.confirmPassword &&
          this.credential.confirmPassword.value &&
          this.credential.confirmPassword.value.length > 5
        ) {
          this.isActiveChangePassword = true;
        }
      }
    },
    'credential.confirmPassword.value'(val) {
      this.isActiveChangePassword = false;
      if (val) {
        if (
          val.length > 5 &&
          this.credential &&
          this.credential.newPassword &&
          this.credential.newPassword.value &&
          this.credential.newPassword.value.length > 5
        ) {
          this.isActiveChangePassword = true;
        }
      }
    },
    resultForgot(val) {
      if (val) {
        this.dialogMensage = false;
        this.dialogChangePassword = true;
        this.mail = '';
        if (val.send) {
          this.msgForgotMail = 'Nova senha enviada para o email informado';
        } else {
          this.msgForgotMail = 'Não foi possivel enviar uma nova senha para o email informado.';
        }
      }
    },
    checkEmail(val) {
      if (val) {
        if (val.result) {
          this.steps.currentStep = this.steps.config.password.step;
        } else {
          this.credential.email.errors = val.message || ['Usuário não encontrado'];
        }
        this.loading.checkingEmail = false;
      }
    },
    checkPassword(val) {
      if (val) {
        this.loading.checkingPassword = false;
        switch (val.result) {
          case 'NEW_PASSWORD_REQUIRED':
            this.steps.currentStep = this.steps.config.newPassword.step;
            break;
          case 'OK':
            this.checkAcceptTerm();
            break;
          case 'ERROR':
            this.credential.password.errors = ['Senha inválida'];
            break;
        }
      }
    },
    changePassword(val) {
      if (val) {
        this.loading.changingPassword = false;
        switch (val.result) {
          case 'OK':
            this.checkAcceptTerm();
            break;
          case 'ERROR':
            this.credential.newPassword.errors = [
              'Senha deve possuir pelo menos 8 caracteres e ser composta por letras maiúsculas, minúsculas e números',
            ];
            break;
        }
      }
    },
    'steps.currentStep'(val) {
      const that = this;

      switch (val) {
        case that.steps.config.email.step:
          that.loading.checkingEmail = false;
          that.credential.email.value = null;
          that.credential.email.errors = [];
          that.$nextTick(() => {
            setTimeout(() => {
              that.$refs.email.focus();
            }, 10);
          });
          break;
        case that.steps.config.password.step:
          that.loading.checkingPassword = false;
          that.credential.password.value = null;
          that.credential.password.errors = [];
          that.$nextTick(() => {
            setTimeout(() => {
              that.$refs.password.focus();
            }, 10);
          });
          break;
        case that.steps.config.newPassword.step:
          that.loading.changingPassword = false;
          that.credential.newPassword.value = null;
          that.credential.newPassword.errors = [];
          that.credential.confirmPassword.value = null;
          that.credential.confirmPassword.errors = [];
          that.$nextTick(() => {
            setTimeout(() => {
              that.$refs.newPassword.focus();
            }, 10);
          });
          break;
      }

      this.$emit('currentStep', val);
    },

    termReady(val) {
      if (val) {
        this.goHome();
      }
    },

    resultTerm(term) {
      this.loading.checkinTermPending = false;
      this.termUse = term;
      if (this.termUse && (this.termUse.length === 0 || this.termUse.every((opt) => opt === true))) {
        return this.goHome();
      }
      this.askLocation();
    },
  },
  mounted() {
    this.backToEmail();
  },
  beforeDestroy() {
    this.$store.commit('credential/POPULATE_TERM_READY', false);
    this.$store.commit('credential/POPULATE_TERM_USER', []);
  },
  methods: {
    askLocation() {
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };

      window.navigator.geolocation.getCurrentPosition(this.setLocation, undefined, options);
    },
    setLocation(position) {
      if (position) {
        const coordinates = position.coords;
        if (coordinates) {
          this.location = {
            latitude: coordinates.latitude,
            longitude: coordinates.longitude,
          };
        }
      }
    },
    goCheckUser() {
      if (this.credential.email.value && this.credential.email.value.length === 0) {
        this.credential.email.errors = ['O email não pode ser vazio'];
        return;
      }

      this.loading.checkingEmail = true;
      this.$store.dispatch('credential/CHECK_EMAIL', {
        email: this.credential.email.value,
      });
    },

    backToEmail() {
      this.steps.currentStep = this.steps.config.email.step;
    },

    goCheckPassword() {
      if (this.credential.password.value && this.credential.password.value.length < 5) {
        return;
      }

      this.loading.checkingPassword = true;
      this.$store.dispatch('credential/CHECK_PASSWORD', {
        password: this.credential.password.value,
      });
    },

    goChangePassword() {
      if (!this.$v.$invalid) {
        this.loading.changingPassword = true;
        this.$store.dispatch('credential/CHANGE_PASSWORD', {
          newPassword: this.credential.newPassword.value,
        });
      }
    },

    goHome() {
      this.$router.replace({ path: '/' });
    },
    checkAcceptTerm() {
      this.loading.checkinTermPending = true;
      this.steps.currentStep = this.steps.config.acceptTerm.step;
      this.$store.dispatch('credential/FETCH_TERM_USER');
    },
    notAcceptTerm() {
      this.termShow = 0;
      this.$store.dispatch('credential/NOT_ACCEPT_TERM');
      this.steps.currentStep = this.steps.config.notAcceptTerm.step;
    },
    Forgot() {
      this.dialog = false;
      this.$store.dispatch('credential/FETCH_FORGOT', this.mail);
      // this.mail = '';
    },
    getUrlFilePath(filePath) {
      if (filePath && !filePath.includes(process.env.VUE_APP_MEDIA_SERVER_BASE)) {
        return `${process.env.VUE_APP_MEDIA_SERVER_BASE}/${filePath}`;
      }
      return filePath;
    },
  },
};

/* script */
const __vue_script__$n = script$n;

/* template */
var __vue_render__$l = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "v-container",
    { staticClass: "pa-2" },
    [
      _c(
        "v-stepper",
        {
          model: {
            value: _vm.steps.currentStep,
            callback: function ($$v) {
              _vm.$set(_vm.steps, "currentStep", $$v);
            },
            expression: "steps.currentStep",
          },
        },
        [
          _c(
            "v-stepper-header",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: false,
                  expression: "false",
                },
              ],
            },
            [
              _c("v-stepper-step", {
                attrs: { step: _vm.steps.config.email.step },
              }),
              _vm._v(" "),
              _c("v-stepper-step", {
                attrs: { step: _vm.steps.config.password.step },
              }),
              _vm._v(" "),
              _c("v-stepper-step", {
                attrs: { step: _vm.steps.config.newPassword.step },
              }),
              _vm._v(" "),
              _c("v-stepper-step", {
                attrs: { step: _vm.steps.config.acceptTerm.step },
              }),
              _vm._v(" "),
              _c("v-stepper-step", {
                attrs: { step: _vm.steps.config.notAcceptTerm.step },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-stepper-items",
            [
              _c(
                "v-stepper-content",
                {
                  staticStyle: { height: "340px" },
                  attrs: { step: _vm.steps.config.email.step },
                },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "mb-5",
                      attrs: { "text-xs-center": "", flat: "" },
                    },
                    [
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "mb-6 text-center ma-1",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$vuetify.lang.t(
                                          "$vuetify.pages.login_page.login_to_your_account"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "form",
                            { attrs: { onsubmit: "return false;" } },
                            [
                              _c("v-text-field", {
                                ref: "email",
                                staticClass: "notranslate",
                                attrs: {
                                  id: "login_email",
                                  autocomplete: "username",
                                  outlined: "",
                                  disabled: _vm.loading.checkingEmail,
                                  "error-messages": _vm.credential.email.errors,
                                  "prepend-icon": "person",
                                  label: "Login",
                                  placeholder: " ",
                                  type: "text",
                                },
                                on: {
                                  input: function ($event) {
                                    _vm.credential.email.errors = [];
                                  },
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.goCheckUser.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.credential.email.value,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.credential.email, "value", $$v);
                                  },
                                  expression: "credential.email.value",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _c("v-progress-circular", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.loading.checkingEmail,
                                expression: "loading.checkingEmail",
                              },
                            ],
                            attrs: {
                              size: 50,
                              color: "primary",
                              indeterminate: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c(
                              "div",
                              { staticClass: "text-center" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.loading.checkingEmail,
                                        expression: "!loading.checkingEmail",
                                      },
                                    ],
                                    attrs: {
                                      id: "login_buttom_continue",
                                      color: "primary",
                                    },
                                    on: { click: _vm.goCheckUser },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$vuetify.lang.t(
                                            "$vuetify.pages.login_page.continue"
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-stepper-content",
                {
                  staticStyle: { height: "340px" },
                  attrs: { step: _vm.steps.config.password.step },
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "mb-5", attrs: { flat: "" } },
                    [
                      _c(
                        "v-card-text",
                        [
                          _c("v-text-field", {
                            staticClass: "notranslate",
                            attrs: {
                              outlined: "",
                              disabled: "",
                              "prepend-icon": "person",
                              label: "Login",
                              placeholder: " ",
                              type: "text",
                            },
                            model: {
                              value: _vm.credential.email.value,
                              callback: function ($$v) {
                                _vm.$set(_vm.credential.email, "value", $$v);
                              },
                              expression: "credential.email.value",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "form",
                            { attrs: { onsubmit: "return false;" } },
                            [
                              _c("input", {
                                attrs: {
                                  type: "text",
                                  hidden: "",
                                  autocomplete: "username",
                                },
                                domProps: { value: _vm.credential.email.value },
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                ref: "password",
                                staticClass: "notranslate",
                                attrs: {
                                  id: "login_password",
                                  autocomplete: "current-password",
                                  outlined: "",
                                  "prepend-icon": "vpn_key",
                                  "append-icon":
                                    _vm.credential.password.type === "password"
                                      ? "visibility"
                                      : "visibility_off",
                                  disabled: _vm.loading.checkingPassword,
                                  "error-messages":
                                    _vm.credential.password.errors,
                                  label: _vm.$vuetify.lang.t(
                                    "$vuetify.pages.login_page.password"
                                  ),
                                  required: "",
                                  type: _vm.credential.password.type,
                                },
                                on: {
                                  "click:append": function ($event) {
                                    _vm.credential.password.type =
                                      _vm.credential.password.type ===
                                      "password"
                                        ? (_vm.credential.password.type =
                                            "text")
                                        : (_vm.credential.password.type =
                                            "password");
                                  },
                                  input: function ($event) {
                                    _vm.credential.password.errors = [];
                                  },
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    _vm.credential &&
                                    _vm.credential.password &&
                                    _vm.credential.password.value &&
                                    _vm.credential.password.value.length > 5
                                      ? _vm.goCheckPassword()
                                      : false;
                                  },
                                },
                                model: {
                                  value: _vm.credential.password.value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.credential.password,
                                      "value",
                                      $$v
                                    );
                                  },
                                  expression: "credential.password.value",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-right" }, [
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.loading.checkingEmail,
                                    expression: "!loading.checkingEmail",
                                  },
                                ],
                                staticClass: "link-login",
                                attrs: { id: "login_buttom_forgot", href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault();
                                    _vm.mail = _vm.credential.email.value;
                                    _vm.dialog = true;
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$vuetify.lang.t(
                                        "$vuetify.pages.login_page.forgot_password"
                                      )
                                    )
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _c(
                        "v-btn",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.loading.checkingPassword,
                              expression: "!loading.checkingPassword",
                            },
                          ],
                          attrs: {
                            id: "login_buttom_back",
                            disabled: _vm.loading.checkingPassword,
                            color: "primary",
                          },
                          on: { click: _vm.backToEmail },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$vuetify.lang.t(
                                  "$vuetify.pages.login_page.back"
                                )
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.loading.checkingPassword,
                              expression: "!loading.checkingPassword",
                            },
                          ],
                          attrs: {
                            id: "login_buttom_go",
                            disabled:
                              _vm.loading.checkingPassword ||
                              !_vm.credential ||
                              !_vm.credential.password ||
                              !_vm.credential.password.value ||
                              _vm.credential.password.value.length < 5,
                            color: "primary",
                          },
                          on: { click: _vm.goCheckPassword },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$vuetify.lang.t(
                                  "$vuetify.pages.login_page.log_in"
                                )
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-progress-circular", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.loading.checkingPassword,
                            expression: "loading.checkingPassword",
                          },
                        ],
                        attrs: {
                          size: 50,
                          color: "primary",
                          indeterminate: "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-stepper-content",
                {
                  staticStyle: { height: "340px" },
                  attrs: { step: _vm.steps.config.newPassword.step },
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "mb-5", attrs: { flat: "" } },
                    [
                      _c("v-card-text", [
                        _c(
                          "form",
                          { attrs: { onsubmit: "return false;" } },
                          [
                            _c("input", {
                              attrs: {
                                type: "text",
                                hidden: "",
                                autocomplete: "username",
                              },
                              domProps: { value: _vm.credential.email.value },
                            }),
                            _vm._v(" "),
                            _c("v-text-field", {
                              ref: "newPassword",
                              staticClass: "notranslate mb-3",
                              attrs: {
                                id: "login_newPassword",
                                autocomplete: "new-password",
                                disabled: _vm.loading.changingPassword,
                                "append-icon":
                                  _vm.credential.newPassword.type === "password"
                                    ? "visibility"
                                    : "visibility_off",
                                outlined: "",
                                "error-messages": _vm.newPasswordErrors,
                                "prepend-icon": "person",
                                label: "Nova Senha",
                                type: _vm.credential.newPassword.type,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.$v.credential.newPassword.value.$touch()
                                },
                                "click:append": function ($event) {
                                  _vm.credential.newPassword.type =
                                    _vm.credential.newPassword.type ===
                                    "password"
                                      ? (_vm.credential.newPassword.type =
                                          "text")
                                      : (_vm.credential.newPassword.type =
                                          "password");
                                },
                              },
                              model: {
                                value: _vm.credential.newPassword.value,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.credential.newPassword,
                                    "value",
                                    $$v
                                  );
                                },
                                expression: "credential.newPassword.value",
                              },
                            }),
                            _vm._v(" "),
                            _c("v-text-field", {
                              ref: "confirmPassword",
                              staticClass: "notranslate",
                              attrs: {
                                id: "login_confirm_newPassword",
                                autocomplete: "new-password",
                                disabled: _vm.loading.changingPassword,
                                "error-messages": _vm.confirmPasswordErrors,
                                "append-icon":
                                  _vm.credential.confirmPassword.type ===
                                  "password"
                                    ? "visibility"
                                    : "visibility_off",
                                outlined: "",
                                "prepend-icon": "vpn_key",
                                label: "Confirmação",
                                type: _vm.credential.confirmPassword.type,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.$v.credential.confirmPassword.value.$touch()
                                },
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.goChangePassword.apply(
                                    null,
                                    arguments
                                  )
                                },
                                "click:append": function ($event) {
                                  _vm.credential.confirmPassword.type =
                                    _vm.credential.confirmPassword.type ===
                                    "password"
                                      ? (_vm.credential.confirmPassword.type =
                                          "text")
                                      : (_vm.credential.confirmPassword.type =
                                          "password");
                                },
                              },
                              model: {
                                value: _vm.credential.confirmPassword.value,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.credential.confirmPassword,
                                    "value",
                                    $$v
                                  );
                                },
                                expression: "credential.confirmPassword.value",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            id: "login_newPassword_buttom_cancel",
                            text: "",
                          },
                          on: { click: _vm.backToEmail },
                        },
                        [_vm._v(" Cancelar ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.loading.changingPassword,
                              expression: "!loading.changingPassword",
                            },
                          ],
                          attrs: {
                            id: "login_newPassword_buttom_confirm",
                            disabled: _vm.$v.$invalid,
                            color: "primary",
                          },
                          on: { click: _vm.goChangePassword },
                        },
                        [_vm._v("\n            Confirmar\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-progress-circular", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.loading.changingPassword,
                            expression: "loading.changingPassword",
                          },
                        ],
                        attrs: {
                          size: 50,
                          color: "primary",
                          indeterminate: "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-stepper-content",
                {
                  staticStyle: { "max-height": "340px", "overflow-y": "auto" },
                  attrs: { step: _vm.steps.config.acceptTerm.step },
                },
                [
                  _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _c("v-progress-circular", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.loading.checkinTermPending,
                            expression: "loading.checkinTermPending",
                          },
                        ],
                        attrs: {
                          size: 50,
                          color: "primary",
                          indeterminate: "",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.resultTerm && _vm.resultTerm.length > 0
                    ? _c("dav-accept-term")
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-stepper-content",
                {
                  staticStyle: { "max-height": "340px", "overflow-y": "auto" },
                  attrs: { step: _vm.steps.config.notAcceptTerm.step },
                },
                [
                  _c("div", [
                    _vm._v(
                      "Não será possivel acessar o sistema sem aceitar o termos de uso."
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            id: "login_buttom_backToEmail_back",
                            text: "",
                            color: "secondary",
                          },
                          on: { click: _vm.backToEmail },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$vuetify.lang.t("$vuetify.btn.back")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "600px" },
              model: {
                value: _vm.dialog,
                callback: function ($$v) {
                  _vm.dialog = $$v;
                },
                expression: "dialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", { attrs: { xs12: "" } }, [
                    _c("div", { staticClass: "text-center" }, [
                      _c("span", { staticClass: "text-h5" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$vuetify.lang.t(
                              "$vuetify.pages.login_page.forgot_password"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-row",
                            [
                              _c("v-col", { attrs: { cols: "12" } }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$vuetify.lang.t(
                                        "$vuetify.pages.login_page.forgot_password_message"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Email",
                                      disabled: true,
                                      required: "",
                                    },
                                    model: {
                                      value: _vm.mail,
                                      callback: function ($$v) {
                                        _vm.mail = $$v;
                                      },
                                      expression: "mail",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                id: "login_buttom_dialog_close",
                                color: "blue darken-1",
                                text: "",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.dialog = false;
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$vuetify.lang.t(
                                      "$vuetify.pages.login_page.close"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "white--text",
                              attrs: {
                                id: "login_buttom_dialog_send_mail",
                                disabled:
                                  _vm.dialogMensage ||
                                  _vm.mail.length < 5 ||
                                  !_vm.mail.includes("@"),
                                loading: _vm.dialogMensage,
                                color: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.dialogMensage = true;
                                  _vm.Forgot();
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$vuetify.lang.t(
                                      "$vuetify.pages.login_page.send_mail"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "v-dialog",
                {
                  attrs: { "hide-overlay": "", persistent: "", width: "300" },
                  model: {
                    value: _vm.dialogMensage,
                    callback: function ($$v) {
                      _vm.dialogMensage = $$v;
                    },
                    expression: "dialogMensage",
                  },
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "v-card",
                        { attrs: { color: "primary", dark: "" } },
                        [
                          _c(
                            "v-card-text",
                            [
                              _vm._v(
                                "\n              Enviando email\n              "
                              ),
                              _c("v-progress-linear", {
                                staticClass: "mb-0",
                                attrs: { indeterminate: "", color: "white" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "v-dialog",
                {
                  attrs: { "hide-overlay": "", persistent: "", width: "300" },
                  model: {
                    value: _vm.dialogChangePassword,
                    callback: function ($$v) {
                      _vm.dialogChangePassword = $$v;
                    },
                    expression: "dialogChangePassword",
                  },
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "v-card",
                        [
                          _c("v-card-text", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.msgForgotMail) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text-center" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    id: "login_dialog_msgForgotMail_close",
                                    color: "blue darken-1",
                                    text: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogChangePassword = false;
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                Fechar\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
};
var __vue_staticRenderFns__$l = [];
__vue_render__$l._withStripped = true;

  /* style */
  const __vue_inject_styles__$n = function (inject) {
    if (!inject) return
    inject("data-v-7810dfbd_0", { source: "\n.v-text-field.v-text-field--enclosed .v-text-field__details {\n  margin-bottom: 0px;\n}\n.link-login,\n.link-login:visited,\n.link-login:active {\n  margin: 0;\n  padding: 0;\n  background-color: transparent;\n  box-shadow: none;\n  color: #328ddd;\n  font-size: 0.9em;\n}\n.link-login:hover {\n  text-decoration: underline;\n  color: #0000ee;\n}\n", map: {"version":3,"sources":["/home/daniel/Projects/dav/frontend/dav-frontend-components-vue/src/components/LoginForm/LoginForm.vue"],"names":[],"mappings":";AAuTA;EACA,kBAAA;AACA;AACA;;;EAGA,SAAA;EACA,UAAA;EACA,6BAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AACA;AACA;EACA,0BAAA;EACA,cAAA;AACA","file":"LoginForm.vue","sourcesContent":["<template>\n  <v-container class=\"pa-2\">\n    <v-stepper v-model=\"steps.currentStep\">\n      <v-stepper-header v-show=\"false\">\n        <v-stepper-step :step=\"steps.config.email.step\" />\n        <v-stepper-step :step=\"steps.config.password.step\" />\n        <v-stepper-step :step=\"steps.config.newPassword.step\" />\n        <v-stepper-step :step=\"steps.config.acceptTerm.step\" />\n        <v-stepper-step :step=\"steps.config.notAcceptTerm.step\" />\n      </v-stepper-header>\n      <v-stepper-items>\n        <v-stepper-content style=\"height: 340px\" :step=\"steps.config.email.step\">\n          <v-card class=\"mb-5\" text-xs-center flat>\n            <v-card-text>\n              <v-row>\n                <v-col cols=\"12\" class=\"mb-6 text-center ma-1\"> {{$vuetify.lang.t('$vuetify.pages.login_page.login_to_your_account')}} </v-col>\n              </v-row>\n              <form onsubmit=\"return false;\">\n                <v-text-field\n                  id=\"login_email\"\n                  ref=\"email\"\n                  v-model=\"credential.email.value\"\n                  autocomplete=\"username\"\n                  class=\"notranslate\"\n                  outlined\n                  :disabled=\"loading.checkingEmail\"\n                  :error-messages=\"credential.email.errors\"\n                  prepend-icon=\"person\"\n                  label=\"Login\"\n                  placeholder=\" \"\n                  type=\"text\"\n                  @input=\"credential.email.errors = []\"\n                  @keyup.enter=\"goCheckUser\"\n                />\n              </form>\n            </v-card-text>\n            <div class=\"text-center\">\n              <v-progress-circular v-show=\"loading.checkingEmail\" :size=\"50\" color=\"primary\" indeterminate />\n            </div>\n          </v-card>\n          <v-card-actions>\n            <v-row>\n              <v-col cols=\"12\">\n                <div class=\"text-center\">\n                  <v-btn\n                    v-show=\"!loading.checkingEmail\"\n                    id=\"login_buttom_continue\"\n                    color=\"primary\"\n                    @click=\"goCheckUser\"\n                  >\n                    {{$vuetify.lang.t('$vuetify.pages.login_page.continue')}}\n                  </v-btn>\n                </div>\n              </v-col>\n            </v-row>\n          </v-card-actions>\n        </v-stepper-content>\n        <v-stepper-content :step=\"steps.config.password.step\" style=\"height: 340px\">\n          <v-card class=\"mb-5\" flat>\n            <v-card-text>\n              <v-text-field\n                v-model=\"credential.email.value\"\n                class=\"notranslate\"\n                outlined\n                disabled\n                prepend-icon=\"person\"\n                label=\"Login\"\n                placeholder=\" \"\n                type=\"text\"\n              />\n              <form onsubmit=\"return false;\">\n                <input type=\"text\" hidden autocomplete=\"username\" :value=\"credential.email.value\" />\n                <v-text-field\n                  id=\"login_password\"\n                  ref=\"password\"\n                  v-model=\"credential.password.value\"\n                  autocomplete=\"current-password\"\n                  class=\"notranslate\"\n                  outlined\n                  prepend-icon=\"vpn_key\"\n                  :append-icon=\"credential.password.type === 'password' ? 'visibility' : 'visibility_off'\"\n                  :disabled=\"loading.checkingPassword\"\n                  :error-messages=\"credential.password.errors\"\n                  :label=\"$vuetify.lang.t('$vuetify.pages.login_page.password')\"\n                  required\n                  :type=\"credential.password.type\"\n                  @click:append=\"\n                    credential.password.type =\n                      credential.password.type === 'password'\n                        ? (credential.password.type = 'text')\n                        : (credential.password.type = 'password')\n                  \"\n                  @input=\"credential.password.errors = []\"\n                  @keyup.enter=\"\n                    credential &&\n                    credential.password &&\n                    credential.password.value &&\n                    credential.password.value.length > 5\n                      ? goCheckPassword()\n                      : false\n                  \"\n                />\n              </form>\n              <div class=\"text-right\">\n                <a\n                  v-show=\"!loading.checkingEmail\"\n                  id=\"login_buttom_forgot\"\n                  href=\"#\"\n                  class=\"link-login\"\n                  @click.prevent=\"\n                    mail = credential.email.value;\n                    dialog = true;\n                  \"\n                >\n                  {{$vuetify.lang.t('$vuetify.pages.login_page.forgot_password')}}</a\n                >\n              </div>\n            </v-card-text>\n          </v-card>\n          <div class=\"text-center\">\n            <v-btn\n              v-show=\"!loading.checkingPassword\"\n              id=\"login_buttom_back\"\n              :disabled=\"loading.checkingPassword\"\n              color=\"primary\"\n              @click=\"backToEmail\"\n            >\n              {{$vuetify.lang.t('$vuetify.pages.login_page.back')}}\n            </v-btn>\n\n            <v-btn\n              v-show=\"!loading.checkingPassword\"\n              id=\"login_buttom_go\"\n              :disabled=\"\n                loading.checkingPassword ||\n                !credential ||\n                !credential.password ||\n                !credential.password.value ||\n                credential.password.value.length < 5\n              \"\n              color=\"primary\"\n              @click=\"goCheckPassword\"\n            >\n              {{$vuetify.lang.t('$vuetify.pages.login_page.log_in')}}\n            </v-btn>\n\n            <v-progress-circular v-show=\"loading.checkingPassword\" :size=\"50\" color=\"primary\" indeterminate />\n          </div>\n        </v-stepper-content>\n        <v-stepper-content :step=\"steps.config.newPassword.step\" style=\"height: 340px\">\n          <v-card class=\"mb-5\" flat>\n            <v-card-text>\n              <form onsubmit=\"return false;\">\n                <input type=\"text\" hidden autocomplete=\"username\" :value=\"credential.email.value\" />\n                <v-text-field\n                  id=\"login_newPassword\"\n                  ref=\"newPassword\"\n                  v-model=\"credential.newPassword.value\"\n                  autocomplete=\"new-password\"\n                  :disabled=\"loading.changingPassword\"\n                  :append-icon=\"credential.newPassword.type === 'password' ? 'visibility' : 'visibility_off'\"\n                  outlined\n                  :error-messages=\"newPasswordErrors\"\n                  class=\"notranslate mb-3\"\n                  prepend-icon=\"person\"\n                  label=\"Nova Senha\"\n                  :type=\"credential.newPassword.type\"\n                  @input=\"$v.credential.newPassword.value.$touch()\"\n                  @click:append=\"\n                    credential.newPassword.type =\n                      credential.newPassword.type === 'password'\n                        ? (credential.newPassword.type = 'text')\n                        : (credential.newPassword.type = 'password')\n                  \"\n                />\n                <v-text-field\n                  id=\"login_confirm_newPassword\"\n                  ref=\"confirmPassword\"\n                  v-model=\"credential.confirmPassword.value\"\n                  autocomplete=\"new-password\"\n                  :disabled=\"loading.changingPassword\"\n                  :error-messages=\"confirmPasswordErrors\"\n                  :append-icon=\"credential.confirmPassword.type === 'password' ? 'visibility' : 'visibility_off'\"\n                  outlined\n                  prepend-icon=\"vpn_key\"\n                  label=\"Confirmação\"\n                  :type=\"credential.confirmPassword.type\"\n                  class=\"notranslate\"\n                  @input=\"$v.credential.confirmPassword.value.$touch()\"\n                  @keyup.enter=\"goChangePassword\"\n                  @click:append=\"\n                    credential.confirmPassword.type =\n                      credential.confirmPassword.type === 'password'\n                        ? (credential.confirmPassword.type = 'text')\n                        : (credential.confirmPassword.type = 'password')\n                  \"\n                />\n              </form>\n            </v-card-text>\n          </v-card>\n          <div class=\"text-center\">\n            <v-btn id=\"login_newPassword_buttom_cancel\" text @click=\"backToEmail\"> Cancelar </v-btn>\n            <v-btn\n              v-show=\"!loading.changingPassword\"\n              id=\"login_newPassword_buttom_confirm\"\n              :disabled=\"$v.$invalid\"\n              color=\"primary\"\n              @click=\"goChangePassword\"\n            >\n              Confirmar\n            </v-btn>\n            <v-progress-circular v-show=\"loading.changingPassword\" :size=\"50\" color=\"primary\" indeterminate />\n          </div>\n        </v-stepper-content>\n        <v-stepper-content :step=\"steps.config.acceptTerm.step\" style=\"max-height: 340px; overflow-y: auto\">\n          <div class=\"text-center\">\n            <v-progress-circular v-show=\"loading.checkinTermPending\" :size=\"50\" color=\"primary\" indeterminate />\n          </div>\n          <dav-accept-term v-if=\"resultTerm && resultTerm.length > 0\" />\n        </v-stepper-content>\n        <v-stepper-content :step=\"steps.config.notAcceptTerm.step\" style=\"max-height: 340px; overflow-y: auto\">\n          <div>Não será possivel acessar o sistema sem aceitar o termos de uso.</div>\n\n          <v-card-actions>\n            <v-spacer />\n            <v-btn id=\"login_buttom_backToEmail_back\" text color=\"secondary\" @click=\"backToEmail\">\n              {{ $vuetify.lang.t('$vuetify.btn.back') }}\n            </v-btn>\n          </v-card-actions>\n        </v-stepper-content>\n      </v-stepper-items>\n    </v-stepper>\n\n    <v-row justify=\"center\">\n      <v-dialog v-model=\"dialog\" persistent max-width=\"600px\">\n        <v-card>\n          <v-card-title xs12>\n            <div class=\"text-center\">\n              <span class=\"text-h5\">{{$vuetify.lang.t('$vuetify.pages.login_page.forgot_password')}}</span>\n            </div>\n          </v-card-title>\n          <v-card-text>\n            <v-container>\n              <v-row>\n                <v-col cols=\"12\">\n                  <span>{{$vuetify.lang.t('$vuetify.pages.login_page.forgot_password_message')}}</span>\n                </v-col>\n                <v-col cols=\"12\">\n                  <v-text-field v-model=\"mail\" label=\"Email\" :disabled=\"true\" required />\n                </v-col>\n              </v-row>\n            </v-container>\n            <v-spacer />\n\n            <div class=\"text-center\">\n              <v-btn id=\"login_buttom_dialog_close\" color=\"blue darken-1\" text @click=\"dialog = false\"> {{$vuetify.lang.t('$vuetify.pages.login_page.close')}} </v-btn>\n\n              <v-btn\n                id=\"login_buttom_dialog_send_mail\"\n                :disabled=\"dialogMensage || mail.length < 5 || !mail.includes('@')\"\n                :loading=\"dialogMensage\"\n                class=\"white--text\"\n                color=\"primary\"\n                @click=\"\n                  dialogMensage = true;\n                  Forgot();\n                \"\n              >\n                {{$vuetify.lang.t('$vuetify.pages.login_page.send_mail')}}\n              </v-btn>\n            </div>\n          </v-card-text>\n        </v-card>\n      </v-dialog>\n      <div class=\"text-center\">\n        <v-dialog v-model=\"dialogMensage\" hide-overlay persistent width=\"300\">\n          <div>\n            <v-card color=\"primary\" dark>\n              <v-card-text>\n                Enviando email\n                <v-progress-linear indeterminate color=\"white\" class=\"mb-0\" />\n              </v-card-text>\n            </v-card>\n          </div>\n        </v-dialog>\n      </div>\n      <div class=\"text-center\">\n        <v-dialog v-model=\"dialogChangePassword\" hide-overlay persistent width=\"300\">\n          <div>\n            <v-card>\n              <v-card-text>\n                {{ msgForgotMail }}\n              </v-card-text>\n              <div class=\"text-center\">\n                <v-btn\n                  id=\"login_dialog_msgForgotMail_close\"\n                  color=\"blue darken-1\"\n                  text\n                  @click=\"dialogChangePassword = false\"\n                >\n                  Fechar\n                </v-btn>\n              </div>\n            </v-card>\n          </div>\n        </v-dialog>\n      </div>\n    </v-row>\n  </v-container>\n</template>\n<style>\n.v-text-field.v-text-field--enclosed .v-text-field__details {\n  margin-bottom: 0px;\n}\n.link-login,\n.link-login:visited,\n.link-login:active {\n  margin: 0;\n  padding: 0;\n  background-color: transparent;\n  box-shadow: none;\n  color: #328ddd;\n  font-size: 0.9em;\n}\n.link-login:hover {\n  text-decoration: underline;\n  color: #0000ee;\n}\n</style>\n<script>\nimport { AcceptTerm } from '../AcceptTerm';\nimport { required, sameAs, minLength } from 'vuelidate/lib/validators';\nimport { validationMixin } from 'vuelidate';\n\nexport default {\n  name: 'LoginForm',\n  components: { 'dav-accept-term': AcceptTerm },\n  mixins: [validationMixin],\n  tag: 'primeit-login-form',\n  validations: {\n    credential: {\n      newPassword: {\n        value: {\n          required,\n          minLength: minLength(8),\n          valid: function (value) {\n            return /^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z]).{6,}$/.test(value);\n          },\n        },\n      },\n      confirmPassword: {\n        value: {\n          same: sameAs(function () {\n            return this.credential.newPassword.value;\n          }),\n        },\n      },\n    },\n  },\n  props: {},\n  data: () => ({\n    termShow: 0,\n    dialog: false,\n    dialogMensage: false,\n    mail: '',\n    dialogChangePassword: false,\n    msgForgotMail: '',\n    isActiveChangePassword: false,\n    readConfirmAcceptTerm: false,\n    loadingAccept: false,\n    termUse: null,\n    location: null,\n    steps: {\n      currentStep: null,\n      config: {\n        email: { step: 1, complete: false },\n        password: { step: 2, complete: false },\n        newPassword: { step: 3, complete: false },\n        acceptTerm: { step: 4, complete: false },\n        notAcceptTerm: { step: 5, complete: false },\n      },\n    },\n    loading: {\n      checkingEmail: false,\n      checkingPassword: false,\n      changingPassword: false,\n      checkinTermPending: false,\n    },\n    credential: {\n      email: {\n        value: '',\n        errors: [],\n      },\n      password: {\n        value: '',\n        errors: [],\n        type: 'password',\n        appendIcon: 'visibility',\n      },\n      newPassword: {\n        value: '',\n        errors: [],\n        type: 'password',\n        appendIcon: 'visibility',\n      },\n      confirmPassword: {\n        value: '',\n        errors: [],\n        type: 'password',\n        appendIcon: 'visibility',\n      },\n    },\n  }),\n  computed: {\n    newPasswordErrors() {\n      const errors = [];\n      if (!this.$v.credential.newPassword.value.$dirty) return errors;\n      !this.$v.credential.newPassword.value.required && errors.push('A senha é obrigatória');\n      !this.$v.credential.newPassword.value.minLength && errors.push('A senha deve possuir pelo menos 8 caracteres');\n      !this.$v.credential.newPassword.value.valid &&\n        errors.push(\n          'A senha deve possuir pelo menos 8 caracteres e ser composta por letras maiúsculas, minúsculas e números'\n        );\n      return errors;\n    },\n    confirmPasswordErrors() {\n      const errors = [];\n      if (!this.$v.credential.confirmPassword.value.$dirty) return errors;\n      !this.$v.credential.confirmPassword.value.same && errors.push('Confirmação deve ser igual a senha escolhida');\n      return errors;\n    },\n    setup() {\n      return this.$store.getters['credential/SETUP'];\n    },\n    checkEmail() {\n      return this.$store.getters['credential/CHECK_EMAIL'];\n    },\n    checkPassword() {\n      return this.$store.getters['credential/CHECK_PASSWORD'];\n    },\n    changePassword() {\n      return this.$store.getters['credential/CHANGE_PASSWORD'];\n    },\n    resultForgot() {\n      return this.$store.getters['credential/GET_FORGOT'];\n    },\n    resultTerm() {\n      return this.$store.getters['credential/TERM_USER'];\n    },\n    termReady() {\n      return this.$store.getters['credential/TERM_READY'];\n    },\n  },\n  watch: {\n    'credential.newPassword.value'(val) {\n      this.isActiveChangePassword = false;\n      if (val) {\n        if (\n          val.length > 5 &&\n          this.credential &&\n          this.credential.confirmPassword &&\n          this.credential.confirmPassword.value &&\n          this.credential.confirmPassword.value.length > 5\n        ) {\n          this.isActiveChangePassword = true;\n        }\n      }\n    },\n    'credential.confirmPassword.value'(val) {\n      this.isActiveChangePassword = false;\n      if (val) {\n        if (\n          val.length > 5 &&\n          this.credential &&\n          this.credential.newPassword &&\n          this.credential.newPassword.value &&\n          this.credential.newPassword.value.length > 5\n        ) {\n          this.isActiveChangePassword = true;\n        }\n      }\n    },\n    resultForgot(val) {\n      if (val) {\n        this.dialogMensage = false;\n        this.dialogChangePassword = true;\n        this.mail = '';\n        if (val.send) {\n          this.msgForgotMail = 'Nova senha enviada para o email informado';\n        } else {\n          this.msgForgotMail = 'Não foi possivel enviar uma nova senha para o email informado.';\n        }\n      }\n    },\n    checkEmail(val) {\n      if (val) {\n        if (val.result) {\n          this.steps.currentStep = this.steps.config.password.step;\n        } else {\n          this.credential.email.errors = val.message || ['Usuário não encontrado'];\n        }\n        this.loading.checkingEmail = false;\n      }\n    },\n    checkPassword(val) {\n      if (val) {\n        this.loading.checkingPassword = false;\n        switch (val.result) {\n          case 'NEW_PASSWORD_REQUIRED':\n            this.steps.currentStep = this.steps.config.newPassword.step;\n            break;\n          case 'OK':\n            this.checkAcceptTerm();\n            break;\n          case 'ERROR':\n            this.credential.password.errors = ['Senha inválida'];\n            break;\n        }\n      }\n    },\n    changePassword(val) {\n      if (val) {\n        this.loading.changingPassword = false;\n        switch (val.result) {\n          case 'OK':\n            this.checkAcceptTerm();\n            break;\n          case 'ERROR':\n            this.credential.newPassword.errors = [\n              'Senha deve possuir pelo menos 8 caracteres e ser composta por letras maiúsculas, minúsculas e números',\n            ];\n            break;\n        }\n      }\n    },\n    'steps.currentStep'(val) {\n      const that = this;\n\n      switch (val) {\n        case that.steps.config.email.step:\n          that.loading.checkingEmail = false;\n          that.credential.email.value = null;\n          that.credential.email.errors = [];\n          that.$nextTick(() => {\n            setTimeout(() => {\n              that.$refs.email.focus();\n            }, 10);\n          });\n          break;\n        case that.steps.config.password.step:\n          that.loading.checkingPassword = false;\n          that.credential.password.value = null;\n          that.credential.password.errors = [];\n          that.$nextTick(() => {\n            setTimeout(() => {\n              that.$refs.password.focus();\n            }, 10);\n          });\n          break;\n        case that.steps.config.newPassword.step:\n          that.loading.changingPassword = false;\n          that.credential.newPassword.value = null;\n          that.credential.newPassword.errors = [];\n          that.credential.confirmPassword.value = null;\n          that.credential.confirmPassword.errors = [];\n          that.$nextTick(() => {\n            setTimeout(() => {\n              that.$refs.newPassword.focus();\n            }, 10);\n          });\n          break;\n      }\n\n      this.$emit('currentStep', val);\n    },\n\n    termReady(val) {\n      if (val) {\n        this.goHome();\n      }\n    },\n\n    resultTerm(term) {\n      this.loading.checkinTermPending = false;\n      this.termUse = term;\n      if (this.termUse && (this.termUse.length === 0 || this.termUse.every((opt) => opt === true))) {\n        return this.goHome();\n      }\n      this.askLocation();\n    },\n  },\n  mounted() {\n    this.backToEmail();\n  },\n  beforeDestroy() {\n    this.$store.commit('credential/POPULATE_TERM_READY', false);\n    this.$store.commit('credential/POPULATE_TERM_USER', []);\n  },\n  methods: {\n    askLocation() {\n      const options = {\n        enableHighAccuracy: true,\n        timeout: 5000,\n        maximumAge: 0,\n      };\n\n      window.navigator.geolocation.getCurrentPosition(this.setLocation, undefined, options);\n    },\n    setLocation(position) {\n      if (position) {\n        const coordinates = position.coords;\n        if (coordinates) {\n          this.location = {\n            latitude: coordinates.latitude,\n            longitude: coordinates.longitude,\n          };\n        }\n      }\n    },\n    goCheckUser() {\n      if (this.credential.email.value && this.credential.email.value.length === 0) {\n        this.credential.email.errors = ['O email não pode ser vazio'];\n        return;\n      }\n\n      this.loading.checkingEmail = true;\n      this.$store.dispatch('credential/CHECK_EMAIL', {\n        email: this.credential.email.value,\n      });\n    },\n\n    backToEmail() {\n      this.steps.currentStep = this.steps.config.email.step;\n    },\n\n    goCheckPassword() {\n      if (this.credential.password.value && this.credential.password.value.length < 5) {\n        return;\n      }\n\n      this.loading.checkingPassword = true;\n      this.$store.dispatch('credential/CHECK_PASSWORD', {\n        password: this.credential.password.value,\n      });\n    },\n\n    goChangePassword() {\n      if (!this.$v.$invalid) {\n        this.loading.changingPassword = true;\n        this.$store.dispatch('credential/CHANGE_PASSWORD', {\n          newPassword: this.credential.newPassword.value,\n        });\n      }\n    },\n\n    goHome() {\n      this.$router.replace({ path: '/' });\n    },\n    checkAcceptTerm() {\n      this.loading.checkinTermPending = true;\n      this.steps.currentStep = this.steps.config.acceptTerm.step;\n      this.$store.dispatch('credential/FETCH_TERM_USER');\n    },\n    notAcceptTerm() {\n      this.termShow = 0;\n      this.$store.dispatch('credential/NOT_ACCEPT_TERM');\n      this.steps.currentStep = this.steps.config.notAcceptTerm.step;\n    },\n    Forgot() {\n      this.dialog = false;\n      this.$store.dispatch('credential/FETCH_FORGOT', this.mail);\n      // this.mail = '';\n    },\n    getUrlFilePath(filePath) {\n      if (filePath && !filePath.includes(process.env.VUE_APP_MEDIA_SERVER_BASE)) {\n        return `${process.env.VUE_APP_MEDIA_SERVER_BASE}/${filePath}`;\n      }\n      return filePath;\n    },\n  },\n};\n</script>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$n = undefined;
  /* module identifier */
  const __vue_module_identifier__$n = undefined;
  /* functional template */
  const __vue_is_functional_template__$n = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$n = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$l, staticRenderFns: __vue_staticRenderFns__$l },
    __vue_inject_styles__$n,
    __vue_script__$n,
    __vue_scope_id__$n,
    __vue_is_functional_template__$n,
    __vue_module_identifier__$n,
    false,
    createInjector,
    undefined,
    undefined
  );

const LoginForm = __vue_component__$n;

//

var script$m = {
  name: 'ToolbarUserControl',
  props: {
    allowedToEditProfile: { type: Boolean, default: false },
    allowedRegisterDependent: { type: Boolean, default: false },
    id: String,
    role: String,
    doctorOffice: { type: Boolean, default: false },
    avatar: {
      type: String,
      default: '',
    },
  },
  tag: 'primeit-toolbar-user-control',
  data: () => ({
    menuUser: false,
    dialog: false,
    roleText: '',
    allowProfessionalAccessAvailability: false,
  }),
  computed: {
    logged() {
      return this.$store.getters['credential/LOGGED'];
    },
    currentUser() {
      return this.$store.getters['credential/CURRENT_USER'];
    },
    setup() {
      return this.$store.getters['credential/SETUP'];
    },
  },
  watch: {
    logged(val) {
      if (!val) {
        this.endSession();
      }
    },
  },
  mounted() {
    CommonSecurity.getUser().then((user) => {
      if (user) {
        const role = user.getAttribute('custom:roles');
        const rolesDoctor = ['DC', 'D'];

        this.allowProfessionalAccessAvailability =
          rolesDoctor.includes(role) && this.setup?.settings?.show_availability_for_inoffice_professional !== 'hide';
      }
    });
  },
  methods: {
    logout() {
      this.$store.dispatch('credential/LOGOUT');
    },
    endSession() {
      this.$router.replace({ path: '/login' });
    },
    editProfile() {
      const that = this;
      CommonSecurity.getUser().then((user) => {
        if (user) {
          const role = user.getAttribute('custom:roles') === 'P' ? 'person' : 'professional';
          const id = user.getAttribute('cognito:username').includes('@')
            ? user.getAttribute('cognito:username').split('@')[1]
            : user.getAttribute('cognito:username');
          if (that.$route.path !== `/profile/${role}/edit/${id}`)
            that.$root.$router.push({ path: `/profile/${role}/edit/${id}` });
          that.menuUser = false;
        }
      });
    },

    redirectToRegister() {
      this.$router.push({ path: '/registerdependent' });
      this.menuUser = false;
    },

    redirectToScheduleAvailability() {
      CommonSecurity.getUser().then((user) => {
        if (user) {
          const id = user.getAttribute('cognito:username').includes('@')
            ? user.getAttribute('cognito:username').split('@')[1]
            : user.getAttribute('cognito:username');
          this.$router.push({ path: `/schedule_availability/${id}` });
        }
      });
    },
  },
};

/* script */
const __vue_script__$m = script$m;

/* template */
var __vue_render__$k = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "span",
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "290" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v;
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "text-h5" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$vuetify.lang.t("$vuetify.message.sign_out")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$vuetify.lang.t("$vuetify.message.confirm_sign_out")
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { id: "buttom_logout_yes", color: "primary" },
                      on: { click: _vm.logout },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.btn.yes")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { id: "buttom_logout_no", color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.dialog = false;
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.btn.no")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-menu",
        {
          attrs: {
            "close-on-content-click": false,
            "nudge-width": 200,
            "offset-x": "",
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var on = ref.on;
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      {
                        attrs: { color: "blue lighten-2", fab: "", small: "" },
                      },
                      on
                    ),
                    [
                      _vm.currentUser
                        ? _c("dav-avatar", {
                            attrs: {
                              "source-size": 36,
                              "img-source": _vm.avatar,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.menuUser,
            callback: function ($$v) {
              _vm.menuUser = $$v;
            },
            expression: "menuUser",
          },
        },
        [
          _vm._v(" "),
          _vm.currentUser
            ? _c(
                "v-card",
                [
                  _c(
                    "v-list",
                    [
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-list-item-avatar",
                            [
                              _vm.currentUser
                                ? _c("dav-avatar", {
                                    attrs: { "img-source": _vm.avatar },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.currentUser.signInUserSession.idToken
                                        .payload["name"]
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("v-list-item-subtitle", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.role) +
                                    "\n            "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    [
                      _vm.doctorOffice
                        ? _c(
                            "v-list-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.editProfile()
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-icon",
                                [_c("v-icon", [_vm._v("mdi-account")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$vuetify.lang.t(
                                          "$vuetify.message.my_profile"
                                        )
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.allowProfessionalAccessAvailability &&
                      _vm.doctorOffice
                        ? _c(
                            "v-list-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.redirectToScheduleAvailability()
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-icon",
                                [_c("v-icon", [_vm._v("mdi-calendar")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$vuetify.lang.t(
                                          "$vuetify.message.my_availability"
                                        )
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.allowedRegisterDependent
                        ? _c(
                            "v-list-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.redirectToRegister()
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-icon",
                                [_c("v-icon", [_vm._v("mdi-account-plus")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$vuetify.lang.t(
                                          "$vuetify.label.register_dependent"
                                        )
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        {
                          on: {
                            click: function ($event) {
                              _vm.dialog = true;
                            },
                          },
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            [_c("v-icon", [_vm._v("launch")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$vuetify.lang.t(
                                      "$vuetify.message.sign_out"
                                    )
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
};
var __vue_staticRenderFns__$k = [];
__vue_render__$k._withStripped = true;

  /* style */
  const __vue_inject_styles__$m = undefined;
  /* scoped */
  const __vue_scope_id__$m = undefined;
  /* module identifier */
  const __vue_module_identifier__$m = undefined;
  /* functional template */
  const __vue_is_functional_template__$m = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$m = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$k, staticRenderFns: __vue_staticRenderFns__$k },
    __vue_inject_styles__$m,
    __vue_script__$m,
    __vue_scope_id__$m,
    __vue_is_functional_template__$m,
    __vue_module_identifier__$m,
    false,
    undefined,
    undefined,
    undefined
  );

const ToolbarUserControl = __vue_component__$m;

//
  var script$l = {
    name: 'ValidateCurrentTime',
    tag: 'primeit-validate-current-time',
    data: () => ({
      userTime: null,
      showErrorDateTime: false,
      link: '',
    }),
    computed: {

    },
    async created () {
      this.link = location.href;
      const dateNow = new Date();
      this.showErrorDateTime = false;
      const response = await fetch(`${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_EXTERNAL_APPOINTMENT}/_/worldtime`);
      const worldtime = await response.json();

      this.userTime = moment$1(dateNow).format('DD/MM/YYYY HH:mm');

      if (worldtime && worldtime.currentDateTime) {
        const diff = moment$1(worldtime.currentDateTime).diff(moment$1(dateNow), 'seconds');

        if (diff >= 240 || diff <= -240) {
          this.showErrorDateTime = true;
        }
      }
    },
    methods: {
      refresh () {
        document.location.href = this.link;
      },
    },
  };

/* script */
const __vue_script__$l = script$l;

/* template */
var __vue_render__$j = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "500px", persistent: "" },
      model: {
        value: _vm.showErrorDateTime,
        callback: function ($$v) {
          _vm.showErrorDateTime = $$v;
        },
        expression: "showErrorDateTime",
      },
    },
    [
      _vm.showErrorDateTime
        ? _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _c("span", { staticClass: "headline" }, [
                          _vm._v(
                            "\n            A sua data/hora está incorreta! Acerte o relógio e tente novamente.\n          "
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticClass: "text-center", attrs: { cols: "12" } },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "material-icons",
                              staticStyle: { "font-size": "100px" },
                            },
                            [_vm._v("\n            schedule\n          ")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticClass: "text-center", attrs: { cols: "12" } },
                        [
                          _c("span", { staticClass: "headline" }, [
                            _vm._v(
                              "\n            A sua data e hora são:\n          "
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticClass: "text-center", attrs: { cols: "12" } },
                        [
                          _c("span", { staticClass: "headline" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.userTime) +
                                "\n          "
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticClass: "text-center", attrs: { cols: "12" } },
                        [
                          _c(
                            "div",
                            { staticClass: "text-center" },
                            [
                              _c(
                                "v-btn",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.refresh()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              Tentar Novamente\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
};
var __vue_staticRenderFns__$j = [];
__vue_render__$j._withStripped = true;

  /* style */
  const __vue_inject_styles__$l = undefined;
  /* scoped */
  const __vue_scope_id__$l = undefined;
  /* module identifier */
  const __vue_module_identifier__$l = undefined;
  /* functional template */
  const __vue_is_functional_template__$l = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$l = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$j, staticRenderFns: __vue_staticRenderFns__$j },
    __vue_inject_styles__$l,
    __vue_script__$l,
    __vue_scope_id__$l,
    __vue_is_functional_template__$l,
    __vue_module_identifier__$l,
    false,
    undefined,
    undefined,
    undefined
  );

const ValidateCurrentTime = __vue_component__$l;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  var script$k = {
    name: 'MessageSnackbar',
    tag: 'primeit-message-snackbar',
    data: () => ({
      snackbars: [],
      snackbar: {
        show: false,
        color: '',
        mode: 'multi-line',
        timeout: 3500,
        text: '',
        btnClose: false,
      },
    }),
    watch: {
      $route (to, from) {
        if (this.snackbars && this.snackbars.length > 0) {
          setTimeout(function () { this.snackbars = []; }, 4500);
        }
      },
    },
    created () {
      this.listenEvents();
    },
    methods: {
      listenEvents () {
        const vm = this;
        vm.$root.$on('show-snackbar', function (options) {
          vm.showSnackbar({ text: options.text, btnClose: options.btnClose, timeout: options.timeout, color: options.color });
        });
        vm.$root.$on('show-snackbar-multiple', function (msgs) {
          vm.showSnackbarMultiple(msgs);
        });
      },
      showSnackbar (options) {
        // para resolver o fato do vuetify mudado timeout de 0 para -1
        let timeout = options.timeout && options.timeout > 0 ? options.timeout : -1;
        timeout = !options.btnClose && timeout === -1 ? 4000 : timeout;
        this.snackbar.text = options.text ? options.text : options.message;
        this.snackbar.show = true;
        this.snackbar.btnClose = options.btnClose;
        this.snackbar.color = options.color ? options.color : options.type;
        this.snackbar.timeout = timeout;
        this.snackbars = [];
      },
      showSnackbarMultiple (msgs) {
        this.snackbars = [];
        msgs.forEach(element => {
          let timeout = element.timeout && element.timeout > 0 ? element.timeout : -1;
          timeout = !element.btnClose && timeout === -1 ? 4000 : timeout;
          element.show = true;
          element.text = element.text ? element.text : element.message;
          element.btnClose = element.btnClose === undefined ? true : element.btnClose;
          element.color = element.color ? element.color : element.type;
          element.timeout = timeout;
          this.snackbars.push(element);
        });
      },
    },
  };

/* script */
const __vue_script__$k = script$k;

/* template */
var __vue_render__$i = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _vm._l(_vm.snackbars, function (snack, index) {
        return _c("div", { key: index }, [
          _c(
            "div",
            [
              _c(
                "v-snackbar",
                {
                  staticClass: "dav-snackbar",
                  style: "bottom:" + index + "em;",
                  attrs: {
                    color: snack.color,
                    "multi-line": snack.mode,
                    timeout: snack.timeout,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "action",
                        fn: function () {
                          return [
                            snack.btnClose
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: { dark: "", text: "" },
                                    on: {
                                      click: function ($event) {
                                        snack.show = false;
                                      },
                                    },
                                  },
                                  [_vm._v("\n            Fechar\n          ")]
                                )
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: snack.show,
                    callback: function ($$v) {
                      _vm.$set(snack, "show", $$v);
                    },
                    expression: "snack.show",
                  },
                },
                [_c("div", { domProps: { innerHTML: _vm._s(snack.text) } })]
              ),
            ],
            1
          ),
        ])
      }),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          staticClass: "dav-snackbar",
          attrs: {
            color: _vm.snackbar.color,
            "multi-line": _vm.snackbar.mode,
            timeout: _vm.snackbar.timeout,
          },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function () {
                return [
                  _vm.snackbar.btnClose
                    ? _c(
                        "v-btn",
                        {
                          attrs: { dark: "", text: "" },
                          on: {
                            click: function ($event) {
                              _vm.snackbar.show = false;
                            },
                          },
                        },
                        [_vm._v("\n        Fechar\n      ")]
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.snackbar.show,
            callback: function ($$v) {
              _vm.$set(_vm.snackbar, "show", $$v);
            },
            expression: "snackbar.show",
          },
        },
        [_c("div", { domProps: { innerHTML: _vm._s(_vm.snackbar.text) } })]
      ),
    ],
    2
  )
};
var __vue_staticRenderFns__$i = [];
__vue_render__$i._withStripped = true;

  /* style */
  const __vue_inject_styles__$k = function (inject) {
    if (!inject) return
    inject("data-v-7054a37c_0", { source: ".multiple-snackbar[data-v-7054a37c] {\n  width: 100%;\n}\n.v-snack__wrapper[data-v-7054a37c] {\n  width: 100%;\n}\n@media only screen and (min-width: 600px) {\n.v-snack__wrapper[data-v-7054a37c] {\n    width: 100%;\n}\n}\n", map: {"version":3,"sources":["/home/daniel/Projects/dav/frontend/dav-frontend-components-vue/src/components/MessageSnackbar/MessageSnackbar.vue","MessageSnackbar.vue"],"names":[],"mappings":"AAqHA;EACA,WAAA;ACpHA;ADuHA;EACA,WAAA;ACrHA;ADwHA;AACA;IACA,WAAA;ACtHE;AACF","file":"MessageSnackbar.vue","sourcesContent":["<template>\n  <div>\n    <div\n      v-for=\"(snack, index) in snackbars\"\n      :key=\"index\"\n    >\n      <div>\n        <v-snackbar\n          v-model=\"snack.show\"\n          :color=\"snack.color\"\n          :multi-line=\"snack.mode\"\n          :timeout=\"snack.timeout\"\n          :style=\"'bottom:'+ index +'em;'\"\n          class=\"dav-snackbar\"\n        >\n          <div\n            v-html=\"snack.text\"\n          />\n          <template v-slot:action>\n            <v-btn\n              v-if=\"snack.btnClose\"\n              dark\n              text\n              @click=\"snack.show = false\"\n            >\n              Fechar\n            </v-btn>\n          </template>\n        </v-snackbar>\n      </div>\n    </div>\n    <!-- SnackBar -->\n    <v-snackbar\n      v-model=\"snackbar.show\"\n      :color=\"snackbar.color\"\n      :multi-line=\"snackbar.mode\"\n      :timeout=\"snackbar.timeout\"\n      class=\"dav-snackbar\"\n    >\n      <div v-html=\"snackbar.text\" />\n      <template v-slot:action>\n        <v-btn\n          v-if=\"snackbar.btnClose\"\n          dark\n          text\n          @click=\"snackbar.show = false\"\n        >\n          Fechar\n        </v-btn>\n      </template>\n    </v-snackbar>\n  </div>\n</template>\n\n<script>\n  export default {\n    name: 'MessageSnackbar',\n    tag: 'primeit-message-snackbar',\n    data: () => ({\n      snackbars: [],\n      snackbar: {\n        show: false,\n        color: '',\n        mode: 'multi-line',\n        timeout: 3500,\n        text: '',\n        btnClose: false,\n      },\n    }),\n    watch: {\n      $route (to, from) {\n        if (this.snackbars && this.snackbars.length > 0) {\n          setTimeout(function () { this.snackbars = []; }, 4500);\n        }\n      },\n    },\n    created () {\n      this.listenEvents();\n    },\n    methods: {\n      listenEvents () {\n        const vm = this;\n        vm.$root.$on('show-snackbar', function (options) {\n          vm.showSnackbar({ text: options.text, btnClose: options.btnClose, timeout: options.timeout, color: options.color });\n        });\n        vm.$root.$on('show-snackbar-multiple', function (msgs) {\n          vm.showSnackbarMultiple(msgs);\n        });\n      },\n      showSnackbar (options) {\n        // para resolver o fato do vuetify mudado timeout de 0 para -1\n        let timeout = options.timeout && options.timeout > 0 ? options.timeout : -1;\n        timeout = !options.btnClose && timeout === -1 ? 4000 : timeout;\n        this.snackbar.text = options.text ? options.text : options.message;\n        this.snackbar.show = true;\n        this.snackbar.btnClose = options.btnClose;\n        this.snackbar.color = options.color ? options.color : options.type;\n        this.snackbar.timeout = timeout;\n        this.snackbars = [];\n      },\n      showSnackbarMultiple (msgs) {\n        this.snackbars = [];\n        msgs.forEach(element => {\n          let timeout = element.timeout && element.timeout > 0 ? element.timeout : -1;\n          timeout = !element.btnClose && timeout === -1 ? 4000 : timeout;\n          element.show = true;\n          element.text = element.text ? element.text : element.message;\n          element.btnClose = element.btnClose === undefined ? true : element.btnClose;\n          element.color = element.color ? element.color : element.type;\n          element.timeout = timeout;\n          this.snackbars.push(element);\n        });\n      },\n    },\n  };\n</script>\n<style lang=\"stylus\" scoped>\n.multiple-snackbar {\n  width: 100%;\n}\n\n.v-snack__wrapper {\n  width: 100%;\n}\n\n@media only screen and (min-width: 600px) {\n  .v-snack__wrapper {\n    width: 100%;\n  }\n}\n</style>\n<style lang=\"stylus\">\n@media (max-width: 400px){\n  .dav-snackbar > div {\n    min-width: 100% !important;\n    margin-bottom: 80px;\n  }\n}\n@media (max-width: 550px){\n  .dav-snackbar {\n    padding-bottom: 80px !important;\n  }\n}\n</style>\n",".multiple-snackbar {\n  width: 100%;\n}\n.v-snack__wrapper {\n  width: 100%;\n}\n@media only screen and (min-width: 600px) {\n  .v-snack__wrapper {\n    width: 100%;\n  }\n}\n"]}, media: undefined })
,inject("data-v-7054a37c_1", { source: "@media (max-width: 400px) {\n.dav-snackbar > div {\n    min-width: 100% !important;\n    margin-bottom: 80px;\n}\n}\n@media (max-width: 550px) {\n.dav-snackbar {\n    padding-bottom: 80px !important;\n}\n}\n", map: {"version":3,"sources":["/home/daniel/Projects/dav/frontend/dav-frontend-components-vue/src/components/MessageSnackbar/MessageSnackbar.vue","MessageSnackbar.vue"],"names":[],"mappings":"AAoIA;AACA;IACA,0BAAA;IACA,mBAAA;ACnIE;AACF;ADqIA;AACA;IACA,+BAAA;ACnIE;AACF","file":"MessageSnackbar.vue","sourcesContent":["<template>\n  <div>\n    <div\n      v-for=\"(snack, index) in snackbars\"\n      :key=\"index\"\n    >\n      <div>\n        <v-snackbar\n          v-model=\"snack.show\"\n          :color=\"snack.color\"\n          :multi-line=\"snack.mode\"\n          :timeout=\"snack.timeout\"\n          :style=\"'bottom:'+ index +'em;'\"\n          class=\"dav-snackbar\"\n        >\n          <div\n            v-html=\"snack.text\"\n          />\n          <template v-slot:action>\n            <v-btn\n              v-if=\"snack.btnClose\"\n              dark\n              text\n              @click=\"snack.show = false\"\n            >\n              Fechar\n            </v-btn>\n          </template>\n        </v-snackbar>\n      </div>\n    </div>\n    <!-- SnackBar -->\n    <v-snackbar\n      v-model=\"snackbar.show\"\n      :color=\"snackbar.color\"\n      :multi-line=\"snackbar.mode\"\n      :timeout=\"snackbar.timeout\"\n      class=\"dav-snackbar\"\n    >\n      <div v-html=\"snackbar.text\" />\n      <template v-slot:action>\n        <v-btn\n          v-if=\"snackbar.btnClose\"\n          dark\n          text\n          @click=\"snackbar.show = false\"\n        >\n          Fechar\n        </v-btn>\n      </template>\n    </v-snackbar>\n  </div>\n</template>\n\n<script>\n  export default {\n    name: 'MessageSnackbar',\n    tag: 'primeit-message-snackbar',\n    data: () => ({\n      snackbars: [],\n      snackbar: {\n        show: false,\n        color: '',\n        mode: 'multi-line',\n        timeout: 3500,\n        text: '',\n        btnClose: false,\n      },\n    }),\n    watch: {\n      $route (to, from) {\n        if (this.snackbars && this.snackbars.length > 0) {\n          setTimeout(function () { this.snackbars = []; }, 4500);\n        }\n      },\n    },\n    created () {\n      this.listenEvents();\n    },\n    methods: {\n      listenEvents () {\n        const vm = this;\n        vm.$root.$on('show-snackbar', function (options) {\n          vm.showSnackbar({ text: options.text, btnClose: options.btnClose, timeout: options.timeout, color: options.color });\n        });\n        vm.$root.$on('show-snackbar-multiple', function (msgs) {\n          vm.showSnackbarMultiple(msgs);\n        });\n      },\n      showSnackbar (options) {\n        // para resolver o fato do vuetify mudado timeout de 0 para -1\n        let timeout = options.timeout && options.timeout > 0 ? options.timeout : -1;\n        timeout = !options.btnClose && timeout === -1 ? 4000 : timeout;\n        this.snackbar.text = options.text ? options.text : options.message;\n        this.snackbar.show = true;\n        this.snackbar.btnClose = options.btnClose;\n        this.snackbar.color = options.color ? options.color : options.type;\n        this.snackbar.timeout = timeout;\n        this.snackbars = [];\n      },\n      showSnackbarMultiple (msgs) {\n        this.snackbars = [];\n        msgs.forEach(element => {\n          let timeout = element.timeout && element.timeout > 0 ? element.timeout : -1;\n          timeout = !element.btnClose && timeout === -1 ? 4000 : timeout;\n          element.show = true;\n          element.text = element.text ? element.text : element.message;\n          element.btnClose = element.btnClose === undefined ? true : element.btnClose;\n          element.color = element.color ? element.color : element.type;\n          element.timeout = timeout;\n          this.snackbars.push(element);\n        });\n      },\n    },\n  };\n</script>\n<style lang=\"stylus\" scoped>\n.multiple-snackbar {\n  width: 100%;\n}\n\n.v-snack__wrapper {\n  width: 100%;\n}\n\n@media only screen and (min-width: 600px) {\n  .v-snack__wrapper {\n    width: 100%;\n  }\n}\n</style>\n<style lang=\"stylus\">\n@media (max-width: 400px){\n  .dav-snackbar > div {\n    min-width: 100% !important;\n    margin-bottom: 80px;\n  }\n}\n@media (max-width: 550px){\n  .dav-snackbar {\n    padding-bottom: 80px !important;\n  }\n}\n</style>\n","@media (max-width: 400px) {\n  .dav-snackbar > div {\n    min-width: 100% !important;\n    margin-bottom: 80px;\n  }\n}\n@media (max-width: 550px) {\n  .dav-snackbar {\n    padding-bottom: 80px !important;\n  }\n}\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$k = "data-v-7054a37c";
  /* module identifier */
  const __vue_module_identifier__$k = undefined;
  /* functional template */
  const __vue_is_functional_template__$k = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$k = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$i, staticRenderFns: __vue_staticRenderFns__$i },
    __vue_inject_styles__$k,
    __vue_script__$k,
    __vue_scope_id__$k,
    __vue_is_functional_template__$k,
    __vue_module_identifier__$k,
    false,
    createInjector,
    undefined,
    undefined
  );

const MessageSnackbar = __vue_component__$k;

//
//
//
//
//
//
//
//
//

  var script$j = {
    tag: 'dav-btn',
    props: {
      color: {
        type: String,
      },
      secondsDisabled: {
        type: Number,
      },
    },
    data () {
      return {
        buttonDisabled: false,
      };
    },
    methods: {
      disableButtonForSeconds () {
        const sec = this.secondsDisabled ? this.secondsDisabled : 30;

        this.buttonDisabled = true;
        setTimeout(() => {
          this.buttonDisabled = false;
        }, sec * 1000);
      },
    },
  };

/* script */
const __vue_script__$j = script$j;

/* template */
var __vue_render__$h = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "v-btn",
    {
      attrs: {
        color: _vm.color ? _vm.color : "primary",
        disabled: _vm.buttonDisabled,
      },
      on: {
        click: function ($event) {
          _vm.disableButtonForSeconds(), _vm.$emit("click");
        },
      },
    },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__$h = [];
__vue_render__$h._withStripped = true;

  /* style */
  const __vue_inject_styles__$j = function (inject) {
    if (!inject) return
    inject("data-v-3da21006_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"Button.vue"}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$j = "data-v-3da21006";
  /* module identifier */
  const __vue_module_identifier__$j = undefined;
  /* functional template */
  const __vue_is_functional_template__$j = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$j = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$h, staticRenderFns: __vue_staticRenderFns__$h },
    __vue_inject_styles__$j,
    __vue_script__$j,
    __vue_scope_id__$j,
    __vue_is_functional_template__$j,
    __vue_module_identifier__$j,
    false,
    createInjector,
    undefined,
    undefined
  );

const Button = __vue_component__$j;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  var script$i = {
    tag: 'dav-screening-checkbox',
    name: 'DavScreeningCheckbox',
    props: {
      options: {
        type: Array,
      },
      title: {
        type: String,
      },
      required: {
        type: Boolean,
        default: false,
      },
    },
    data: () => {
      return {
        checkboxes: [],
      };
    },
    methods: {
      updateValue: function () {
        this.adjustValidation();
        this.$emit('input', this.checkboxes);
      },
      requiredRule: function () {
        return [
          v => this.checkboxes.filter(check => !!check).length > 0 || this.$vuetify.lang.t('$vuetify.pages.screening.required'),
        ];
      },
      /**
       * It was needed because checkboxes errors wouldnt reset when one is checked
       */
      adjustValidation () {
        Object.keys(this.$refs).forEach(refName => {
          this.$refs[refName][0].validate(true);
        });
      },
    },
  };

/* script */
const __vue_script__$i = script$i;

/* template */
var __vue_render__$g = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [
    _c(
      "div",
      [
        _c("p", { staticClass: "mb-2 pb-2 body-1" }, [
          _vm._v("\n     " + _vm._s(_vm.title) + "\n    "),
        ]),
        _vm._v(" "),
        _vm._l(_vm.options, function (option, index) {
          return _c("v-checkbox", {
            key: index,
            ref: "checkboxes_" + index,
            refInFor: true,
            class:
              index < _vm.options.length - 1
                ? "mt-0 mb-2 pb-2 pt-0"
                : "mt-0 mb-1 pb-1 pt-0",
            attrs: {
              value: option,
              label: option,
              "hide-details": index < _vm.options.length - 1,
              rules: _vm.required ? _vm.requiredRule() : [],
            },
            on: {
              change: function ($event) {
                return _vm.updateValue()
              },
            },
            model: {
              value: _vm.checkboxes[index],
              callback: function ($$v) {
                _vm.$set(_vm.checkboxes, index, $$v);
              },
              expression: "checkboxes[index]",
            },
          })
        }),
      ],
      2
    ),
  ])
};
var __vue_staticRenderFns__$g = [];
__vue_render__$g._withStripped = true;

  /* style */
  const __vue_inject_styles__$i = function (inject) {
    if (!inject) return
    inject("data-v-ea840820_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*  */\n", map: {"version":3,"sources":["/home/daniel/Projects/dav/frontend/dav-frontend-components-vue/src/components/Screening/fields/Checkbox.vue"],"names":[],"mappings":";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;AAgEA,KAAA","file":"Checkbox.vue","sourcesContent":["<template>\n  <div>\n    <div>\n      <p class=\"mb-2 pb-2 body-1\">\n       {{ title }}\n      </p>\n      <v-checkbox\n        v-for=\"(option, index) in options\"\n        :key=\"index\"\n        :ref=\"`checkboxes_${index}`\"\n        v-model=\"checkboxes[index]\"\n        :value=\"option\"\n        :label=\"option\"\n        :hide-details=\"index < (options.length - 1)\"\n        :rules=\"required ? requiredRule() : []\"\n        :class=\"index < (options.length - 1) ? 'mt-0 mb-2 pb-2 pt-0' : 'mt-0 mb-1 pb-1 pt-0'\"\n        @change=\"updateValue()\"\n      />\n    </div>\n  </div>\n</template>\n<script>\n  export default {\n    tag: 'dav-screening-checkbox',\n    name: 'DavScreeningCheckbox',\n    props: {\n      options: {\n        type: Array,\n      },\n      title: {\n        type: String,\n      },\n      required: {\n        type: Boolean,\n        default: false,\n      },\n    },\n    data: () => {\n      return {\n        checkboxes: [],\n      };\n    },\n    methods: {\n      updateValue: function () {\n        this.adjustValidation();\n        this.$emit('input', this.checkboxes);\n      },\n      requiredRule: function () {\n        return [\n          v => this.checkboxes.filter(check => !!check).length > 0 || this.$vuetify.lang.t('$vuetify.pages.screening.required'),\n        ];\n      },\n      /**\n       * It was needed because checkboxes errors wouldnt reset when one is checked\n       */\n      adjustValidation () {\n        Object.keys(this.$refs).forEach(refName => {\n          this.$refs[refName][0].validate(true);\n        });\n      },\n    },\n  };\n</script>\n<style scoped>\n/*  */\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$i = "data-v-ea840820";
  /* module identifier */
  const __vue_module_identifier__$i = undefined;
  /* functional template */
  const __vue_is_functional_template__$i = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$i = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$g, staticRenderFns: __vue_staticRenderFns__$g },
    __vue_inject_styles__$i,
    __vue_script__$i,
    __vue_scope_id__$i,
    __vue_is_functional_template__$i,
    __vue_module_identifier__$i,
    false,
    createInjector,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  var script$h = {
    tag: 'dav-screening-radio',
    name: 'DavScreeningRadio',
    props: {
      options: {
        type: Array,
      },
      title: {
        type: String,
      },
      required: {
        type: Boolean,
        default: false,
      },
    },
    data: () => {
      return {
        radio: undefined,
      };
    },
    methods: {
      updateValue: function () {
        this.$emit('input', this.radio);
      },
      requiredRule: function () {
        return [
          v => !!v || this.$vuetify.lang.t('$vuetify.pages.screening.required'),
        ];
      },
    },
  };

/* script */
const __vue_script__$h = script$h;

/* template */
var __vue_render__$f = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _c("p", { staticClass: "mb-0 pb-0 body-1" }, [
        _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
      ]),
      _vm._v(" "),
      _c(
        "v-radio-group",
        {
          staticClass: "mt-0 pb-0 mb-2",
          attrs: {
            required: _vm.required,
            rules: _vm.required ? _vm.requiredRule() : [],
          },
          on: {
            change: function ($event) {
              return _vm.updateValue()
            },
          },
          model: {
            value: _vm.radio,
            callback: function ($$v) {
              _vm.radio = $$v;
            },
            expression: "radio",
          },
        },
        _vm._l(_vm.options, function (option, index) {
          return _c("v-radio", {
            key: index,
            staticClass: "mt-1 pt-1",
            attrs: { value: option, label: option },
          })
        }),
        1
      ),
    ],
    1
  )
};
var __vue_staticRenderFns__$f = [];
__vue_render__$f._withStripped = true;

  /* style */
  const __vue_inject_styles__$h = function (inject) {
    if (!inject) return
    inject("data-v-7df8b4d8_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*  */\n", map: {"version":3,"sources":["/home/daniel/Projects/dav/frontend/dav-frontend-components-vue/src/components/Screening/fields/Radio.vue"],"names":[],"mappings":";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;AAwDA,KAAA","file":"Radio.vue","sourcesContent":["<template>\n  <div>\n    <p class=\"mb-0 pb-0 body-1\">\n      {{ title }}\n    </p>\n    <v-radio-group\n      v-model=\"radio\"\n      class=\"mt-0 pb-0 mb-2\"\n      :required=\"required\"\n      :rules=\"required ? requiredRule() : []\"\n      @change=\"updateValue()\"\n    >\n      <v-radio\n        v-for=\"(option, index) in options\"\n        :key=\"index\"\n        :value=\"option\"\n        :label=\"option\"\n        class=\"mt-1 pt-1\"\n      />\n    </v-radio-group>\n  </div>\n</template>\n<script>\n  export default {\n    tag: 'dav-screening-radio',\n    name: 'DavScreeningRadio',\n    props: {\n      options: {\n        type: Array,\n      },\n      title: {\n        type: String,\n      },\n      required: {\n        type: Boolean,\n        default: false,\n      },\n    },\n    data: () => {\n      return {\n        radio: undefined,\n      };\n    },\n    methods: {\n      updateValue: function () {\n        this.$emit('input', this.radio);\n      },\n      requiredRule: function () {\n        return [\n          v => !!v || this.$vuetify.lang.t('$vuetify.pages.screening.required'),\n        ];\n      },\n    },\n  };\n</script>\n<style scoped>\n/*  */\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$h = "data-v-7df8b4d8";
  /* module identifier */
  const __vue_module_identifier__$h = undefined;
  /* functional template */
  const __vue_is_functional_template__$h = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$h = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$f, staticRenderFns: __vue_staticRenderFns__$f },
    __vue_inject_styles__$h,
    __vue_script__$h,
    __vue_scope_id__$h,
    __vue_is_functional_template__$h,
    __vue_module_identifier__$h,
    false,
    createInjector,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$g = {
  tag: 'dav-screening-select',
  name: 'DavScreeningSelect',
  props: {
    options: {
      type: Array,
    },
    title: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    ismobile: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      select: undefined,
    };
  },
  methods: {
    updateValue: function () {
      this.$emit('input', this.select);
    },
    requiredRule: function () {
      return [(v) => !!v || this.$vuetify.lang.t('$vuetify.pages.screening.required')];
    },
  },
};

/* script */
const __vue_script__$g = script$g;

/* template */
var __vue_render__$e = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _c("v-select", {
        staticClass: "mt-0 mb-0 pb-0 pt-0",
        attrs: {
          items: _vm.options,
          label: _vm.title,
          title: _vm.title,
          hint: _vm.title,
          filled: !_vm.ismobile,
          clearable: "",
          rules: _vm.required ? _vm.requiredRule() : [],
        },
        on: {
          change: function ($event) {
            return _vm.updateValue()
          },
        },
        model: {
          value: _vm.select,
          callback: function ($$v) {
            _vm.select = $$v;
          },
          expression: "select",
        },
      }),
    ],
    1
  )
};
var __vue_staticRenderFns__$e = [];
__vue_render__$e._withStripped = true;

  /* style */
  const __vue_inject_styles__$g = function (inject) {
    if (!inject) return
    inject("data-v-45fe1d9b_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*  */\n", map: {"version":3,"sources":["/home/daniel/Projects/dav/frontend/dav-frontend-components-vue/src/components/Screening/fields/Select.vue"],"names":[],"mappings":";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;AAoDA,KAAA","file":"Select.vue","sourcesContent":["<template>\n  <div>\n    <v-select\n      v-model=\"select\"\n      :items=\"options\"\n      :label=\"title\"\n      :title=\"title\"\n      :hint=\"title\"\n      :filled=\"!ismobile\"\n      clearable\n      class=\"mt-0 mb-0 pb-0 pt-0\"\n      :rules=\"required ? requiredRule() : []\"\n      @change=\"updateValue()\"\n    />\n  </div>\n</template>\n<script>\nexport default {\n  tag: 'dav-screening-select',\n  name: 'DavScreeningSelect',\n  props: {\n    options: {\n      type: Array,\n    },\n    title: {\n      type: String,\n    },\n    required: {\n      type: Boolean,\n      default: false,\n    },\n    ismobile: {\n      type: Boolean,\n      default: false,\n    },\n  },\n  data: () => {\n    return {\n      select: undefined,\n    };\n  },\n  methods: {\n    updateValue: function () {\n      this.$emit('input', this.select);\n    },\n    requiredRule: function () {\n      return [(v) => !!v || this.$vuetify.lang.t('$vuetify.pages.screening.required')];\n    },\n  },\n};\n</script>\n<style scoped>\n/*  */\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$g = "data-v-45fe1d9b";
  /* module identifier */
  const __vue_module_identifier__$g = undefined;
  /* functional template */
  const __vue_is_functional_template__$g = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$g = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$e, staticRenderFns: __vue_staticRenderFns__$e },
    __vue_inject_styles__$g,
    __vue_script__$g,
    __vue_scope_id__$g,
    __vue_is_functional_template__$g,
    __vue_module_identifier__$g,
    false,
    createInjector,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$f = {
  tag: 'dav-screening-textarea',
  name: 'DavScreeningTextarea',
  props: {
    options: {
      type: Array,
    },
    title: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: Number,
      required: false,
    },
    ismobile: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      textarea: undefined,
    };
  },
  computed: {},
  methods: {
    updateValue: function () {
      if (this.textarea) {
        this.$emit('input', this.textarea);
      }
    },
    requiredRule: function () {
      return [(v) => !!v || this.$vuetify.lang.t('$vuetify.pages.screening.required')];
    },
  },
};

/* script */
const __vue_script__$f = script$f;

/* template */
var __vue_render__$d = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _c("v-textarea", {
        staticClass: "mt-0 pt-0",
        attrs: {
          label: _vm.title,
          hint: _vm.title,
          title: _vm.title,
          filled: !_vm.ismobile,
          rows: _vm.ismobile ? 1 : 4,
          "auto-grow": "",
          required: _vm.required,
          rules: _vm.required ? _vm.requiredRule() : [],
          maxlength: _vm.maxlength,
        },
        on: {
          input: function ($event) {
            return _vm.updateValue()
          },
        },
        model: {
          value: _vm.textarea,
          callback: function ($$v) {
            _vm.textarea = $$v;
          },
          expression: "textarea",
        },
      }),
    ],
    1
  )
};
var __vue_staticRenderFns__$d = [];
__vue_render__$d._withStripped = true;

  /* style */
  const __vue_inject_styles__$f = function (inject) {
    if (!inject) return
    inject("data-v-c909a8aa_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*  */\n", map: {"version":3,"sources":["/home/daniel/Projects/dav/frontend/dav-frontend-components-vue/src/components/Screening/fields/TextArea.vue"],"names":[],"mappings":";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;AA6DA,KAAA","file":"TextArea.vue","sourcesContent":["<template>\n  <div>\n    <v-textarea\n      v-model=\"textarea\"\n      :label=\"title\"\n      :hint=\"title\"\n      :title=\"title\"\n      class=\"mt-0 pt-0\"\n      :filled=\"!ismobile\"\n      :rows=\"ismobile ? 1 : 4\"\n      auto-grow\n      :required=\"required\"\n      :rules=\"required ? requiredRule() : []\"\n      :maxlength=\"maxlength\"\n      @input=\"updateValue()\"\n    />\n  </div>\n</template>\n<script>\nexport default {\n  tag: 'dav-screening-textarea',\n  name: 'DavScreeningTextarea',\n  props: {\n    options: {\n      type: Array,\n    },\n    title: {\n      type: String,\n    },\n    required: {\n      type: Boolean,\n      default: false,\n    },\n    maxlength: {\n      type: Number,\n      required: false,\n    },\n    ismobile: {\n      type: Boolean,\n      default: false,\n    },\n  },\n  data: () => {\n    return {\n      textarea: undefined,\n    };\n  },\n  computed: {},\n  methods: {\n    updateValue: function () {\n      if (this.textarea) {\n        this.$emit('input', this.textarea);\n      }\n    },\n    requiredRule: function () {\n      return [(v) => !!v || this.$vuetify.lang.t('$vuetify.pages.screening.required')];\n    },\n  },\n};\n</script>\n<style scoped>\n/*  */\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$f = "data-v-c909a8aa";
  /* module identifier */
  const __vue_module_identifier__$f = undefined;
  /* functional template */
  const __vue_is_functional_template__$f = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$f = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$d, staticRenderFns: __vue_staticRenderFns__$d },
    __vue_inject_styles__$f,
    __vue_script__$f,
    __vue_scope_id__$f,
    __vue_is_functional_template__$f,
    __vue_module_identifier__$f,
    false,
    createInjector,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$e = {
  tag: 'dav-screening-textfield',
  name: 'DavScreeningTextfield',
  props: {
    options: {
      type: Array,
    },
    title: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: Number,
      required: false,
    },
    ismobile: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      textfield: undefined,
    };
  },
  computed: {},
  methods: {
    updateValue: function () {
      this.$emit('input', this.textfield);
    },
    requiredRule: function () {
      return [(v) => !!v || this.$vuetify.lang.t('$vuetify.pages.screening.required')];
    },
  },
};

/* script */
const __vue_script__$e = script$e;

/* template */
var __vue_render__$c = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _c("v-text-field", {
        staticClass: "mt-0 pt-0",
        attrs: {
          label: _vm.title,
          hint: _vm.title,
          title: _vm.title,
          filled: !_vm.ismobile,
          rules: _vm.required ? _vm.requiredRule() : [],
          required: _vm.required,
          maxlength: _vm.maxlength,
        },
        on: {
          input: function ($event) {
            return _vm.updateValue()
          },
        },
        model: {
          value: _vm.textfield,
          callback: function ($$v) {
            _vm.textfield = $$v;
          },
          expression: "textfield",
        },
      }),
    ],
    1
  )
};
var __vue_staticRenderFns__$c = [];
__vue_render__$c._withStripped = true;

  /* style */
  const __vue_inject_styles__$e = function (inject) {
    if (!inject) return
    inject("data-v-4da35728_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*  */\n", map: {"version":3,"sources":["/home/daniel/Projects/dav/frontend/dav-frontend-components-vue/src/components/Screening/fields/TextField.vue"],"names":[],"mappings":";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;AAyDA,KAAA","file":"TextField.vue","sourcesContent":["<template>\n  <div>\n    <v-text-field\n      v-model=\"textfield\"\n      :label=\"title\"\n      :hint=\"title\"\n      :title=\"title\"\n      class=\"mt-0 pt-0\"\n      :filled=\"!ismobile\"\n      :rules=\"required ? requiredRule() : []\"\n      :required=\"required\"\n      :maxlength=\"maxlength\"\n      @input=\"updateValue()\"\n    />\n  </div>\n</template>\n<script>\nexport default {\n  tag: 'dav-screening-textfield',\n  name: 'DavScreeningTextfield',\n  props: {\n    options: {\n      type: Array,\n    },\n    title: {\n      type: String,\n    },\n    required: {\n      type: Boolean,\n      default: false,\n    },\n    maxlength: {\n      type: Number,\n      required: false,\n    },\n    ismobile: {\n      type: Boolean,\n      default: false,\n    },\n  },\n  data: () => {\n    return {\n      textfield: undefined,\n    };\n  },\n  computed: {},\n  methods: {\n    updateValue: function () {\n      this.$emit('input', this.textfield);\n    },\n    requiredRule: function () {\n      return [(v) => !!v || this.$vuetify.lang.t('$vuetify.pages.screening.required')];\n    },\n  },\n};\n</script>\n<style scoped>\n/*  */\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$e = "data-v-4da35728";
  /* module identifier */
  const __vue_module_identifier__$e = undefined;
  /* functional template */
  const __vue_is_functional_template__$e = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$e = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$c, staticRenderFns: __vue_staticRenderFns__$c },
    __vue_inject_styles__$e,
    __vue_script__$e,
    __vue_scope_id__$e,
    __vue_is_functional_template__$e,
    __vue_module_identifier__$e,
    false,
    createInjector,
    undefined,
    undefined
  );

//

var script$d = {
  tag: 'dav-screening-form',
  name: 'DavScreeningForm',
  components: {
    DavScreeningCheckbox: __vue_component__$i,
    DavScreeningRadio: __vue_component__$h,
    DavScreeningSelect: __vue_component__$g,
    DavScreeningTextArea: __vue_component__$f,
    DavScreeningTextField: __vue_component__$e,
  },
  props: {
    form: {
      type: Object,
    },
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    questions: [],
    responses: [],
  }),
  computed: {},
  watch: {},
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    getComponent(model) {
      const fieldComponents = {
        CHECK_BOX: 'DavScreeningCheckbox',
        RADIO_BUTTON: 'DavScreeningRadio',
        SELECT: 'DavScreeningSelect',
        TEXT_AREA: 'DavScreeningTextArea',
        TEXT_FIELD: 'DavScreeningTextField',
      };
      if (model in fieldComponents) {
        return fieldComponents[model];
      }
    },
    updateResponses(title, index, value) {
      this.responses[index] = {
        question: title,
        answer: value,
      };
      const responses = JSON.parse(JSON.stringify(this.responses));
      this.$emit(
        'responses',
        responses.filter((r) => !!r)
      );
    },
  },
};

/* script */
const __vue_script__$d = script$d;

/* template */
var __vue_render__$b = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "v-form",
    { ref: "form" },
    _vm._l(_vm.form.fields, function (field, index) {
      return _vm.form && _vm.form.fields
        ? _c(
            "v-row",
            { key: index },
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(_vm.getComponent(field.model), {
                    tag: "component",
                    attrs: {
                      options: field.options,
                      title: field.title,
                      required: field.required,
                      maxlength: field.maxlength,
                      ismobile: _vm.mobile,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.updateResponses(field.title, index, $event)
                      },
                    },
                    model: {
                      value: _vm.questions[index],
                      callback: function ($$v) {
                        _vm.$set(_vm.questions, index, $$v);
                      },
                      expression: "questions[index]",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e()
    }),
    1
  )
};
var __vue_staticRenderFns__$b = [];
__vue_render__$b._withStripped = true;

  /* style */
  const __vue_inject_styles__$d = function (inject) {
    if (!inject) return
    inject("data-v-67575901_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"Form.vue"}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$d = "data-v-67575901";
  /* module identifier */
  const __vue_module_identifier__$d = undefined;
  /* functional template */
  const __vue_is_functional_template__$d = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$d = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$b, staticRenderFns: __vue_staticRenderFns__$b },
    __vue_inject_styles__$d,
    __vue_script__$d,
    __vue_scope_id__$d,
    __vue_is_functional_template__$d,
    __vue_module_identifier__$d,
    false,
    createInjector,
    undefined,
    undefined
  );

const ScreeningForm = __vue_component__$d;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$c = {
  name: 'UserPermissions',
  props: {
    editable: { type: Boolean, default: true },
    disabled: { type: Boolean, required: false, default: false },
    data: Array,
  },
  tag: 'user-permissions',

  data: (vm) => ({
    selectedOptions: [],
    id: '',
    vm,
    all: false,
    permissions: {
      login_consultorio: false,
      access_emergency: false,
      access_person_schedule: false,
      access_appointments: false,
      access_request_appointment: false,
    },
  }),

  computed: {
    getDefaultUserPermissions() {
      return this.$store.getters['domain/GET_DEFAULT_USER_PERMISSIONS'];
    },
    getPermissionsData() {
      return this.getDefaultUserPermissions.filter(obj => obj.code !== 'access_request_appointment').map((opt) => {
        return { id: opt.code, name: opt.value };
      });
    },
    items() {
      return [
        {
          id: 1,
          name: 'Todas',
          disabled: !this.disabled,
          children: this.getPermissionsData,
        },
      ];
    },
  },

  watch: {
    getDefaultUserPermissions(val) {
      this.selectedOptions = this.data ? this.data : val.map((opt) => opt.code);
    },

    data(val) {
      if (val) {
        this.selectedOptions = val;
      }
    },

    selectedOptions(val) {
      if (val.length == 4) {
        this.all = true;

        for (let item in this.permissions) {
          this.permissions[item] = true;
        }
      } else {
        this.all = false;
        for (let item in this.permissions) {
          if (this.selectedOptions.includes(item)) {
            this.permissions[item] = true;
          } else {
            this.permissions[item] = false;
          }
        }
      }

      this.$emit('userPermissions', val);
    },
  },

  mounted() {
    this.selectedOptions = this.data ? this.data : this.getDefaultUserPermissions.map((opt) => opt.code);
    this.id = `${this.$route.path.split('/')[1]}__user_permissions`;
  },

  methods: {
    changeAll() {
      let val = this.all;
      if (val) {
        for (let item in this.permissions) {
          this.permissions[item] = true;

          if (!this.selectedOptions.includes(item)) {
            this.selectedOptions.push(item);
          }
        }
        val = true;
      } else {
        this.selectedOptions = [];
        for (let item in this.permissions) {
          this.permissions[item] = false;
        }
        val = false;
      }
    },
    permission(id) {
      let val = this.permissions[id];

      if (val) {
        this.selectedOptions.push(id);
      } else {
        this.selectedOptions.splice(this.selectedOptions.indexOf(id), 1);
      }
    },
  },
};

/* script */
const __vue_script__$c = script$c;

/* template */
var __vue_render__$a = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "v-col",
    { staticClass: "grey lighten-3 px-2 mb-4" },
    [
      _c("v-subheader", { staticClass: "black--text pa-6" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$vuetify.lang.t("$vuetify.label.permissions")) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("v-treeview", {
        attrs: {
          "item-disabled": _vm.editable ? "" : "disabled",
          items: _vm.items,
        },
        scopedSlots: _vm._u([
          {
            key: "prepend",
            fn: function (ref) {
              var item = ref.item;
              return [
                item.children
                  ? [
                      _c("v-checkbox", {
                        staticClass: "black-label",
                        attrs: {
                          id: _vm.id + "_all",
                          label: item.name,
                          disabled: _vm.disabled,
                          color: "primary",
                        },
                        on: { change: _vm.changeAll },
                        model: {
                          value: _vm.all,
                          callback: function ($$v) {
                            _vm.all = $$v;
                          },
                          expression: "all",
                        },
                      }),
                    ]
                  : [
                      _c("v-checkbox", {
                        staticClass: "black-label",
                        attrs: {
                          id: _vm.id + "_" + item.id,
                          label: item.name,
                          disabled: _vm.disabled,
                          color: "primary",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.permission(item.id)
                          },
                        },
                        model: {
                          value: _vm.permissions[item.id],
                          callback: function ($$v) {
                            _vm.$set(_vm.permissions, item.id, $$v);
                          },
                          expression: "permissions[item.id]",
                        },
                      }),
                    ],
              ]
            },
          },
          {
            key: "label",
            fn: function (ref) {
              ref.item;
              return undefined
            },
          },
        ]),
        model: {
          value: _vm.selectedOptions,
          callback: function ($$v) {
            _vm.selectedOptions = $$v;
          },
          expression: "selectedOptions",
        },
      }),
    ],
    1
  )
};
var __vue_staticRenderFns__$a = [];
__vue_render__$a._withStripped = true;

  /* style */
  const __vue_inject_styles__$c = function (inject) {
    if (!inject) return
    inject("data-v-6e4ac784_0", { source: "\n.black-label label[data-v-6e4ac784] {\n  color: black !important;\n}\n", map: {"version":3,"sources":["/home/daniel/Projects/dav/frontend/dav-frontend-components-vue/src/components/UserPermissions/UserPermissions.vue"],"names":[],"mappings":";AAyJA;EACA,uBAAA;AACA","file":"UserPermissions.vue","sourcesContent":["<template>\n  <v-col class=\"grey lighten-3 px-2 mb-4\">\n    <v-subheader class=\"black--text pa-6\">\n      {{ $vuetify.lang.t('$vuetify.label.permissions') }}\n    </v-subheader>\n\n    <v-treeview v-model=\"selectedOptions\" :item-disabled=\"editable ? '' : 'disabled'\" :items=\"items\">\n      <template v-slot:prepend=\"{ item }\">\n        <template v-if=\"item.children\">\n          <v-checkbox\n            :id=\"`${id}_all`\"\n            :label=\"item.name\"\n            :disabled=\"disabled\"\n            color=\"primary\"\n            v-model=\"all\"\n            @change=\"changeAll\"\n            class=\"black-label\"\n          ></v-checkbox>\n        </template>\n        <template v-else>\n          <v-checkbox\n            :id=\"`${id}_${item.id}`\"\n            :label=\"item.name\"\n            :disabled=\"disabled\"\n            v-model=\"permissions[item.id]\"\n            @change=\"permission(item.id)\"\n            color=\"primary\"\n            class=\"black-label\"\n          ></v-checkbox>\n        </template>\n      </template>\n      <template v-slot:label=\"{ item }\"> </template>\n    </v-treeview>\n  </v-col>\n</template>\n\n<script>\nexport default {\n  name: 'UserPermissions',\n  props: {\n    editable: { type: Boolean, default: true },\n    disabled: { type: Boolean, required: false, default: false },\n    data: Array,\n  },\n  tag: 'user-permissions',\n\n  data: (vm) => ({\n    selectedOptions: [],\n    id: '',\n    vm,\n    all: false,\n    permissions: {\n      login_consultorio: false,\n      access_emergency: false,\n      access_person_schedule: false,\n      access_appointments: false,\n      access_request_appointment: false,\n    },\n  }),\n\n  computed: {\n    getDefaultUserPermissions() {\n      return this.$store.getters['domain/GET_DEFAULT_USER_PERMISSIONS'];\n    },\n    getPermissionsData() {\n      return this.getDefaultUserPermissions.filter(obj => obj.code !== 'access_request_appointment').map((opt) => {\n        return { id: opt.code, name: opt.value };\n      });\n    },\n    items() {\n      return [\n        {\n          id: 1,\n          name: 'Todas',\n          disabled: !this.disabled,\n          children: this.getPermissionsData,\n        },\n      ];\n    },\n  },\n\n  watch: {\n    getDefaultUserPermissions(val) {\n      this.selectedOptions = this.data ? this.data : val.map((opt) => opt.code);\n    },\n\n    data(val) {\n      if (val) {\n        this.selectedOptions = val;\n      }\n    },\n\n    selectedOptions(val) {\n      if (val.length == 4) {\n        this.all = true;\n\n        for (let item in this.permissions) {\n          this.permissions[item] = true;\n        }\n      } else {\n        this.all = false;\n        for (let item in this.permissions) {\n          if (this.selectedOptions.includes(item)) {\n            this.permissions[item] = true;\n          } else {\n            this.permissions[item] = false;\n          }\n        }\n      }\n\n      this.$emit('userPermissions', val);\n    },\n  },\n\n  mounted() {\n    this.selectedOptions = this.data ? this.data : this.getDefaultUserPermissions.map((opt) => opt.code);\n    this.id = `${this.$route.path.split('/')[1]}__user_permissions`;\n  },\n\n  methods: {\n    changeAll() {\n      let val = this.all;\n      if (val) {\n        for (let item in this.permissions) {\n          this.permissions[item] = true;\n\n          if (!this.selectedOptions.includes(item)) {\n            this.selectedOptions.push(item);\n          }\n        }\n        val = true;\n      } else {\n        this.selectedOptions = [];\n        for (let item in this.permissions) {\n          this.permissions[item] = false;\n        }\n        val = false;\n      }\n    },\n    permission(id) {\n      let val = this.permissions[id];\n\n      if (val) {\n        this.selectedOptions.push(id);\n      } else {\n        this.selectedOptions.splice(this.selectedOptions.indexOf(id), 1);\n      }\n    },\n  },\n};\n</script>\n\n<style scoped>\n.black-label label {\n  color: black !important;\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$c = "data-v-6e4ac784";
  /* module identifier */
  const __vue_module_identifier__$c = undefined;
  /* functional template */
  const __vue_is_functional_template__$c = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$c = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$a, staticRenderFns: __vue_staticRenderFns__$a },
    __vue_inject_styles__$c,
    __vue_script__$c,
    __vue_scope_id__$c,
    __vue_is_functional_template__$c,
    __vue_module_identifier__$c,
    false,
    createInjector,
    undefined,
    undefined
  );

const UserPermissions = __vue_component__$c;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  var script$b = {
    name: 'UserAvatar',
    tag: 'dav-avatar',
    props: {
      imgSource: {
        type: String,
      },

      sourceSize: {
        type: Number,
        default: 50,
      },
    },
  };

/* script */
const __vue_script__$b = script$b;

/* template */
var __vue_render__$9 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "v-avatar",
    { attrs: { size: _vm.sourceSize, color: "grey lighten-4" } },
    [
      _vm.imgSource
        ? _c("v-img", { attrs: { src: _vm.imgSource } })
        : _c(
            "v-icon",
            {
              staticStyle: { color: "lightgrey" },
              attrs: { size: _vm.sourceSize },
            },
            [_vm._v("\n    person_outline\n  ")]
          ),
    ],
    1
  )
};
var __vue_staticRenderFns__$9 = [];
__vue_render__$9._withStripped = true;

  /* style */
  const __vue_inject_styles__$b = undefined;
  /* scoped */
  const __vue_scope_id__$b = undefined;
  /* module identifier */
  const __vue_module_identifier__$b = undefined;
  /* functional template */
  const __vue_is_functional_template__$b = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$b = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$9, staticRenderFns: __vue_staticRenderFns__$9 },
    __vue_inject_styles__$b,
    __vue_script__$b,
    __vue_scope_id__$b,
    __vue_is_functional_template__$b,
    __vue_module_identifier__$b,
    false,
    undefined,
    undefined,
    undefined
  );

const UserAvatar = __vue_component__$b;

//

var script$a = {
  name: 'Timezone',
  tag: 'timezone',
  props: {
    label: String,
    value: String,
    disabledProp: {
      required: false,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'primary'
    },
    outlined: {
      type: Boolean,
      default: false,
    }
  },
  data: (vm) => ({
    timezone: null,
    vm,
    id: null,
    disabled: null,
  }),
  computed: {
    defaultBrowserTimezone() {
      return moment$2.tz.guess();
    },
    momentTimezones() {
      return moment$2.tz.names();
    },
    timezoneItems() {
      return this.momentTimezones.map((opt) => {
        const name = opt.replace('_', ' ');
        return {
          text: `${name}  (GMT ${moment$2().tz(opt).format('Z')})`,
          value: opt,
        };
      });
    },
  },

  mounted() {
    if (!this.value) {
      this.setTimezone(this.defaultBrowserTimezone);
    }

    this.id = this.vm.$el.id;

    const disabled = this.vm.$attrs.disabled;

    if (disabled === undefined) {
      this.disabled = false;
    }
    else {
      this.disabled = disabled;
    }
  },

  methods: {
    setTimezone(val) {
      this.$emit('input', val);
    },
  },
};

/* script */
const __vue_script__$a = script$a;

/* template */
var __vue_render__$8 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("v-autocomplete", {
    attrs: {
      id: _vm.id,
      value: _vm.value,
      filled: !_vm.isMobile,
      outlined: _vm.outlined,
      color: _vm.color,
      items: _vm.timezoneItems,
      hint: _vm.label,
      title: _vm.label,
      label: _vm.label,
      disabled: _vm.disabled || _vm.disabledProp,
    },
    on: { input: _vm.setTimezone },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function (ref) {
          var item = ref.item;
          return [
            _c(
              "span",
              {
                attrs: {
                  id: _vm.id + "_" + item.value.toLowerCase().replace("/", "-"),
                },
              },
              [_vm._v("\n      " + _vm._s(item.value) + "\n    ")]
            ),
          ]
        },
      },
    ]),
  })
};
var __vue_staticRenderFns__$8 = [];
__vue_render__$8._withStripped = true;

  /* style */
  const __vue_inject_styles__$a = function (inject) {
    if (!inject) return
    inject("data-v-629b7be6_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"Timezone.vue"}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$a = "data-v-629b7be6";
  /* module identifier */
  const __vue_module_identifier__$a = undefined;
  /* functional template */
  const __vue_is_functional_template__$a = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$a = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
    __vue_inject_styles__$a,
    __vue_script__$a,
    __vue_scope_id__$a,
    __vue_is_functional_template__$a,
    __vue_module_identifier__$a,
    false,
    createInjector,
    undefined,
    undefined
  );

const Timezone = __vue_component__$a;

const AutocompleteState = (_uid) => {
  const module = {
    actions: {
      FETCH_DATA: async (context, params) => {
        let response;
        let json;

        try {
          response = await Fetcher(`${params.endpoint}/autocomplete?filter=${params.filter}`);
          json = await response.json();
        } catch (e) {
          json = {
            code: 400,
            message: e.message,
          };
        }

        if (params.method === 'getDestinationToSendMail') {
          if (json.data) {
            let data = json.data.filter((obj) => obj.text.indexOf('[EXC]') < 0);

            data = data.map(({ id, text }) => {
              return {
                id,
                text: text.replace(' | undefined', ''),
              };
            });
            json.data = data;
            context.commit('POPULATE_DATA', json);
          } else {
            context.commit('POPULATE_DATA', []);
          }
        } else {
          context.commit('POPULATE_DATA', json);
        }
      },
    },
    getters: {
      GET_DATA: (state) => {
        return JSON.parse(JSON.stringify(state[`data${_uid}`]));
      },
    },
    mutations: {
      POPULATE_DATA: (state, payload) => {
        if (payload) {
          state[`data${_uid}`] = payload;
        }
      },
    },
    namespaced: true,
    state: {
    },
  };
  module.state[`data${_uid}`] = null;
  return module;
};

//

var script$9 = {
  name: 'Autocomplete',
  tag: 'dav-autocomplete',
  props: {
    endpoint: {
      type: String,
      required: true,
    },
    method: {
      default: '',
      type: String,
      required: false,
    },
    filled: {
      type: Boolean,
      default: true,
    },
    clearable: Boolean,
    label: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    hint: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    chips: {
      type: Boolean,
      default: false,
    },
    smallChips: {
      type: Boolean,
      default: false,
    },
    deletableChips: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
    id: {
      type: String,
      default: '',
    },
    excludeDeleted: {
      type: Boolean,
      default: false,
    },
    persistentHint: {
      type: Boolean,
      default: false,
    },
    tagId: {
      type: String,
      default: '',
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      search: null,
      searchText: null,
      select: null,
      typingTimer: null,
      items: [],
      termsSearched: [],
    };
  },
  computed: {
    autocomplete() {
      return this.$store.getters[`autocomplete${this._uid}/GET_DATA`];
    },
  },
  watch: {
    search(val) {
      if (this.select) {
        return;
      }
      if (val && val.length > 2) {
        this.searchText = val;
      } else {
        this.searchText = null;
        this.loading = false;
      }
    },
    autocomplete(val) {
      this.loading = false;
      if (val.code === 200) {
        this.items = val.data;
        this.$emit('status', { code: 200 });
      } else {
        this.$emit('status', { code: 404 });
      }
    },
  },
  beforeCreate() {
    CommonState.registerModule(`autocomplete${this._uid}`, AutocompleteState(this._uid));
  },
  beforeDestroy() {
    CommonState.unregisterModule(`autocomplete${this._uid}`);
  },
  methods: {
    searchItems() {
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
      }

      this.typingTimer = setTimeout(() => {
        return this.executeQuery();
      }, 500);
    },
    executeQuery() {
      if (this.searchText && !this.termsSearched.some((item) => this.searchText.indexOf(item) === 0)) {
        let filter = this.searchText;

        if (this.excludeDeleted) {
          filter += '&excludeDeleted';
        }

        if (this.tagId) {
          filter += `&tagId=${this.tagId}`;
        }

        this.termsSearched.push(this.searchText);
        this.$store.dispatch(`autocomplete${this._uid}/FETCH_DATA`, {
          method: this.method,
          endpoint: this.endpoint,
          filter,
        });
        this.searchText = null;
        this.loading = true;
      }
    },
    updateValue: function () {
      this.$emit('input', this.select);
      this.select = null;
      this.search = '';
    },
  },
};

/* script */
const __vue_script__$9 = script$9;

/* template */
var __vue_render__$7 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _c("v-autocomplete", {
        attrs: {
          id: _vm.id,
          loading: _vm.loading,
          "search-input": _vm.search,
          "item-value": "id",
          "item-text": "text",
          "cache-items": "",
          "hide-no-data": "",
          multiple: _vm.multiple,
          items: _vm.items,
          disabled: _vm.disabled,
          clearable: _vm.clearable,
          label: _vm.label,
          title: _vm.title,
          hint: _vm.hint,
          "persistent-hint": _vm.persistentHint,
          filled: _vm.filled,
          chips: _vm.chips,
          "small-chips": _vm.smallChips,
          "deletable-chips": _vm.deletableChips,
          "return-object": _vm.returnObject,
          outlined: _vm.outlined,
          rules: _vm.rules,
          "hide-details": _vm.hideDetails,
        },
        on: {
          "update:searchInput": function ($event) {
            _vm.search = $event;
          },
          "update:search-input": function ($event) {
            _vm.search = $event;
          },
          keyup: function ($event) {
            return _vm.searchItems()
          },
          change: function ($event) {
            _vm.updateValue();
            _vm.$emit("change");
          },
        },
        model: {
          value: _vm.select,
          callback: function ($$v) {
            _vm.select = $$v;
          },
          expression: "select",
        },
      }),
    ],
    1
  )
};
var __vue_staticRenderFns__$7 = [];
__vue_render__$7._withStripped = true;

  /* style */
  const __vue_inject_styles__$9 = undefined;
  /* scoped */
  const __vue_scope_id__$9 = undefined;
  /* module identifier */
  const __vue_module_identifier__$9 = undefined;
  /* functional template */
  const __vue_is_functional_template__$9 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$9 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
    __vue_inject_styles__$9,
    __vue_script__$9,
    __vue_scope_id__$9,
    __vue_is_functional_template__$9,
    __vue_module_identifier__$9,
    false,
    undefined,
    undefined,
    undefined
  );

const Autocomplete = __vue_component__$9;

//

  var moment = require('moment-timezone');

  var script$8 = {
    name: 'DavTimezone',
    tag: 'dav-timezone',
    props: {
      inputTimezone: String,
    },
    data: () => ({
      currentTz: {
        browser: null,
        user: null,
        company: null,
      },
    }),
    computed: {
      currentUser () {
        return this.$store.getters['credential/CURRENT_USER'];
      },
      userInfo () {
        return this.currentUser.signInUserSession.idToken.payload;
      },
      setup () {
        return this.$store.getters['credential/SETUP'];
      },
    },
    watch: {
      currentTz: {
        deep: true,
        handler (val) {
          if (val.user) {
            this.setTimezone(val.user);
          } else if (val.company) {
            this.setTimezone(val.company);
          } else if (val.browser) {
            this.setTimezone(val.browser);
          }
        },
      },
      currentUser (val) {
        if (val && this.userInfo && this.userInfo.locale) {
          this.currentTz.user = this.userInfo.locale;
        }
      },
      setup (val) {
        if (val) {
          this.currentTz.company = val.timezone;
        }
      },
    },
    created () {
      this.currentTz.browser = moment.tz.guess();
      this.$root.$on('updateToken', (id) => {
        if (id === this.userInfo['cognito:username']) OldCommonSecurity.refreshToken();
      });
    },
    mounted () {},
    methods: {
      setTimezone (tz) {
        this.inputTimezone ? moment.tz.setDefault(this.inputTimezone) : moment.tz.setDefault(tz);
      },
    },
  };

/* script */
const __vue_script__$8 = script$8;

/* template */
var __vue_render__$6 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div")
};
var __vue_staticRenderFns__$6 = [];
__vue_render__$6._withStripped = true;

  /* style */
  const __vue_inject_styles__$8 = function (inject) {
    if (!inject) return
    inject("data-v-49c207aa_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"DavTimezone.vue"}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$8 = "data-v-49c207aa";
  /* module identifier */
  const __vue_module_identifier__$8 = undefined;
  /* functional template */
  const __vue_is_functional_template__$8 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$8 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
    __vue_inject_styles__$8,
    __vue_script__$8,
    __vue_scope_id__$8,
    __vue_is_functional_template__$8,
    __vue_module_identifier__$8,
    false,
    createInjector,
    undefined,
    undefined
  );

const DavTimezone = __vue_component__$8;

//
//
//
//
//
//
//
//

  var script$7 = {
    name: 'AcceptTermDialog',
    tag: 'dav-accept-term-dialog',
    props: {
      customUrlAccept: Boolean,
    },
    data: () => {
      return {
        dialog: false,
      };
    },
    computed: {
      resultTerm () {
        return this.$store.getters['credential/TERM_USER'];
      },
    },
    mounted () {
      this.dialog = true;
    },
    created () {
      this.$root.$on('displayTermAccept', (val) => {
        this.dialog = val;
      });
    },
  };

/* script */
const __vue_script__$7 = script$7;

/* template */
var __vue_render__$5 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v;
        },
        expression: "dialog",
      },
    },
    [
      _c("dav-accept-term", {
        attrs: { "custom-url-accept": _vm.customUrlAccept },
      }),
    ],
    1
  )
};
var __vue_staticRenderFns__$5 = [];
__vue_render__$5._withStripped = true;

  /* style */
  const __vue_inject_styles__$7 = function (inject) {
    if (!inject) return
    inject("data-v-005d5275_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"AcceptTermDialog.vue"}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$7 = "data-v-005d5275";
  /* module identifier */
  const __vue_module_identifier__$7 = undefined;
  /* functional template */
  const __vue_is_functional_template__$7 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$7 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$7,
    __vue_script__$7,
    __vue_scope_id__$7,
    __vue_is_functional_template__$7,
    __vue_module_identifier__$7,
    false,
    createInjector,
    undefined,
    undefined
  );

const AcceptTermDialog = __vue_component__$7;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$6 = {
  name: 'Nps',
  tag: 'primeit-nps-component',
  props: {
    value: Boolean,
    appointmentId: String,
    topMessage: String,
    protocol: String,
    state: {
      type: String,
      default: 'appointment',
    },
  },

  data: () => ({
    valid: true,
    loading: false,
    finishedRating: false,
    entity: {
      nps_rating: null,
      type_rating: '',
      rating_text: '',
    },
  }),
  computed: {
    setup() {
      return this.$store.getters['credential/SETUP'];
    },
    getRatingTypes() {
      return ['Sugestão', 'Elogio', 'Reclamação'];
    },
    feedback: function () {
      return this.$store.getters['common/FEEDBACK'];
    },
  },
  watch: {
    feedback: function (value) {
      if ('code' in value) {
        if (value.code === 200) {
          this.$root.$emit('show-snackbar', { text: value.message, timeout: 3000, btnClose: false, color: 'success' });
        } else {
          this.$root.$emit('show-snackbar', { text: value.message, timeout: 0, btnClose: true, color: 'error' });
        }
      }
      this.loading = false;
      this.valid = true;
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
  },
  async created() {},
  destroyed() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    getButtonColor(val) {
      switch (val) {
        case 0:
          return '#ad0009';
        case 1:
          return '#e00218';
        case 2:
          return '#ff4557';
        case 3:
          return '#ff8800';
        case 4:
          return '#ffa640';
        case 5:
          return '#f4ff29';
        case 6:
          return '#ffdd00';
        case 7:
          return '#77e368';
        case 8:
          return '#4bd439';
        case 9:
          return '#2ab518';
        case 10:
          return '#13a100';
      }
    },
    getBoxSize(size) {
      switch (size) {
        case size < 640:
          return '370px';
        case size >= 640:
          return '640px';
      }
    },

    isMobile() {
      if (screen.width <= 760) {
        return true;
      }
      return false;
    },
    emitFeedbackSuccess() {
      this.$emit('feedback-success');
    },
    async save() {
      if (this.entity.nps_rating) {
        this.valid = false;
        this.loading = true;
        this.finishedRating = true;

        const entityToSave = JSON.parse(JSON.stringify(this.entity));
        entityToSave.appointment_id = this.appointmentId;

        entityToSave.nps_rating = (entityToSave.nps_rating - 1).toString();

        this.$store
          .dispatch(`${this.state}/FETCH_SAVE_NPS`, {
            id: this.appointmentId,
            body: entityToSave,
            protocol: this.protocol,
          })
          .then(() => {
            this.emitFeedbackSuccess();
          })
          .catch(() => {});
      } else {
        this.$root.$emit('show-snackbar', {
          text: 'Selecione uma nota para seu atendimento.',
          timeout: 3000,
          btnClose: true,
          color: 'error',
        });
      }
    },
  },
};

/* script */
const __vue_script__$6 = script$6;

/* template */
var __vue_render__$4 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return !_vm.finishedRating
    ? _c(
        "v-container",
        { staticClass: "pr-4" },
        [
          _c(
            "v-card",
            {
              staticClass: "pa-2",
              class: _vm.topMessage ? "mt-8" : "",
              staticStyle: { border: "1px solid #c2c6ca" },
              attrs: {
                flat: "",
                "max-width": _vm.finishedRating
                  ? "370px"
                  : _vm.getBoxSize(_vm.$vuetify.breakpoint.width),
                color: "#fff",
              },
            },
            [
              _c(
                "div",
                [
                  _vm.topMessage
                    ? _c(
                        "v-card-title",
                        { staticClass: "text-center justify-center" },
                        [
                          _c(
                            "span",
                            {
                              style: "color: " + _vm.setup.theme.light.primary,
                            },
                            [_vm._v(_vm._s(_vm.topMessage))]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.finishedRating
                    ? _c(
                        "v-col",
                        {
                          staticClass: "text-left ml-1 mb-0",
                          attrs: { cols: "12" },
                        },
                        [
                          _c("span", [_vm._v(" " + _vm._s("A ") + " ")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v(" " + _vm._s(_vm.setup.name) + " "),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  " agradece pela sua preferência. Gostaríamos de saber sua opinião sobre a experiência da Telemedicina, ela é muito importante para nós!"
                                ) +
                                "\n        "
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.finishedRating
                ? _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: { method: "POST" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault();
                          return _vm.save.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.valid,
                        callback: function ($$v) {
                          _vm.valid = $$v;
                        },
                        expression: "valid",
                      },
                    },
                    [
                      _c(
                        "v-col",
                        { staticClass: "text-center", attrs: { cols: "12" } },
                        [
                          _c("span", { staticClass: "font-weight-medium" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  "Em uma escala de 0 a 10, o quanto você indicaria a teleconsulta para um amigo ou familiar?"
                                ) +
                                "\n        "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "text-center mb-6",
                              attrs: { cols: "12" },
                            },
                            [
                              _c("v-rating", {
                                staticClass: "mt-5",
                                attrs: {
                                  hover: "",
                                  length: "11",
                                  density: "compact",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "item",
                                      fn: function (props) {
                                        return [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass:
                                                "pa-3 white--text font-weight-bold nps-buttom",
                                              class: {
                                                "box-shadow":
                                                  _vm.entity.nps_rating ===
                                                  props.index + 1,
                                              },
                                              attrs: {
                                                id: "nps__score_" + props.index,
                                                color: _vm.getButtonColor(
                                                  props.index
                                                ),
                                              },
                                              on: { click: props.click },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(props.index) +
                                                    "\n                "
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  4159770694
                                ),
                                model: {
                                  value: _vm.entity.nps_rating,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.entity, "nps_rating", $$v);
                                  },
                                  expression: "entity.nps_rating",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "text-center mt-6 mb-6",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "font-weight-medium" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        "Por favor, deixe seu elogio, crítica ou sugestão e nos ajude a melhorar essa experiência:"
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "mb-n6", attrs: { cols: "12" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  id: "comment__list",
                                  items: _vm.getRatingTypes,
                                  label: "Classifique seu comentário",
                                  outlined: "",
                                  clearable: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "item",
                                      fn: function (ref) {
                                        var item = ref.item;
                                        return [
                                          _c(
                                            "span",
                                            {
                                              attrs: {
                                                id:
                                                  "comment__list_" +
                                                  item
                                                    .toLowerCase()
                                                    .replace("ã", "a")
                                                    .replace("ç", "c"),
                                              },
                                            },
                                            [_vm._v(_vm._s(item))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2295248265
                                ),
                                model: {
                                  value: _vm.entity.type_rating,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.entity, "type_rating", $$v);
                                  },
                                  expression: "entity.type_rating",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  id: "comment__text_field",
                                  rows: "5",
                                  outlined: "",
                                  placeholder: "Escreva aqui seu comentário",
                                  "auto-grow": "",
                                },
                                model: {
                                  value: _vm.entity.rating_text,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.entity, "rating_text", $$v);
                                  },
                                  expression: "entity.rating_text",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c("v-col", [
                            _c(
                              "div",
                              { staticClass: "text-end mt-3" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "buttonAction",
                                    attrs: {
                                      id: "nps__send_comment",
                                      disabled: !_vm.valid,
                                      loading: _vm.loading,
                                      color: "primary",
                                      type: "submit",
                                      block: _vm.$vuetify.breakpoint.mobile,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$vuetify.lang.t(
                                            "$vuetify.btn.send"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
};
var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;

  /* style */
  const __vue_inject_styles__$6 = function (inject) {
    if (!inject) return
    inject("data-v-040fe60e_0", { source: "\n.buttonAction[data-v-040fe60e] {\n  width: 160px;\n  height: 48px !important;\n  text-transform: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: bold;\n}\n.v-rating[data-v-040fe60e] {\n  display: flex;\n  max-width: 400px;\n}\n.text-center[data-v-040fe60e] {\n  text-align: -webkit-center !important;\n}\n.nps-buttom[data-v-040fe60e] {\n  font-size: 18px;\n  margin: 0 auto;\n  text-shadow: -1px 0 gray, 0 1px gray, 1px 0 gray, 0 -1px gray;\n  min-width: 0 !important;\n  height: 45px !important;\n  width: 0px;\n}\n.box-shadow[data-v-040fe60e] {\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 4) !important;\n}\n", map: {"version":3,"sources":["/home/daniel/Projects/dav/frontend/dav-frontend-components-vue/src/components/Nps/Nps.vue"],"names":[],"mappings":";AAgPA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AACA;AAEA;EACA,aAAA;EACA,gBAAA;AACA;AAEA;EACA,qCAAA;AACA;AAEA;EACA,eAAA;EACA,cAAA;EACA,6DAAA;EACA,uBAAA;EACA,uBAAA;EACA,UAAA;AACA;AAEA;EACA,mDAAA;AACA","file":"Nps.vue","sourcesContent":["<template>\n  <v-container v-if=\"!finishedRating\" class=\"pr-4\">\n    <v-card\n      flat\n      class=\"pa-2\"\n      :max-width=\"finishedRating ? '370px' : getBoxSize($vuetify.breakpoint.width)\"\n      :class=\"topMessage ? 'mt-8' : ''\"\n      color=\"#fff\"\n      style=\"border: 1px solid #c2c6ca\"\n    >\n      <div>\n        <v-card-title v-if=\"topMessage\" class=\"text-center justify-center\">\n          <span :style=\"`color: ${setup.theme.light.primary}`\">{{ topMessage }}</span>\n        </v-card-title>\n        <v-col v-if=\"!finishedRating\" class=\"text-left ml-1 mb-0\" cols=\"12\">\n          <span> {{ 'A ' }} </span>\n          <span class=\"font-weight-bold\"> {{ setup.name }} </span>\n          <span>\n            {{\n              ' agradece pela sua preferência. Gostaríamos de saber sua opinião sobre a experiência da Telemedicina, ela é muito importante para nós!'\n            }}\n          </span>\n        </v-col>\n      </div>\n      <v-form v-if=\"!finishedRating\" ref=\"form\" v-model=\"valid\" method=\"POST\" @submit.prevent=\"save\">\n        <v-col class=\"text-center\" cols=\"12\">\n          <span class=\"font-weight-medium\">\n            {{ 'Em uma escala de 0 a 10, o quanto você indicaria a teleconsulta para um amigo ou familiar?' }}\n          </span>\n        </v-col>\n        <v-row dense>\n          <v-col class=\"text-center mb-6\" cols=\"12\">\n            <v-rating v-model=\"entity.nps_rating\" hover length=\"11\" class=\"mt-5\" density=\"compact\">\n              <template #item=\"props\">\n                <v-btn\n                  :id=\"`nps__score_${props.index}`\"\n                  class=\"pa-3 white--text font-weight-bold nps-buttom\"\n                  :class=\"{ 'box-shadow': entity.nps_rating === props.index + 1 }\"\n                  :color=\"getButtonColor(props.index)\"\n                  @click=\"props.click\"\n                >\n                  <span>\n                    {{ props.index }}\n                  </span>\n                </v-btn>\n              </template>\n            </v-rating>\n          </v-col>\n        </v-row>\n        <v-row dense>\n          <v-col class=\"text-center mt-6 mb-6\" cols=\"12\">\n            <span class=\"font-weight-medium\">\n              {{ 'Por favor, deixe seu elogio, crítica ou sugestão e nos ajude a melhorar essa experiência:' }}\n            </span>\n          </v-col>\n        </v-row>\n        <v-row dense>\n          <v-col class=\"mb-n6\" cols=\"12\">\n            <v-select\n              id=\"comment__list\"\n              v-model=\"entity.type_rating\"\n              :items=\"getRatingTypes\"\n              :label=\"'Classifique seu comentário'\"\n              outlined\n              clearable\n            >\n              <template #item=\"{ item }\">\n                <span :id=\"`comment__list_${item.toLowerCase().replace('ã', 'a').replace('ç', 'c')}`\">{{ item }}</span>\n              </template>\n            </v-select>\n          </v-col>\n        </v-row>\n        <v-row dense>\n          <v-col cols=\"12\">\n            <v-textarea\n              id=\"comment__text_field\"\n              v-model=\"entity.rating_text\"\n              rows=\"5\"\n              outlined\n              :placeholder=\"'Escreva aqui seu comentário'\"\n              auto-grow\n            />\n          </v-col>\n        </v-row>\n        <v-row dense>\n          <v-col>\n            <div class=\"text-end mt-3\">\n              <v-btn\n                id=\"nps__send_comment\"\n                class=\"buttonAction\"\n                :disabled=\"!valid\"\n                :loading=\"loading\"\n                color=\"primary\"\n                type=\"submit\"\n                :block=\"$vuetify.breakpoint.mobile\"\n              >\n                {{ $vuetify.lang.t('$vuetify.btn.send') }}\n              </v-btn>\n            </div>\n          </v-col>\n        </v-row>\n      </v-form>\n    </v-card>\n  </v-container>\n</template>\n<script>\nexport default {\n  name: 'Nps',\n  tag: 'primeit-nps-component',\n  props: {\n    value: Boolean,\n    appointmentId: String,\n    topMessage: String,\n    protocol: String,\n    state: {\n      type: String,\n      default: 'appointment',\n    },\n  },\n\n  data: () => ({\n    valid: true,\n    loading: false,\n    finishedRating: false,\n    entity: {\n      nps_rating: null,\n      type_rating: '',\n      rating_text: '',\n    },\n  }),\n  computed: {\n    setup() {\n      return this.$store.getters['credential/SETUP'];\n    },\n    getRatingTypes() {\n      return ['Sugestão', 'Elogio', 'Reclamação'];\n    },\n    feedback: function () {\n      return this.$store.getters['common/FEEDBACK'];\n    },\n  },\n  watch: {\n    feedback: function (value) {\n      if ('code' in value) {\n        if (value.code === 200) {\n          this.$root.$emit('show-snackbar', { text: value.message, timeout: 3000, btnClose: false, color: 'success' });\n        } else {\n          this.$root.$emit('show-snackbar', { text: value.message, timeout: 0, btnClose: true, color: 'error' });\n        }\n      }\n      this.loading = false;\n      this.valid = true;\n    },\n  },\n  mounted() {\n    window.addEventListener('resize', this.onResize);\n  },\n  async created() {},\n  destroyed() {\n    window.removeEventListener('resize', this.onResize);\n  },\n  methods: {\n    getButtonColor(val) {\n      switch (val) {\n        case 0:\n          return '#ad0009';\n        case 1:\n          return '#e00218';\n        case 2:\n          return '#ff4557';\n        case 3:\n          return '#ff8800';\n        case 4:\n          return '#ffa640';\n        case 5:\n          return '#f4ff29';\n        case 6:\n          return '#ffdd00';\n        case 7:\n          return '#77e368';\n        case 8:\n          return '#4bd439';\n        case 9:\n          return '#2ab518';\n        case 10:\n          return '#13a100';\n      }\n    },\n    getBoxSize(size) {\n      switch (size) {\n        case size < 640:\n          return '370px';\n        case size >= 640:\n          return '640px';\n      }\n    },\n\n    isMobile() {\n      if (screen.width <= 760) {\n        return true;\n      }\n      return false;\n    },\n    emitFeedbackSuccess() {\n      this.$emit('feedback-success');\n    },\n    async save() {\n      if (this.entity.nps_rating) {\n        this.valid = false;\n        this.loading = true;\n        this.finishedRating = true;\n\n        const entityToSave = JSON.parse(JSON.stringify(this.entity));\n        entityToSave.appointment_id = this.appointmentId;\n\n        entityToSave.nps_rating = (entityToSave.nps_rating - 1).toString();\n\n        this.$store\n          .dispatch(`${this.state}/FETCH_SAVE_NPS`, {\n            id: this.appointmentId,\n            body: entityToSave,\n            protocol: this.protocol,\n          })\n          .then(() => {\n            this.emitFeedbackSuccess();\n          })\n          .catch(() => {});\n      } else {\n        this.$root.$emit('show-snackbar', {\n          text: 'Selecione uma nota para seu atendimento.',\n          timeout: 3000,\n          btnClose: true,\n          color: 'error',\n        });\n      }\n    },\n  },\n};\n</script>\n<style scoped>\n.buttonAction {\n  width: 160px;\n  height: 48px !important;\n  text-transform: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.v-rating {\n  display: flex;\n  max-width: 400px;\n}\n\n.text-center {\n  text-align: -webkit-center !important;\n}\n\n.nps-buttom {\n  font-size: 18px;\n  margin: 0 auto;\n  text-shadow: -1px 0 gray, 0 1px gray, 1px 0 gray, 0 -1px gray;\n  min-width: 0 !important;\n  height: 45px !important;\n  width: 0px;\n}\n\n.box-shadow {\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 4) !important;\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$6 = "data-v-040fe60e";
  /* module identifier */
  const __vue_module_identifier__$6 = undefined;
  /* functional template */
  const __vue_is_functional_template__$6 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$6 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$6,
    __vue_script__$6,
    __vue_scope_id__$6,
    __vue_is_functional_template__$6,
    __vue_module_identifier__$6,
    false,
    createInjector,
    undefined,
    undefined
  );

const Nps = __vue_component__$6;

//

var script$5 = {
  name: 'DavCellphone',
  tag: 'dav-cellphone',
  mixins: [validationMixin],
  validations: {
    cell_phone: {
      ddi: {
        required: requiredIf(function (val) {
          return val && val.number && val.number.length;
        }),
      },
      number: {
        isValid(val) {
          if (val) {
            const pattern = this.isBrazilianNumber() ? /^\(\d{2}\)\d{5}-\d{4}$/ : /^\d+$/;
            return RegExp(pattern).test(val);
          }
          return true;
        },
        required: requiredIf(function (val) {
          return this.required;
        }),
      },
    },
  },
  props: {
    id: String,
    value: [Object, String],
    required: Boolean,
    countryList: Array,
    disabled: Boolean,
    payment: Boolean,
    clearable: {
      type: Boolean,
      default: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'primary'
    },
    outlined: {
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
    init_value: false,
    cell_phone: {
      ddi: null,
      number: null,
    },
    selectOpen: false,
    countryListDomain: null,
    ddi: false,
  }),
  computed: {
    domainCountry() {
      this.countryListDomain = (this.countryList || this.$store.getters['domain/GET_COUNTRY'])
        .map((obj) => {
          return {
            name: this.removeSpecialCharacters(this.$vuetify.lang.t(`$vuetify.country.${obj.code}`)),
            code: obj.code,
            dial_code: obj.dial_code,
          };
        })
        .sort((obj1, obj2) => {
          return obj1.name < obj2.name ? -1 : obj1.name > obj2.name ? 1 : 0;
        });
      return this.countryListDomain;
    },
    errorMessagesCountryCode() {
      const errors = [];
      if (!this.$v.cell_phone.ddi.$dirty) return errors;
      if (!this.$v.cell_phone.ddi.required) {
        errors.push(
          this.$vuetify.lang.t('$vuetify.message.isRequired', [this.$vuetify.lang.t('$vuetify.label.country_contact')])
        );
      }
      return errors;
    },
    errorMessagesNumber() {
      const errors = [];
      if (!this.$v.cell_phone.number.$dirty) return errors;
      if (!this.$v.cell_phone.number.isValid) {
        errors.push(
          this.$vuetify.lang.t('$vuetify.message.isValid', [this.$vuetify.lang.t('$vuetify.label.cell_phone')])
        );
      }
      if (!this.$v.cell_phone.number.required) {
        errors.push(
          this.$vuetify.lang.t('$vuetify.message.isRequired', [this.$vuetify.lang.t('$vuetify.label.cell_phone')])
        );
      }
      return errors;
    },
    validRequired: function (value) {
      return [(value) => !!value || this.$vuetify.lang.t('$vuetify.message.isRequired', [''])];
    },
  },
  watch: {
    async value(val) {
      if (val) {
        let phone = JSON.parse(JSON.stringify(val));

        if ((await phone.ddi) != undefined) {
          this.cell_phone.ddi = this.countryListDomain.find((obj) => obj.dial_code == phone.ddi).code;
          this.ddi = true;
        }

        if (phone.number != undefined) {
          if (this.cell_phone.ddi == 'BR') {
            const re = /(\d{2})(\d{5})(\d{4})/;
            const to = '($1)$2-$3';
            this.cell_phone.number = phone.number.replace(re, to);
          } else {
            this.cell_phone.number = phone.number;
          }
        }

        this.initValue();
      }
    },
  },
  mounted() {
    if (this.value) {
      let phone = JSON.parse(JSON.stringify(this.value));

      if (phone.ddi != undefined) {
        this.cell_phone.ddi = this.countryListDomain.find((obj) => obj.dial_code == phone.ddi).code;
      }

      if (phone.number != undefined) {
        if (this.cell_phone.ddi == 'BR') {
          const re = /(\d{2})(\d{5})(\d{4})/;
          const to = '($1)$2-$3';
          this.cell_phone.number = phone.number.replace(re, to);
        } else {
          this.cell_phone.number = phone.number;
        }
      }
    }
    this.initValue();
  },
  methods: {
    initValue() {
      if (!this.init_value) {
        if (this.isBrazilianNumber()) {
          this.cell_phone.number = this.applyCellphoneMask(this.cell_phone.number);
        }
        if (this.cell_phone.number && !this.cell_phone.ddi) {
          this.cell_phone.ddi = 'BR';
        } else if (!this.cell_phone.number && !this.cell_phone.ddi) {
          this.cell_phone.ddi = 'BR';
        }
      }

      this.init_value = true;
    },
    validate() {
      this.$v.$touch();
      return !this.$v.invalid;
    },
    updateValue() {
      const cellPhone = JSON.parse(JSON.stringify(this.cell_phone));

      this.$emit('input', {
        number: cellPhone.number,
        ddi: cellPhone.ddi != null ? this.countryListDomain.find((obj) => obj.code == cellPhone.ddi).dial_code : null,
      });
    },
    isBrazilianNumber() {
      return this.cell_phone.ddi === 'BR';
    },
    maskNumberField() {
      return this.isBrazilianNumber() ? '(##)#####-####' : '##############################';
    },
    applyCellphoneMask(value) {
      if (value) {
        const re = /(\d{2})(\d{5})(\d{4})/;
        const to = '($1)$2-$3';
        return value.replace(re, to);
      }
    },
    removeSpecialCharacters(text) {
      text = text.toLowerCase();
      text = text.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a');
      text = text.replace(new RegExp('[ÉÈÊ]', 'gi'), 'e');
      text = text.replace(new RegExp('[ÍÌÎ]', 'gi'), 'i');
      text = text.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o');
      text = text.replace(new RegExp('[ÚÙÛ]', 'gi'), 'u');
      text = text.replace(new RegExp('[Ç]', 'gi'), 'c');
      return text;
    },
  },
};

/* script */
const __vue_script__$5 = script$5;

/* template */
var __vue_render__$3 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _c(
        "v-row",
        { staticClass: "pa-0 ma-0" },
        [
          _c(
            "v-col",
            {
              staticClass: "pa-0 ma-0 pr-1",
              attrs: { cols: "12", lg: "3", md: "3", sm: "12" },
            },
            [
              _c("v-autocomplete", {
                attrs: {
                  "persistent-hint": "",
                  outlined: _vm.outlined,
                  id: _vm.id + "_ddi",
                  items: _vm.domainCountry,
                  "error-messages": _vm.errorMessagesCountryCode,
                  color: _vm.color,
                  filled: !_vm.isMobile,
                  clearable: _vm.clearable,
                  disabled: _vm.disabled,
                  hint: _vm.isMobile
                    ? ""
                    : _vm.$vuetify.lang.t("$vuetify.label.country_contact"),
                  title: _vm.payment
                    ? _vm.$vuetify.lang.t("$vuetify.label.country_contact") +
                      " *"
                    : _vm.$vuetify.lang.t("$vuetify.label.country_contact"),
                  label: _vm.payment
                    ? _vm.$vuetify.lang.t("$vuetify.label.country_contact") +
                      " *"
                    : _vm.$vuetify.lang.t("$vuetify.label.country_contact"),
                  rules: _vm.payment ? _vm.validRequired : [],
                  "item-value": "code",
                  "item-text": !_vm.selectOpen
                    ? function (item) {
                        return "" + item.dial_code
                      }
                    : function (item) {
                        return (
                          _vm.$vuetify.lang.t("$vuetify.country." + item.code) +
                          " (" +
                          item.dial_code +
                          ")"
                        )
                      },
                },
                on: {
                  blur: function ($event) {
                    _vm.$v.cell_phone.ddi.$touch();
                    _vm.selectOpen = false;
                  },
                  input: _vm.updateValue,
                  focus: function ($event) {
                    _vm.selectOpen = true;
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "item",
                    fn: function (ref) {
                      var item = ref.item;
                      return [
                        _c(
                          "span",
                          {
                            attrs: {
                              id: _vm.id + "_ddi_" + item.code.toLowerCase(),
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  !_vm.selectOpen
                                    ? item.dial_code
                                    : _vm.$vuetify.lang.t(
                                        "$vuetify.country." + item.code
                                      ) +
                                        " (" +
                                        item.dial_code +
                                        ")"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.cell_phone.ddi,
                  callback: function ($$v) {
                    _vm.$set(_vm.cell_phone, "ddi", $$v);
                  },
                  expression: "cell_phone.ddi",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "pa-0 ma-0",
              attrs: { cols: "12", lg: "9", md: "9", sm: "12" },
            },
            [
              _c("v-text-field", {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: _vm.maskNumberField(),
                    expression: "maskNumberField()",
                  },
                ],
                attrs: {
                  id: _vm.id + "_number",
                  outlined: _vm.outlined,
                  color: _vm.color,
                  filled: !_vm.isMobile,
                  clearable: _vm.clearable,
                  disabled: _vm.disabled,
                  "error-messages": _vm.errorMessagesNumber,
                  title: _vm.payment
                    ? _vm.$vuetify.lang.t("$vuetify.label.cell_phone") + " *"
                    : _vm.$vuetify.lang.t("$vuetify.label.cell_phone"),
                  label: _vm.payment
                    ? _vm.$vuetify.lang.t("$vuetify.label.cell_phone") + " *"
                    : _vm.$vuetify.lang.t("$vuetify.label.cell_phone"),
                  hint: _vm.isMobile
                    ? ""
                    : _vm.$vuetify.lang.t("$vuetify.title.patient.cell_phone"),
                  rules: _vm.payment ? _vm.validRequired : [],
                  counter: _vm.isBrazilianNumber() ? 14 : 30,
                },
                on: {
                  blur: function ($event) {
                    _vm.$v.cell_phone.number.$touch();
                    _vm.$v.cell_phone.ddi.$touch();
                  },
                  input: _vm.updateValue,
                },
                model: {
                  value: _vm.cell_phone.number,
                  callback: function ($$v) {
                    _vm.$set(_vm.cell_phone, "number", $$v);
                  },
                  expression: "cell_phone.number",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
};
var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;

  /* style */
  const __vue_inject_styles__$5 = undefined;
  /* scoped */
  const __vue_scope_id__$5 = undefined;
  /* module identifier */
  const __vue_module_identifier__$5 = undefined;
  /* functional template */
  const __vue_is_functional_template__$5 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$5 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    false,
    undefined,
    undefined,
    undefined
  );

const Cellphone = __vue_component__$5;

//

var script$4 = {
  name: 'DavTelephone',
  tag: 'dav-telephone',
  mixins: [validationMixin],
  validations: {
    telephone: {
      ddi: {
        required: requiredIf(function (val) {
          return val && val.number && val.number.length;
        }),
      },
      number: {
        isValid(val) {
          if (val) {
            const pattern = this.isBrazilianNumber() ? /^\(\d{2}\)\d{4}-\d{4}$/ : /^\d+$/;
            return RegExp(pattern).test(val);
          }
          return true;
        },
        required: requiredIf(function (val) {
          return this.required;
        }),
      },
    },
  },
  props: {
    id: String,
    value: [Object, String],
    required: Boolean,
    countryList: Array,
    disabled: Boolean,
    isMobile: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'primary'
    },
    outlined: {
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
    mounted: false,
    telephone: {
      ddi: null,
      number: null,
    },
    selectOpen: false,
    countryListDomain: null,
    ddi: false,
  }),
  computed: {
    domainCountry() {
      this.countryListDomain = (this.countryList || this.$store.getters['domain/GET_COUNTRY'])
        .map((obj) => {
          return {
            name: this.removeSpecialCharacters(this.$vuetify.lang.t(`$vuetify.country.${obj.code}`)),
            code: obj.code,
            dial_code: obj.dial_code,
          };
        })
        .sort((obj1, obj2) => {
          return obj1.name < obj2.name ? -1 : obj1.name > obj2.name ? 1 : 0;
        });
      return this.countryListDomain;
    },
    errorMessagesCountryCode() {
      const errors = [];
      if (!this.$v.telephone.ddi.$dirty) return errors;
      if (!this.$v.telephone.ddi.required) {
        errors.push(
          this.$vuetify.lang.t('$vuetify.message.isRequired', [this.$vuetify.lang.t('$vuetify.label.country_contact')])
        );
      }
      return errors;
    },
    errorMessagesNumber() {
      const errors = [];
      if (!this.$v.telephone.number.$dirty) return errors;
      if (!this.$v.telephone.number.isValid) {
        errors.push(
          this.$vuetify.lang.t('$vuetify.message.isValid', [this.$vuetify.lang.t('$vuetify.label.telephone')])
        );
      }
      if (!this.$v.telephone.number.required) {
        errors.push(
          this.$vuetify.lang.t('$vuetify.message.isRequired', [this.$vuetify.lang.t('$vuetify.label.telephone')])
        );
      }
      return errors;
    },
  },
  watch: {
    async value(val) {
      if (val) {
        let phone = JSON.parse(JSON.stringify(val));

        if ((await phone.ddi) != undefined) {
          this.telephone.ddi = this.countryListDomain.find((obj) => obj.dial_code == phone.ddi).code;
          this.ddi = true;
        }

        if (phone.number != undefined) {
          if (this.telephone.ddi == 'BR') {
            const re = /(\d{2})(\d{4})(\d{4})/;
            const to = '($1)$2-$3';
            this.telephone.number = phone.number.replace(re, to);
          } else {
            this.telephone.number = phone.number;
          }
        }

        this.initValue();
      }
    },
    ddi(val) {},
  },
  mounted() {
    if (this.value) {
      let phone = JSON.parse(JSON.stringify(this.value));

      if (phone.ddi != undefined) {
        this.telephone.ddi = this.countryListDomain.find((obj) => obj.dial_code == phone.ddi).code;
      }

      if (phone.number != undefined) {
        if (this.telephone.ddi == 'BR') {
          const re = /(\d{2})(\d{4})(\d{4})/;
          const to = '($1)$2-$3';
          this.telephone.number = phone.number.replace(re, to);
        } else {
          this.telephone.number = phone.number;
        }
      }
    }
    this.initValue();
  },
  methods: {
    initValue() {
      if (!this.init_value) {
        if (this.isBrazilianNumber()) {
          this.telephone.number = this.applyTelephoneMask(this.telephone.number);
        }
        if (this.telephone.number && !this.telephone.ddi) {
          this.telephone.ddi = 'BR';
        } else if (!this.telephone.number && !this.telephone.ddi) {
          this.telephone.ddi = 'BR';
        }
      }
      this.init_value = true;
    },
    validate() {
      this.$v.$touch();
    },
    setTelephoneValue() {
      if (this.isBrazilianNumber()) {
        this.telephone.number = this.applyTelephoneMask(this.value.number);
      } else {
        this.telephone.number = this.value.number;
      }
      this.telephone.ddi = this.value.ddi;
    },
    updateValue() {
      const telephone = JSON.parse(JSON.stringify(this.telephone));
      this.$emit('input', {
        number: telephone.number,
        ddi: telephone.ddi != null ? this.countryListDomain.find((obj) => obj.code == telephone.ddi).dial_code : null,
      });
    },
    isBrazilianNumber() {
      return this.telephone.ddi === 'BR';
    },
    maskNumberField() {
      return this.isBrazilianNumber() ? '(##)####-####' : '##############################';
    },
    applyTelephoneMask(value) {
      if (value) {
        const re = /(\d{2})(\d{4})(\d{4})/;
        const to = '($1)$2-$3';
        return value.replace(re, to);
      }
    },
    removeSpecialCharacters(text) {
      text = text.toLowerCase();
      text = text.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a');
      text = text.replace(new RegExp('[ÉÈÊ]', 'gi'), 'e');
      text = text.replace(new RegExp('[ÍÌÎ]', 'gi'), 'i');
      text = text.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o');
      text = text.replace(new RegExp('[ÚÙÛ]', 'gi'), 'u');
      text = text.replace(new RegExp('[Ç]', 'gi'), 'c');
      return text;
    },
  },
};

/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$2 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _c(
        "v-row",
        { staticClass: "pa-0 ma-0" },
        [
          _c(
            "v-col",
            {
              staticClass: "pa-0 ma-0 pr-1",
              attrs: { cols: "12", lg: "3", md: "3", sm: "12" },
            },
            [
              _c("v-autocomplete", {
                attrs: {
                  "persistent-hint": "",
                  outlined: _vm.outlined,
                  id: _vm.id + "_ddi",
                  items: _vm.domainCountry,
                  "error-messages": _vm.errorMessagesCountryCode,
                  color: _vm.color,
                  filled: !_vm.isMobile,
                  clearable: "",
                  disabled: _vm.disabled,
                  hint: _vm.isMobile
                    ? ""
                    : _vm.$vuetify.lang.t("$vuetify.label.country_contact"),
                  title: _vm.$vuetify.lang.t("$vuetify.label.country_contact"),
                  label: _vm.$vuetify.lang.t("$vuetify.label.country_contact"),
                  "item-value": "code",
                  "item-text": !_vm.selectOpen
                    ? function (item) {
                        return "" + item.dial_code
                      }
                    : function (item) {
                        return (
                          _vm.$vuetify.lang.t("$vuetify.country." + item.code) +
                          " (" +
                          item.dial_code +
                          ")"
                        )
                      },
                },
                on: {
                  blur: function ($event) {
                    _vm.$v.telephone.ddi.$touch();
                    _vm.selectOpen = false;
                  },
                  input: _vm.updateValue,
                  focus: function ($event) {
                    _vm.selectOpen = true;
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "item",
                    fn: function (ref) {
                      var item = ref.item;
                      return [
                        _c(
                          "span",
                          {
                            attrs: {
                              id: _vm.id + "_ddi_" + item.code.toLowerCase(),
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  !_vm.selectOpen
                                    ? item.dial_code
                                    : _vm.$vuetify.lang.t(
                                        "$vuetify.country." + item.code
                                      ) +
                                        " (" +
                                        item.dial_code +
                                        ")"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.telephone.ddi,
                  callback: function ($$v) {
                    _vm.$set(_vm.telephone, "ddi", $$v);
                  },
                  expression: "telephone.ddi",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "pa-0 ma-0",
              attrs: { cols: "12", lg: "9", md: "9", sm: "12" },
            },
            [
              _c("v-text-field", {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: _vm.maskNumberField(),
                    expression: "maskNumberField()",
                  },
                ],
                attrs: {
                  id: _vm.id + "_number",
                  color: _vm.color,
                  filled: !_vm.isMobile,
                  clearable: "",
                  outlined: _vm.outlined,
                  disabled: _vm.disabled,
                  "error-messages": _vm.errorMessagesNumber,
                  title: _vm.$vuetify.lang.t(
                    "$vuetify.title.patient.telephone"
                  ),
                  label: _vm.$vuetify.lang.t("$vuetify.label.telephone"),
                  hint: _vm.isMobile
                    ? ""
                    : _vm.$vuetify.lang.t("$vuetify.title.patient.telephone"),
                  counter: _vm.isBrazilianNumber() ? 13 : 30,
                },
                on: {
                  blur: function ($event) {
                    _vm.$v.telephone.number.$touch();
                    _vm.$v.telephone.ddi.$touch();
                  },
                  input: _vm.updateValue,
                },
                model: {
                  value: _vm.telephone.number,
                  callback: function ($$v) {
                    _vm.$set(_vm.telephone, "number", $$v);
                  },
                  expression: "telephone.number",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$4 = undefined;
  /* scoped */
  const __vue_scope_id__$4 = undefined;
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$4 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    false,
    undefined,
    undefined,
    undefined
  );

const Telephone = __vue_component__$4;

const module = {
  actions: {
    CREATE_PRESCRIPTION: async (context, params) => {
      const payload = { ts: moment$1().toISOString() };
      const prof = params.professional;
      const code = prof.license_number ? prof.license_number : prof.crm.split('/')[0];
      const region = prof.license_region ? prof.license_region : prof.crm.split('/')[1];
      const type = prof.license_council || 'CRM';

      const url = `${process.env.VUE_APP_PRESCRIPTION_BACKEND_URL}/api/prescricao/iniciar`;
      const init = {
        body: JSON.stringify({
          Convenio: {},
          Estabelecimento: params.estabelecimento,
          Logo: params.company.logo,
          Medico: {
            Documento: params.professional.cpf,
            Email: params.professional.mail,
            Nome: params.professional.name,
            ReferenciaExterna: params.professional.id + Date.now(),
            RegistroProfissional: {
              Conselho: type,
              Numero: code,
              UF: region,
            },
            TipoDocumento: 'CPF',
          },
          Paciente: {
            Documento: params.person.cpf,
            Email: params.person.mail,
            Endereco: params.person.address,
            Nascimento: params.person.birth_date,
            Nome: params.person.name,
            ReferenciaExterna: params.person.id + Date.now(),
            Sexo: params.person.gender,
            TelefoneCelular: params.person.cell_phone,
            TipoDocumento: 'CPF',
          },
          ReferenciaExterna: params.appointment.id + params.estabelecimento.Nome,
          RegistroProntuarioEletronico: {
            ReferenciaExterna: moment$1().toISOString(), // params.appointment.id,
          },
        }),
        headers: new Headers({
          'Cache-Control': 'no-store',
          'Content-Type': 'application/json',
        }),
        method: 'POST',
      };

      try {
        const response = await fetch(url, init);
        const json = await response.json();
        payload.code = response.status;
        payload.response = json;
        if (response.status === 200) {
          if (payload.response.ModalURL) {
            payload.url = payload.response.ModalURL;
          } else {
            payload.url = `${payload.response.headers.get('x-next-url')}/${
              payload.response.Referencia
            }/${response.headers.get('x-api-token')}`;
          }
          context.commit('POPULATE_PRESCRIPTION', payload);
        } else {
          context.commit('POPULATE_FEEDBACK', payload);
        }
      } catch (err) {
        context.commit('POPULATE_FEEDBACK', payload);
      }
    },

    /**
     * @deprecated Renomeado para DISCARD_ACTUAL_PRESCRIPTION, para melhor interpretação do código
     * @param context
     * @param params
     * @returns {Promise<void>}
     * @constructor
     */
    DELETE_PRESCRIPTION: async (context, params) => {
      try {
        context.commit('POPULATE_PRESCRIPTION', undefined);
      } catch (err) {
        context.commit('POPULATE_FEEDBACK', err);
      }
    },

    DISCARD_ACTUAL_PRESCRIPTION: async (context) => {
      try {
        context.commit('POPULATE_PRESCRIPTION', undefined);
      } catch (err) {
        context.commit('POPULATE_FEEDBACK', err);
      }
    },

    FETCH_DIGITAL_FILES: async (context, params) => {
      try {
        const work = [];

        const download = (pdf, name, prescription) =>
          new Promise((resolve, reject) => {
            fetch(pdf, {
              headers: new Headers({
                Accept: 'application/pdf',
              }),
              method: 'GET',
            })
              .then((response) => {
                if (response.status === 200) {
                  response
                    .blob()
                    .then((blob) => {
                      resolve({
                        code: response.status,
                        name,
                        pdf: blob,
                        prescription,
                        url: pdf,
                      });
                    })
                    .catch((err) => reject(err));
                }
              })
              .catch((err) => reject(err));
          });

        params.Documentos.forEach((document) => {
          const name = document.TipoDocumento;
          const file = document.URL;
          work.push(download(file, name, params.idPrescription));
        });

        context.commit('POPULATE_PDF', await Promise.all(work));
      } catch (err) {
        context.commit('POPULATE_FEEDBACK', { ts: new Date().toISOString() });
      }
    },

    REFRESH_ACTUAL_PRESCRIPTION: async (context, params) => {
      try {
        const url = `${process.env.VUE_APP_PRESCRIPTION_BACKEND_URL}/api/prescricao/${params.idPrescription}/sessao`;

        const response = await fetch(url, {
          method: 'POST',
        });

        if (response.ok) {
          const json = await response.json();
          context.state.prescription.url = json.data.ModalURL;

          context.commit('POPULATE_PRESCRIPTION', context.state.prescription);
        }
      } catch (err) {
        context.commit('POPULATE_FEEDBACK', err);
      }
    },
  },
  getters: {
    FEEDBACK: (state) => state.feedback,
    GET_PDF: (state) => state.pdf,
    GET_PRESCRIPTION: (state) => state.prescription,
  },
  mutations: {
    POPULATE_FEEDBACK: (state, payload) => {
      if (payload) {
        state.feedback = payload;
      }
    },
    POPULATE_PDF: (state, payload) => {
      if (payload) {
        state.pdf = payload;
      }
    },
    POPULATE_PRESCRIPTION: (state, payload) => {
      if (payload) {
        state.prescription = payload;
      } else {
        state.prescription = null;
      }
    },
  },
  namespaced: true,
  state: {
    feedback: null,
    pdf: null,
    prescription: null,
  },
};

CommonState$1.registerModule('prescription', module);

//

var script$3 = {
  name: 'PrescriptionButton',
  tag: 'prescription-button',
  props: {
    value: Object,
    appointment: {
      type: Object,
      required: true,
    },
    person: {
      type: String,
      required: false,
      default: '',
    },
    professional: {
      type: String,
      required: false,
      default: '',
    },
    onSave: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    addressDialog: false,
    dialog: false,
    loaded: false,
    dataColor: '#576cff',
    patient: null,
    startedPrescription: false,
    doctor: null,
    listener: null,
    prescription_address: null,
    internationalAddressDialog: false,
  }),
  computed: {
    setup() {
      return this.$store.getters['credential/SETUP'];
    },
    pdf() {
      return this.$store.getters['prescription/GET_PDF'];
    },
    feedback() {
      return this.$store.getters['prescription/FEEDBACK'];
    },
    prescription() {
      return this.$store.getters['prescription/GET_PRESCRIPTION'];
    },
    prescriptionUrl() {
      return this.prescription ? this.prescription.url : null;
    },
  },
  watch: {
    pdf(actual) {
      if (actual) {
        const payloads = Array.isArray(actual) ? actual : [actual];
        (async () => {
          const work = payloads.map((payload) => {
            return new Promise((resolve) => {
              const reader = new FileReader();
              reader.readAsDataURL(payload.pdf);
              reader.onload = () => {
                const payloadName = payload.name;

                const upload = {
                  name: `${payloadName === '' ? 'ENCAMINHAMENTO' : payload.name}-${payload.prescription}.pdf`,
                  file: reader.result,
                };
                resolve(upload);
              };
            });
          });

          const filesToUpload = await Promise.all(work);
          /// não mexer no 'for await'
          /// For await para fazer um a um e não ter paralelismo
          for await (const upload of filesToUpload) {
            await this.onSave(upload);
          }
        })();
      }
    },
    prescription(value) {
      if (value) this.openPrescription(value.response.idPrescricao);
    },
    feedback(value) {
      if (value && value.code === 412) {
        let prescriptionMessage = '';
        for (const message of value.response) {
          prescriptionMessage += message.Descricao.split('\n')[0];
          prescriptionMessage += '\n';
        }
        this.$root.$emit('show-snackbar', {
          text: `${this.$vuetify.lang.t('$vuetify.message.participant_data_problem')}\n${prescriptionMessage}`,
          btnClose: false,
          color: 'error',
          timeout: 3000,
        });
      } else {
        this.$root.$emit('show-snackbar', {
          text: this.$vuetify.lang.t('$vuetify.message.prescription_error'),
          btnClose: true,
          color: 'error',
          timeout: 3000,
        });
      }
      this.startedPrescription = false;
    },
  },
  mounted() {
    this.patient = this.appointment.participants.find((p) => p.role.code === 'PAT');
    this.patient.gender = this.getGender(this.patient.gender);
    if (this.patient.address && (!this.patient.address.country || this.patient.address.country === 'BR')) {
      this.patient.address = this.getEnderecoData(this.patient.address);
    } else {
      this.patient.address = {};
    }
    this.doctor = this.appointment.participants.find((p) => p.role.code === 'MMD');
    this.prescription_address = this.appointment.prescription_address;
  },
  methods: {
    getGender(gender) {
      if (gender === 'M' || gender === 'Masculino') {
        return 'Masculino';
      } else if (gender === 'F' || gender === 'Feminino') {
        return 'Feminino';
      } else {
        return null;
      }
    },

    startPrescription() {
      if (!this.prescription_address.city) {
        this.addressDialog = true;
        return;
      }

      if (this.prescription_address.country && this.prescription_address.country !== 'BR') {
        this.internationalAddressDialog = true;
        return;
      }

      if (this.patient.cell_phone_ddi && this.patient.cell_phone_ddi !== '+55') {
        this.patient.cell_phone = null;
      }

      if (this.patient) {
        if (this.startedPrescription) {
          this.$store
            .dispatch('prescription/REFRESH_ACTUAL_PRESCRIPTION', {
              idPrescription: this.prescription.response.idPrescricao,
            })
            .then((_) => (this.dialog = true));
        } else {
          this.$store
            .dispatch('prescription/CREATE_PRESCRIPTION', {
              appointment: { id: this.appointment.id },
              company: { id: this.setup.companyId, name: this.setup.name },
              professional: this.doctor,
              person: this.patient,
              estabelecimento: this.getEstabelecimentoData(),
            })
            .then((_) => {
              this.dialog = true;
            });
        }
      } else {
        this.$root.$emit('show-snackbar', {
          text: this.$vuetify.lang.t('$vuetify.message.no_patient'),
          btnClose: false,
          color: 'error',
          timeout: 3000,
        });
      }
    },

    getEstabelecimentoData() {
      const data = {
        Nome: this.setup.name,
      };
      if (this.prescription_address) {
        data.Nome = this.prescription_address.name;
        data.Endereco = this.getEnderecoData(this.prescription_address);
      }
      if (this.setup.picture) {
        data.Logo = this.setup.picture;
      }
      return data;
    },

    getEnderecoData(address) {
      return {
        Endereco1: address.street && address.number ? this.assembleAddressInfo(address) : null,
        Bairro: address.neighborhood || null,
        Cidade: address.city ? (typeof address.city === 'string' ? address.city : address.city.value) : null,
        Estado: address.state || null,
        CodigoPostal: address.zip_code || null,
      };
    },

    assembleAddressInfo(address) {
      let data = address.street + ', ' + address.number;
      if (address.complement) {
        data += ' - ' + address.complement;
      }
      return data;
    },

    sendPrescriptionData(id, response) {
      const data = {
        medicines: [],
      };
      if (response && response.Medicamentos) {
        response.Medicamentos.forEach((med) => {
          data.medicines.push({ prescription_id: id, label: med.Label, dosage: med.Posologia });
        });
      }
      if (response && response.MedicamentosManuais) {
        response.MedicamentosManuais.forEach((med) => {
          data.medicines.push({ prescription_id: id, label: med.Label, dosage: med.Posologia });
        });
      }
      if (response && response.Comentario) data.comments = response.Comentario;
      this.$emit('input', data);
    },

    openPrescription(idPrescription) {
      const that = this;
      this.dialog = true;
      this.loaded = false;
      this.listener = (event) => {
        switch (event.data.type) {
          case 'excluded':
            that.$root.$emit('show-snackbar', {
              text: this.$vuetify.lang.t('$vuetify.message.wiping_prescription'),
              btnClose: false,
              color: 'success',
              timeout: 2000,
            });
            that.$store.dispatch('prescription/DISCARD_ACTUAL_PRESCRIPTION');
            window.removeEventListener('message', this.listener);
            this.startedPrescription = false;
            that.dialog = false;
            break;
          case 'prescricao':
            that.$root.$emit('show-snackbar', {
              text: this.$vuetify.lang.t('$vuetify.message.saving_prescription'),
              btnClose: false,
              color: 'success',
              timeout: 3000,
            });
            that.$store
              .dispatch('prescription/FETCH_DIGITAL_FILES', { idPrescription, Documentos: event.data.Documentos })
              .then(() => {
                this.sendPrescriptionData(idPrescription, event.data);
              });
            // that.$store.dispatch('prescription/DISCARD_ACTUAL_PRESCRIPTION');
            window.removeEventListener('message', this.listener);
            this.startedPrescription = false;
            break;
          case 'cancel':
            that.dialog = false;
            break;
        }
      };
      this.startedPrescription = true;
      window.addEventListener('message', this.listener);
    },
  },
};

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$1 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "span",
    { staticClass: "d-inline-block" },
    [
      _c(
        "v-btn",
        {
          staticClass: "v-btn-actions-room",
          attrs: { small: "", color: "primary" },
          on: { click: _vm.startPrescription },
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { eager: "", "max-width": "400" },
          model: {
            value: _vm.internationalAddressDialog,
            callback: function ($$v) {
              _vm.internationalAddressDialog = $$v;
            },
            expression: "internationalAddressDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "text-h5" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$vuetify.lang.t("$vuetify.label.error_prescription")
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$vuetify.lang.t(
                        "$vuetify.message.dialog_prescription_error_international_address"
                      )
                    )
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.internationalAddressDialog = false;
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.btn.close")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { eager: "", "max-width": "400" },
          model: {
            value: _vm.addressDialog,
            callback: function ($$v) {
              _vm.addressDialog = $$v;
            },
            expression: "addressDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "text-h5" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$vuetify.lang.t("$vuetify.label.error_prescription")
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$vuetify.lang.t(
                        "$vuetify.message.dialog_prescription_error"
                      )
                    )
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.addressDialog = false;
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.btn.close")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { eager: "" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v;
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                { staticClass: "pa-0", staticStyle: { overflow: "hidden" } },
                [
                  _c(
                    "v-container",
                    {
                      staticStyle: {
                        height: "580px",
                        width: "100%",
                        overflow: "hidden",
                        "max-width": "100% !important",
                      },
                    },
                    [
                      _c(
                        "v-container",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.loaded,
                              expression: "!loaded",
                            },
                          ],
                          staticClass: "align-center",
                          staticStyle: {
                            height: "580px",
                            width: "100%",
                            "background-color": "white",
                          },
                        },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "1" } },
                                [
                                  _c("v-skeleton-loader", {
                                    staticClass: "mx-auto",
                                    attrs: { type: "avatar" },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                [
                                  _c("v-skeleton-loader", {
                                    staticClass: "mx-auto",
                                    attrs: { type: "heading" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            { staticStyle: { height: "400px" } },
                            [
                              _c(
                                "v-col",
                                [
                                  _c("v-skeleton-loader", {
                                    staticClass: "mx-auto",
                                    attrs: { type: "list-item-two-line" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        [
                                          _c("v-skeleton-loader", {
                                            staticClass: "mx-auto",
                                            attrs: { type: "text" },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        [
                                          _c("v-skeleton-loader", {
                                            staticClass: "mx-auto",
                                            attrs: { type: "text" },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                [
                                  _c("v-skeleton-loader", {
                                    staticClass: "mx-auto",
                                    attrs: { type: "actions" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.dialog ||
                      _vm.addressDialog ||
                      _vm.internationalAddressDialog
                        ? _c("iframe", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.loaded,
                                expression: "loaded",
                              },
                            ],
                            ref: "prescriptionIframe",
                            staticClass: "pa-0",
                            attrs: {
                              id: "iframe__nexodata",
                              frameborder: "0",
                              width: "100%",
                              height: "580px;",
                              src: _vm.prescriptionUrl,
                            },
                            on: {
                              load: function ($event) {
                                _vm.loaded = true;
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$3 = function (inject) {
    if (!inject) return
    inject("data-v-4d04f744_0", { source: "\n.teste {\n  width: 50px;\n}\n", map: {"version":3,"sources":["/home/daniel/Projects/dav/frontend/dav-frontend-components-vue/src/components/PrescriptionModule/PrescriptionButton.vue"],"names":[],"mappings":";AA2WA;EACA,WAAA;AACA","file":"PrescriptionButton.vue","sourcesContent":["<template>\n  <span class=\"d-inline-block\">\n    <v-btn small color=\"primary\" class=\"v-btn-actions-room\" @click=\"startPrescription\">\n      <slot />\n    </v-btn>\n\n    <v-dialog v-model=\"internationalAddressDialog\" eager max-width=\"400\">\n      <v-card>\n        <v-card-title class=\"text-h5\">\n          {{ $vuetify.lang.t('$vuetify.label.error_prescription') }}\n        </v-card-title>\n        <v-card-text>\n          {{ $vuetify.lang.t(`$vuetify.message.dialog_prescription_error_international_address`) }}</v-card-text\n        >\n        <v-card-actions>\n          <v-spacer />\n          <v-btn color=\"primary\" text @click=\"internationalAddressDialog = false\">\n            {{ $vuetify.lang.t('$vuetify.btn.close') }}\n          </v-btn>\n        </v-card-actions>\n      </v-card>\n    </v-dialog>\n\n    <v-dialog v-model=\"addressDialog\" eager max-width=\"400\">\n      <v-card>\n        <v-card-title class=\"text-h5\">\n          {{ $vuetify.lang.t('$vuetify.label.error_prescription') }}\n        </v-card-title>\n        <v-card-text> {{ $vuetify.lang.t('$vuetify.message.dialog_prescription_error') }}</v-card-text>\n        <v-card-actions>\n          <v-spacer />\n          <v-btn color=\"primary\" text @click=\"addressDialog = false\">\n            {{ $vuetify.lang.t('$vuetify.btn.close') }}\n          </v-btn>\n        </v-card-actions>\n      </v-card>\n    </v-dialog>\n\n    <v-dialog v-model=\"dialog\" eager>\n      <v-card>\n        <v-card-text style=\"overflow: hidden\" class=\"pa-0\">\n          <v-container style=\"height: 580px; width: 100%; overflow: hidden; max-width: 100% !important\">\n            <v-container\n              v-show=\"!loaded\"\n              class=\"align-center\"\n              style=\"height: 580px; width: 100%; background-color: white\"\n            >\n              <v-row>\n                <v-col cols=\"1\"><v-skeleton-loader class=\"mx-auto\" type=\"avatar\" /></v-col>\n                <v-col><v-skeleton-loader class=\"mx-auto\" type=\"heading\" /></v-col>\n              </v-row>\n              <v-row style=\"height: 400px\">\n                <v-col><v-skeleton-loader class=\"mx-auto\" type=\"list-item-two-line\" /></v-col>\n              </v-row>\n              <v-row>\n                <v-col>\n                  <v-row>\n                    <v-col><v-skeleton-loader class=\"mx-auto\" type=\"text\" /></v-col>\n                    <v-col><v-skeleton-loader class=\"mx-auto\" type=\"text\" /></v-col>\n                  </v-row>\n                </v-col>\n                <v-col><v-skeleton-loader class=\"mx-auto\" type=\"actions\" /></v-col>\n              </v-row>\n            </v-container>\n\n            <iframe\n              v-if=\"dialog || addressDialog || internationalAddressDialog\"\n              v-show=\"loaded\"\n              id=\"iframe__nexodata\"\n              ref=\"prescriptionIframe\"\n              class=\"pa-0\"\n              frameborder=\"0\"\n              width=\"100%\"\n              height=\"580px;\"\n              :src=\"prescriptionUrl\"\n              @load=\"loaded = true\"\n            />\n          </v-container>\n        </v-card-text>\n      </v-card>\n    </v-dialog>\n  </span>\n</template>\n<script>\nimport './state/prescription';\n\nexport default {\n  name: 'PrescriptionButton',\n  tag: 'prescription-button',\n  props: {\n    value: Object,\n    appointment: {\n      type: Object,\n      required: true,\n    },\n    person: {\n      type: String,\n      required: false,\n      default: '',\n    },\n    professional: {\n      type: String,\n      required: false,\n      default: '',\n    },\n    onSave: {\n      type: Function,\n      required: true,\n    },\n  },\n  data: () => ({\n    addressDialog: false,\n    dialog: false,\n    loaded: false,\n    dataColor: '#576cff',\n    patient: null,\n    startedPrescription: false,\n    doctor: null,\n    listener: null,\n    prescription_address: null,\n    internationalAddressDialog: false,\n  }),\n  computed: {\n    setup() {\n      return this.$store.getters['credential/SETUP'];\n    },\n    pdf() {\n      return this.$store.getters['prescription/GET_PDF'];\n    },\n    feedback() {\n      return this.$store.getters['prescription/FEEDBACK'];\n    },\n    prescription() {\n      return this.$store.getters['prescription/GET_PRESCRIPTION'];\n    },\n    prescriptionUrl() {\n      return this.prescription ? this.prescription.url : null;\n    },\n  },\n  watch: {\n    pdf(actual) {\n      if (actual) {\n        const payloads = Array.isArray(actual) ? actual : [actual];\n        (async () => {\n          const work = payloads.map((payload) => {\n            return new Promise((resolve) => {\n              const reader = new FileReader();\n              reader.readAsDataURL(payload.pdf);\n              reader.onload = () => {\n                const payloadName = payload.name;\n\n                const upload = {\n                  name: `${payloadName === '' ? 'ENCAMINHAMENTO' : payload.name}-${payload.prescription}.pdf`,\n                  file: reader.result,\n                };\n                resolve(upload);\n              };\n            });\n          });\n\n          const filesToUpload = await Promise.all(work);\n          /// não mexer no 'for await'\n          /// For await para fazer um a um e não ter paralelismo\n          for await (const upload of filesToUpload) {\n            await this.onSave(upload);\n          }\n        })();\n      }\n    },\n    prescription(value) {\n      if (value) this.openPrescription(value.response.idPrescricao);\n    },\n    feedback(value) {\n      if (value && value.code === 412) {\n        let prescriptionMessage = '';\n        for (const message of value.response) {\n          prescriptionMessage += message.Descricao.split('\\n')[0];\n          prescriptionMessage += '\\n';\n        }\n        this.$root.$emit('show-snackbar', {\n          text: `${this.$vuetify.lang.t('$vuetify.message.participant_data_problem')}\\n${prescriptionMessage}`,\n          btnClose: false,\n          color: 'error',\n          timeout: 3000,\n        });\n      } else {\n        this.$root.$emit('show-snackbar', {\n          text: this.$vuetify.lang.t('$vuetify.message.prescription_error'),\n          btnClose: true,\n          color: 'error',\n          timeout: 3000,\n        });\n      }\n      this.startedPrescription = false;\n    },\n  },\n  mounted() {\n    this.patient = this.appointment.participants.find((p) => p.role.code === 'PAT');\n    this.patient.gender = this.getGender(this.patient.gender);\n    if (this.patient.address && (!this.patient.address.country || this.patient.address.country === 'BR')) {\n      this.patient.address = this.getEnderecoData(this.patient.address);\n    } else {\n      this.patient.address = {};\n    }\n    this.doctor = this.appointment.participants.find((p) => p.role.code === 'MMD');\n    this.prescription_address = this.appointment.prescription_address;\n  },\n  methods: {\n    getGender(gender) {\n      if (gender === 'M' || gender === 'Masculino') {\n        return 'Masculino';\n      } else if (gender === 'F' || gender === 'Feminino') {\n        return 'Feminino';\n      } else {\n        return null;\n      }\n    },\n\n    startPrescription() {\n      if (!this.prescription_address.city) {\n        this.addressDialog = true;\n        return;\n      }\n\n      if (this.prescription_address.country && this.prescription_address.country !== 'BR') {\n        this.internationalAddressDialog = true;\n        return;\n      }\n\n      if (this.patient.cell_phone_ddi && this.patient.cell_phone_ddi !== '+55') {\n        this.patient.cell_phone = null;\n      }\n\n      if (this.patient) {\n        if (this.startedPrescription) {\n          this.$store\n            .dispatch('prescription/REFRESH_ACTUAL_PRESCRIPTION', {\n              idPrescription: this.prescription.response.idPrescricao,\n            })\n            .then((_) => (this.dialog = true));\n        } else {\n          this.$store\n            .dispatch('prescription/CREATE_PRESCRIPTION', {\n              appointment: { id: this.appointment.id },\n              company: { id: this.setup.companyId, name: this.setup.name },\n              professional: this.doctor,\n              person: this.patient,\n              estabelecimento: this.getEstabelecimentoData(),\n            })\n            .then((_) => {\n              this.dialog = true;\n            });\n        }\n      } else {\n        this.$root.$emit('show-snackbar', {\n          text: this.$vuetify.lang.t('$vuetify.message.no_patient'),\n          btnClose: false,\n          color: 'error',\n          timeout: 3000,\n        });\n      }\n    },\n\n    getEstabelecimentoData() {\n      const data = {\n        Nome: this.setup.name,\n      };\n      if (this.prescription_address) {\n        data.Nome = this.prescription_address.name;\n        data.Endereco = this.getEnderecoData(this.prescription_address);\n      }\n      if (this.setup.picture) {\n        data.Logo = this.setup.picture;\n      }\n      return data;\n    },\n\n    getEnderecoData(address) {\n      return {\n        Endereco1: address.street && address.number ? this.assembleAddressInfo(address) : null,\n        Bairro: address.neighborhood || null,\n        Cidade: address.city ? (typeof address.city === 'string' ? address.city : address.city.value) : null,\n        Estado: address.state || null,\n        CodigoPostal: address.zip_code || null,\n      };\n    },\n\n    assembleAddressInfo(address) {\n      let data = address.street + ', ' + address.number;\n      if (address.complement) {\n        data += ' - ' + address.complement;\n      }\n      return data;\n    },\n\n    sendPrescriptionData(id, response) {\n      const data = {\n        medicines: [],\n      };\n      if (response && response.Medicamentos) {\n        response.Medicamentos.forEach((med) => {\n          data.medicines.push({ prescription_id: id, label: med.Label, dosage: med.Posologia });\n        });\n      }\n      if (response && response.MedicamentosManuais) {\n        response.MedicamentosManuais.forEach((med) => {\n          data.medicines.push({ prescription_id: id, label: med.Label, dosage: med.Posologia });\n        });\n      }\n      if (response && response.Comentario) data.comments = response.Comentario;\n      this.$emit('input', data);\n    },\n\n    openPrescription(idPrescription) {\n      const that = this;\n      this.dialog = true;\n      this.loaded = false;\n      this.listener = (event) => {\n        switch (event.data.type) {\n          case 'excluded':\n            that.$root.$emit('show-snackbar', {\n              text: this.$vuetify.lang.t('$vuetify.message.wiping_prescription'),\n              btnClose: false,\n              color: 'success',\n              timeout: 2000,\n            });\n            that.$store.dispatch('prescription/DISCARD_ACTUAL_PRESCRIPTION');\n            window.removeEventListener('message', this.listener);\n            this.startedPrescription = false;\n            that.dialog = false;\n            break;\n          case 'prescricao':\n            that.$root.$emit('show-snackbar', {\n              text: this.$vuetify.lang.t('$vuetify.message.saving_prescription'),\n              btnClose: false,\n              color: 'success',\n              timeout: 3000,\n            });\n            that.$store\n              .dispatch('prescription/FETCH_DIGITAL_FILES', { idPrescription, Documentos: event.data.Documentos })\n              .then(() => {\n                this.sendPrescriptionData(idPrescription, event.data);\n              });\n            // that.$store.dispatch('prescription/DISCARD_ACTUAL_PRESCRIPTION');\n            window.removeEventListener('message', this.listener);\n            this.startedPrescription = false;\n            break;\n          case 'cancel':\n            that.dialog = false;\n            break;\n\n          default:\n            break;\n        }\n      };\n      this.startedPrescription = true;\n      window.addEventListener('message', this.listener);\n    },\n  },\n};\n</script>\n\n<style>\n.teste {\n  width: 50px;\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$3 = undefined;
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$3 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    false,
    createInjector,
    undefined,
    undefined
  );

const PrescriptionButton = __vue_component__$3;

//

var script$2 = {
  name: 'Ehr',
  tag: 'ehr-component',

  props: {
    history: {
      type: Array,
      default: undefined,
      required: true,
    },
    patientId: {
      type: String,
      required: false,
      default: '',
    },
    source: {
      type: String,
      required: true,
    },
    userRole: {
      type: String,
      required: true,
    },
    allowShowHistory: {
      type: Boolean,
      required: false,
    },
  },
  data: () => ({
    history_limit: 10,
    loadingPatientHistory: false,
    loadingOneAppointmentPatientHistory: false,
    selectedHistory: null,
    show_history_ehr: false,
  }),

  watch: {
    history(value) {
      if (value) {
        this.loadingOneAppointmentPatientHistory = false;
      }
    },
  },

  methods: {
    deleteHistory(itemId) {
      this.$emit('deleteHistory', itemId);
    },
    formatDate(date) {
      if (!date) return null;
      return moment$1(date).format('DD/MM/YYYY');
    },
    formatLink(link) {
      let value;
      if (!link.includes('https')) {
        value = `https://${link}`;
      } else {
        value = link;
      }

      return value;
    },
    formatNameHistory(historyType) {
      const types = ['ARCHIVE', 'EXAM', 'NOTES', 'LINK', 'QUESTIONNAIRE'];

      if (types.includes(historyType)) {
        return `${this.$vuetify.lang.t('$vuetify.label.history_item_type_EVENT')}: `;
      } else {
        return `${this.$vuetify.lang.t(`$vuetify.label.history_item_type_${historyType}`)}:`;
      }
    },
    formatAppointmentReason(appointment) {
      let text;
      const { appointment_reason, source } = appointment;

      if (source === 'EMERGENCY' && appointment_reason === 'elective') {
        text = this.$vuetify.lang.t('$vuetify.label.emergency_service');
      } else if (appointment_reason === 'emergency') {
        text = this.$vuetify.lang.t('$vuetify.label.appointment_reason');
      } else {
        text = this.$vuetify.lang.t('$vuetify.label.elective');
      }

      return text;
    },
    formatSource(source) {
      const sourceName = {
        CLINIC: this.$vuetify.lang.t('$vuetify.label.source_options.clinic'),
        PATIENT: this.$vuetify.lang.t('$vuetify.label.source_options.patient'),
        EMERGENCY: this.$vuetify.lang.t('$vuetify.label.source_options.emergency'),
      };

      return sourceName[source];
    },
    getFileLink(filePath) {
      return `${process.env.VUE_APP_MEDIA_SERVER_BASE}/${filePath}`;
    },
    getHour(dt) {
      return moment$1(dt).format('HH:mm');
    },
    getPatientHistoryTitle(historyItem) {
      let description = historyItem?.description ? `- ${historyItem.description}` : '';

      if (historyItem.type === 'PRESCRIPTION' && this.source === 'OFFICE') {
        const [professional_name] = historyItem.description.split('|');
        description = `${professional_name} | ${historyItem.professional_crm}`;
      }

      return `${this.formatDate(historyItem.date)} ${description}`;
    },
    getPatientHistory(historyItem = null) {
      const role = this.userRole;

      if (['DC', 'C', 'D'].includes(role) || this.allowShowHistory) {
        if (historyItem) {
          this.loadingOneAppointmentPatientHistory = true;
        } else {
          this.loadingPatientHistory = true;
        }

        if (historyItem) {
          if (historyItem.alreadyGotInfo) {
            this.loadingOneAppointmentPatientHistory = false;
          } else {
            const data = {
              person_id: this.$route.params.id ?? this.patientId,
              id: historyItem.id,
              type: historyItem.type,
            };
            this.$emit('fetchHistory', data);
          }
        } else {
          const data = {
            person_id: this.$route.params.id ?? this.patientId,
          };

          this.$emit('fetchHistory', data);
        }
      }
    },
    hasAnyShowableData(historyItem) {
      const historyShowableFields = [
        'reason',
        'notes',
        'orientation',
        'medicines',
        'upshot',
        'cid10',
        'files',
        // diagnostic
        'remetent',
        'result_description',
        'result_file',
        'specialty',
      ];
      for (const field of historyShowableFields) {
        if (historyItem[field]) {
          return true;
        }
      }
      return false;
    },
  },
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _c(
        "v-row",
        { staticClass: "pb-2 px-1", attrs: { dense: "" } },
        [
          _vm.history && _vm.history.length > 0
            ? [
                _c(
                  "v-expansion-panels",
                  {
                    model: {
                      value: _vm.selectedHistory,
                      callback: function ($$v) {
                        _vm.selectedHistory = $$v;
                      },
                      expression: "selectedHistory",
                    },
                  },
                  _vm._l(
                    _vm.history.slice(0, _vm.history_limit),
                    function (item, index) {
                      return _c(
                        "v-expansion-panel",
                        {
                          key: index,
                          on: {
                            click: function ($event) {
                              _vm.selectedHistory !== index
                                ? _vm.getPatientHistory(item)
                                : null;
                            },
                          },
                        },
                        [
                          _c(
                            "v-expansion-panel-header",
                            { staticClass: "black--text grey lighten-2 pb-2" },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center" },
                                [
                                  ![
                                    "APPOINTMENT",
                                    "PRESCRIPTION",
                                    "MEDICAL_REFERRAL",
                                  ].includes(item.type) &&
                                  _vm.source === "CLINIC"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-center pr-6",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: { color: "error" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteHistory(
                                                    item.id
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(" delete ")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "pa-0",
                                      attrs: {
                                        cols: "11",
                                        lg: "11",
                                        md: "11",
                                        sm: "10",
                                      },
                                    },
                                    [
                                      _c("div", [
                                        _c("strong", { staticClass: "pr-1" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatNameHistory(item.type)
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.getPatientHistoryTitle(item)
                                            ) +
                                            "\n                "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "d-flex mt-3" },
                                        [
                                          item.type === "PRESCRIPTION"
                                            ? [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$vuetify.lang.t(
                                                        "$vuetify.label.prescription_description_generate",
                                                        item.provider
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            : [
                                                _c(
                                                  "strong",
                                                  { staticClass: "pr-1" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$vuetify.lang.t(
                                                            "$vuetify.label.history_type_event"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$vuetify.lang.t(
                                                        "$vuetify.label.history_item_type_" +
                                                          item.type
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ],
                                        ],
                                        2
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.source === "CLINIC" &&
                                  item.type !== "APPOINTMENT"
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass: "d-flex justify-end",
                                          attrs: { cols: "1" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "pr-10" },
                                            [
                                              _vm._t(
                                                "notify-participant-button",
                                                null,
                                                { historyId: item.id }
                                              ),
                                            ],
                                            2
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-expansion-panel-content",
                            { staticClass: "pt-2" },
                            [
                              _vm.loadingOneAppointmentPatientHistory
                                ? _c("v-progress-circular", {
                                    staticClass: "text-center",
                                    staticStyle: { "margin-left": "45%" },
                                    attrs: {
                                      size: 50,
                                      color: "primary",
                                      indeterminate: "",
                                    },
                                  })
                                : _c("div", [
                                    item.protocol
                                      ? _c(
                                          "div",
                                          { staticClass: "d-flex mb-1" },
                                          [
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$vuetify.lang.t(
                                                      "$vuetify.label.protocol"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(item.protocol) +
                                                  "\n                "
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.appointment_specialty
                                      ? _c(
                                          "div",
                                          { staticClass: "d-flex mb-1" },
                                          [
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$vuetify.lang.t(
                                                      "$vuetify.label.medical_specialty"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    item.appointment_specialty
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.start_date_time
                                      ? _c(
                                          "div",
                                          { staticClass: "d-flex mb-1" },
                                          [
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$vuetify.lang.t(
                                                      "$vuetify.label.timeToSchedule"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.getHour(
                                                      item.start_date_time
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.appointment_reason
                                      ? _c(
                                          "div",
                                          { staticClass: "d-flex mb-1" },
                                          [
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$vuetify.lang.t(
                                                      "$vuetify.label.type"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.formatAppointmentReason(
                                                      item
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.source
                                      ? _c(
                                          "div",
                                          { staticClass: "d-flex mb-1" },
                                          [
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$vuetify.lang.t(
                                                      "$vuetify.label.source"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.formatSource(
                                                      item.source
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.specialty
                                      ? _c(
                                          "div",
                                          { staticClass: "d-flex mb-1" },
                                          [
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$vuetify.lang.t(
                                                      "$vuetify.label.specialty"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(item.specialty) +
                                                  "\n                "
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.description
                                      ? _c(
                                          "div",
                                          { staticClass: "d-flex mb-1" },
                                          [
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$vuetify.lang.t(
                                                      "$vuetify.label.description"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(item.description) +
                                                  "\n                "
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.hasAnyShowableData(item)
                                      ? _c("div", [
                                          item.reason
                                            ? _c(
                                                "div",
                                                { staticClass: "d-flex mb-1" },
                                                [
                                                  _c("p", [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$vuetify.lang.t(
                                                            "$vuetify.label.reason"
                                                          )
                                                        ) + ":"
                                                      ),
                                                    ]),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.reason) +
                                                        "\n                  "
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.notes
                                            ? _c(
                                                "div",
                                                { staticClass: "d-flex mb-1" },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticStyle: {
                                                        "word-break":
                                                          "break-all",
                                                      },
                                                    },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$vuetify.lang.t(
                                                              "$vuetify.label.notes"
                                                            )
                                                          ) + ":"
                                                        ),
                                                      ]),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(item.notes) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.orientation
                                            ? _c(
                                                "div",
                                                { staticClass: "d-flex mb-1" },
                                                [
                                                  _c("p", [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$vuetify.lang.t(
                                                            "$vuetify.label.orientation"
                                                          )
                                                        ) + ":"
                                                      ),
                                                    ]),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.orientation
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.upshot
                                            ? _c(
                                                "div",
                                                { staticClass: "d-flex mb-1" },
                                                [
                                                  _c("p", [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$vuetify.lang.t(
                                                            "$vuetify.label.upshot"
                                                          )
                                                        ) + ":"
                                                      ),
                                                    ]),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.upshot.value
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.cid10
                                            ? _c(
                                                "div",
                                                { staticClass: "d-flex mb-1" },
                                                [
                                                  _c("p", [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$vuetify.lang.t(
                                                            "$vuetify.label.cid10"
                                                          )
                                                        ) + ":"
                                                      ),
                                                    ]),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.cid10.value
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.medicines &&
                                          item.medicines.length > 0
                                            ? _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "font-weight-bold",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.$vuetify.lang.t(
                                                            "$vuetify.label.medicines"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "mr-2 ml-2 mt-1",
                                                  },
                                                  [
                                                    _c("v-data-iterator", {
                                                      attrs: {
                                                        items:
                                                          item.medicines &&
                                                          item.medicines,
                                                        "hide-default-footer": true,
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (med) {
                                                              return _vm._l(
                                                                med.items,
                                                                function (
                                                                  medicine
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key: medicine.label,
                                                                    },
                                                                    [
                                                                      _c("p", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            medicine.label
                                                                          )
                                                                        ),
                                                                      ]),
                                                                    ]
                                                                  )
                                                                }
                                                              )
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.files && item.files.length > 0
                                            ? _c(
                                                "div",
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "font-weight-bold",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.$vuetify.lang.t(
                                                              "$vuetify.label.file"
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("v-data-iterator", {
                                                    attrs: {
                                                      items: item.files,
                                                      "hide-default-footer": true,
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (props) {
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "ml-2 mr-2 mt-3",
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-row",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "margin-top":
                                                                            "1px !important",
                                                                        },
                                                                    },
                                                                    _vm._l(
                                                                      props.items,
                                                                      function (
                                                                        file
                                                                      ) {
                                                                        return _c(
                                                                          "v-col",
                                                                          {
                                                                            key: file.name,
                                                                            staticClass:
                                                                              "d-flex ml-4 mt-4",
                                                                            staticStyle:
                                                                              {
                                                                                padding:
                                                                                  "0px !important",
                                                                              },
                                                                            attrs:
                                                                              {
                                                                                cols: "12",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-row",
                                                                              [
                                                                                _c(
                                                                                  "v-col",
                                                                                  {
                                                                                    staticClass:
                                                                                      "ml-2 mb-2",
                                                                                    staticStyle:
                                                                                      {
                                                                                        "text-align":
                                                                                          "left",
                                                                                        padding:
                                                                                          "0px !important",
                                                                                      },
                                                                                    attrs:
                                                                                      {
                                                                                        sm: "10",
                                                                                        md: "10",
                                                                                        lg: "10",
                                                                                        "align-self":
                                                                                          "center",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "a",
                                                                                      {
                                                                                        staticStyle:
                                                                                          {
                                                                                            "text-decoration":
                                                                                              "none",
                                                                                          },
                                                                                        attrs:
                                                                                          {
                                                                                            target:
                                                                                              "_blank",
                                                                                            download:
                                                                                              file.nameOriginal,
                                                                                            href: _vm.getFileLink(
                                                                                              file.filePath
                                                                                            ),
                                                                                            title:
                                                                                              file.nameOriginal,
                                                                                          },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "\n                                  " +
                                                                                            _vm._s(
                                                                                              file.nameOriginal
                                                                                            ) +
                                                                                            "\n                                "
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ],
                                                                          1
                                                                        )
                                                                      }
                                                                    ),
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.remetent
                                            ? _c(
                                                "div",
                                                { staticClass: "d-flex mb-1" },
                                                [
                                                  _c("p", [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$vuetify.lang.t(
                                                            "$vuetify.label.remetent"
                                                          )
                                                        ) + ":"
                                                      ),
                                                    ]),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.remetent) +
                                                        "\n                  "
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.result_description
                                            ? _c(
                                                "div",
                                                { staticClass: "d-flex mb-1" },
                                                [
                                                  _c("p", [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.type !==
                                                            "DIAGNOSTIC"
                                                            ? _vm.$vuetify.lang.t(
                                                                "$vuetify.label.description"
                                                              )
                                                            : _vm.$vuetify.lang.t(
                                                                "$vuetify.label.result_description"
                                                              )
                                                        ) + ":"
                                                      ),
                                                    ]),
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          item.result_description
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.link
                                            ? _c(
                                                "div",
                                                { staticClass: "d-flex mb-1" },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticStyle: {
                                                        "text-decoration":
                                                          "none",
                                                      },
                                                      attrs: {
                                                        target: "_blank",
                                                        href: _vm.formatLink(
                                                          item.link
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$vuetify.lang.t(
                                                              "$vuetify.label.link"
                                                            )
                                                          ) + ":"
                                                        ),
                                                      ]),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(item.link) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.result_file
                                            ? _c(
                                                "div",
                                                { staticClass: "d-flex mb-1" },
                                                [
                                                  _c(
                                                    "p",
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$vuetify.lang.t(
                                                              "$vuetify.label.one_file"
                                                            )
                                                          ) + ":"
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      Array.isArray(
                                                        item.result_file
                                                      )
                                                        ? [
                                                            _c(
                                                              "ul",
                                                              _vm._l(
                                                                item.result_file,
                                                                function (
                                                                  archive,
                                                                  i
                                                                ) {
                                                                  return _c(
                                                                    "li",
                                                                    { key: i },
                                                                    [
                                                                      _c(
                                                                        "a",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              "text-decoration":
                                                                                "none",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              target:
                                                                                "_blank",
                                                                              download:
                                                                                archive.link,
                                                                              href: _vm.getFileLink(
                                                                                archive.link
                                                                              ),
                                                                              title:
                                                                                archive.name,
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                            " +
                                                                              _vm._s(
                                                                                archive.name
                                                                              ) +
                                                                              "\n                          "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]
                                                        : [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticStyle: {
                                                                  "text-decoration":
                                                                    "none",
                                                                },
                                                                attrs: {
                                                                  target:
                                                                    "_blank",
                                                                  download:
                                                                    item.description,
                                                                  href: _vm.getFileLink(
                                                                    item.result_file
                                                                  ),
                                                                  title:
                                                                    item.description,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      item.description
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                    ],
                                                    2
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ])
                                      : _vm._e(),
                                  ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }
                  ),
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      !_vm.loadingPatientHistory &&
      _vm.history &&
      _vm.history.length > _vm.history_limit
        ? _c(
            "v-row",
            {
              staticClass: "pt-0 mt-0 pb-0 mb-0",
              attrs: { align: "center", justify: "center" },
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { plain: "", small: "", elevation: "0" },
                  on: {
                    click: function ($event) {
                      _vm.history_limit += 10;
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$vuetify.lang.t("$vuetify.label.load_more")) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    undefined,
    undefined,
    undefined
  );

const Ehr = __vue_component__$2;

const Components = {
  AcceptTerm,
  AcceptTermDialog,
  Autocomplete,
  AvatarUploader,
  Button,
  Cellphone,
  DavTimezone,
  Ehr,
  LoginForm,
  MessageSnackbar,
  Nps,
  PrescriptionButton,
  ScreeningForm,
  Telephone,
  Timezone,
  ToolbarUserControl,
  UserAvatar,
  UserPermissions,
  ValidateCurrentTime,
};

/// https://stackoverflow.com/questions/20424226/easy-way-to-set-javascript-object-multilevel-property
  const setByPath = (obj, path, value) => {
    const parts = path.split('.');
    let o = obj;
    if (parts.length > 1) {
      for (let i = 0; i < parts.length - 1; i++) {
        if (!o[parts[i]])
          o[parts[i]] = {};
        o = o[parts[i]];
      }
    }
    o[parts[parts.length - 1]] = value;
  };

  var script$1 = {
    name: 'Raw',
    tag: 'raw',
    resolve(obj, path){
      path = path.split('.');
      let current = obj;
      while(path.length) {
        if(typeof current !== 'object') return undefined;
        current = current[path.shift()];
      }
      return current;
    },
    componentUpdated (el, binding, vnode) {
      const value = vnode.data.model.value;
      const mask = vnode.data.directives.filter((item) => item.name === 'mask')[0].value;

      // eslint-disable-next-line no-unused-vars
      const masked = masker(value, mask, true, tokens);
      vnode.data.model.callback(masked);

      setByPath(vnode.context, binding.expression, masked.replace(/\W|\D/g, ''));
    },
  };

/* script */
const __vue_script__$1 = script$1;

/* template */

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    {},
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

const Raw = __vue_component__$1;

const Directives = {
  Raw,
};

/// Gabriel muito safe!!!
  var script = {
    created () {
      global['vueInstance'] = this;
    },
  };

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

const GlobalInstance = __vue_component__;

const Mixins = {
  GlobalInstance,
};

const Paginator = async (url) => {
  let response;
  const result = {
    ExclusiveStartKey: null,
    Items: [],
  };
  try {
    do {
      const init = {
        headers: {},
        method: 'GET',
      };
      if (result.ExclusiveStartKey) init.headers['x-exclusive-start-key'] = result.ExclusiveStartKey;
      response = await Fetcher(url, init);
      if (response.ok) {
        const json = await response.json();
        result.Items = result.Items.concat(json);
        result.ExclusiveStartKey = response.headers.has('x-exclusive-start-key') ? response.headers.get('x-exclusive-start-key') : null;
      } else {
        break;
      }
    } while (result.ExclusiveStartKey !== null);
  } catch (e) {
    console.log('Erro no fetch paginator', e);
  }
  return result.Items;
};

class FetchHelper {
    /**
     * Fetches all
     * @param {String} url
     * @param {Object} params
     * @param {bool} paginator
     */
    async fetchAll (url, params, paginator = false) {
        try {
            const filter = (params && params.filter) ? params.filter : { status: true };
            const fields = (params && params.fields) ? params.fields : 'id,name';
            const sort = (params && params.sort) ? params.sort : 'name';
            const endpoint = this.assembleEndPoint(url, filter, fields, sort);
            if (paginator) {
              // fetches with iteration for a huge amount of data
              return this.dispatchFetchPaginator(endpoint);
            }
            return this.dispatchFetchAll(endpoint);
        } catch (error) {
            return {
                code: 400,
                message: 'Impossível acessar o servidor. Tente novamente',
            };
        }
    }

    /**
    * Returns filter obj as string
    * @param {Object} filter
    */
    assembleFilter (filter) {
      let counter = 0;
      let strFilter = '';
      Object.entries(filter).find(([key, value], index) => {
        if (value !== '' && value !== null) {
        if (counter > 0) strFilter += ',';
        strFilter += `${key}=${value}`;
        counter++;
        }
      });
      return strFilter;
    }

    assembleEndPoint (url, filter, fields, sort) {
      let endpoint = `${url}`;
      if (filter) {
        endpoint += `?filter=${this.assembleFilter(filter)}`;
      }
      if (fields) {
        endpoint += `&fields=${fields}`;
      }
      if (sort) {
        endpoint += `&sort=${sort}`;
      }
      return endpoint;
    }

    /**
     * Dispatches fetch all with pagination for huge amount of data
     * @param {String} url
     */
    async dispatchFetchPaginator (url) {
      return Paginator(url);
    }

    /**
     * Dispaches a fetch all
     * @param {String} url
     */
    async dispatchFetchAll (url) {
        const fetchResponse = await Fetcher(url);
        const jsonResponse = await fetchResponse.json();
        return jsonResponse || [];
    }
}
// @TODO: Bring other types of fetch to here as well;

const audio = 'data:audio/mp3;base64,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';

/**
 * @deprecated
*/
function beepSound () {
  console.warn('beepSound fuction is deprected, please use NOTIFY_SOUND.play() instead');

  const snd2 = new Audio(audio);
  snd2.play();
}

const notifySound = 'data:audio/mp3;base64,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';

const browserSound = {
  play: function (soundName = 'BEEP') {
    return (new Audio(this.SOUNDS[soundName])).play();
  },
  SOUNDS: {
    BEEP: audio,
    NOTIFY: notifySound,
  },
};

// import PluginDialogConfirm from './components/DialogConfirm';

// Declara a função de instalação executada pelo Vue.use()
const install = (Vue, options) => {
  if (install.installed) return;
  install.installed = true;

  /// Install Components
  Object.entries(Components).forEach(([name, component]) => {
      const tag = ('tag' in component) ? component.tag : name;
      Vue.component(tag, component);
  });

  /// Install Directives
  Object.entries(Directives).forEach(([name, directive]) => {
    const tag = ('tag' in directive) ? directive.tag : name;
    Vue.directive(tag, directive);
  });

  /// Install Mixins
  Object.values(Mixins).forEach(mixin => {
    Vue.mixin(mixin);
  });
};

// Cria a definição do módulo para Vue.use()
const PrimeIT = {
    install,
};

// Auto-instala quando o Vue é encontrado (no navegador via <script>)
let GlobalVue = null;
if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue;
}
if (GlobalVue) GlobalVue.use(PrimeIT);

export { CommonRouter, OldCommonSecurity as CommonSecurity, CommonState, FetchHelper, Fetcher, beepSound, browserSound, PrimeIT as default };
